/* eslint-disable default-case */
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import "emoji-mart/css/emoji-mart.css";
import VIDEO from "../build/images/video.jpg";
import AUDIO from "../build/images/audio.svg";
import FOTO from "../build/images/foto.svg";
import DOC from "../build/images/doc.svg";
import FLAGBR from "../build/images/flag-br.png";
import { ReactComponent as IconMail } from "../build/images/iconmailsmall.svg";
import { ReactComponent as RepeatIcon } from "../build/images/repeat.svg";
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { ReactComponent as MailIcon } from "../build/images/mail.svg";
import { ReactComponent as DangerIcon } from "../build/images/alertmodalinfo.svg";
import { ReactComponent as IconDropFile } from "../build/images/drop-icon-v2.svg";
import { ReactComponent as MESSAGEICON } from "../build/images/attendanceIcons/message-search.svg";
import { ReactComponent as IconTabulator } from "../build/images/attendanceIcons/task.svg";

import * as htmlToImage from "html-to-image";
import toast, { Toaster as ToasterSecond } from "react-hot-toast";
import { nc2Service } from "../actions/nc2service";
import {
  senfFileQuickAsw,
  RespostasRapidasida,
  CloseChat,
  addMessage,
  InsertUpload,
  SendNextAtd,
  createStatusAgent,
  CloseAttendant,
  ShowVisibleDetailsAtd,
  ShowVisibleNextAtd,
  MarkMessage,
  InsertAnotations,
  refreshReturnAtd,
  editAtendimentoAgent,
  addAtendimento,
  GetHistory,
  GetMarkstar,
  markstarRedux,
  CallButtonAccept,
  MuteStatus,
  PauseStatus,
  ProximoChatSimult,
  GetFileShared,
  GetAnotations,
  InterationNotifier,
  clearQtdMsg,
  TransferCall,
  editMsg,
  RemoveConference,
  AddConference,
  RequestActiveConfSocketVoz,
  ReturningCallback,
  returnListCallQueue,
  clearConferenceExt,
  GetInteractionsContact,
  InteracoesContactNumberPeer,
  UpdateRgBlockReturn,
  addInteractionIngDesk,
  changeLinkCopied,
  changeInfoMail,
  byeAcwCall,
  addMessageHeader,
  deleteMessageHeader,
  GetDetailsContacts,
  RequestActiveCallSocketVoz,
  RequestActiveCall,
  ShowInfoDisplay,
  AddNumberContact,
  GetPhoneMidia,
  RemoveRemoteNotifier,
  InsertActivityATT,
  tratarAfterCallWork,
  uploadFileSideContent,
  dbfileSize,
  addCcontactIdsToQuarentine,
  activeSearchText,
  ChangeLastCdrClicked,
} from "../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "moment";
import {
  InviteMessages,
  sendtypinwebsocket,
  SendSocketIvrCall,
  InviteChats,
  SendSocketTransferCallIn,
  ChangeAtendimento,
  dtmf,
  SendFileForward,
  SendReqAfterCallWork,
  SendReadingMsg,
  SendFile,
  sendToQuarentineZone,
  EhNumeroInternacional,
  formatarNomeDoContato,
} from "../actions/websocket";
import TimeCounter from "../containers/TimeCounter";
import TimeCounterAudio from "../containers/TimeCounterAudio";
import TimeCounterMinute from "../containers/TimeCounterMinute";
import $ from "jquery";
import AVI from "../build/images/avi-file.png";
import JPG from "../build/images/jpg-file.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import Select from "react-select";
//import WHATSAPPICON from "../build/images/report/whatsapp_icon.png";
import WHATSAPPICON from "../build/images/whatsapp_new3.svg";
import WHATSAPPVOZICON from "../build/images/whatsapp_voice.svg";
// import WHATSAPPICON from "../build/images/whatsapp-icon.svg";
// import WHATSAPPICON from "../build/images/icons-channels/whatsapp2-large.svg";
import { ReactComponent as WHATSAPPSVG } from "../build/images/icons-channels/whatsapp2-large.svg";
import WHATSAPP from "../build/images/whatsapp_icon.svg";
import DEFAULT from "../build/images/default.png";
import FACEBOOKICON from "../build/images/facebook_new.svg";
import { ReactComponent as FACEBOOKSVG } from "../build/images/facebook_new.svg";
import { ReactComponent as SMSICON } from "../build/images/sms-new.svg";
import TELEGRANICON from "../build/images/telegram-new.svg";
import { ReactComponent as TELEGRAMSVG } from "../build/images/telegram-new.svg";
import FACEBOOK from "../build/images/facebook_icon.svg";
import WEBCHATICON from "../build/images/webchat-new.svg";
import { ReactComponent as WEBCHATSVG } from "../build/images/webchat-new.svg";
import VOZICON from "../build/images/callchat-new.svg";
import INSTAGRAMICON from "../build/images/instagram_new.svg";
import { ReactComponent as INSTAGRAMSVG } from "../build/images/instagram_new.svg";
import GOOGLEGBMICON from "../build/images/googlegbm-new.svg";
import TEAMSICON from "../build/images/channels/teamsMedium.svg";
import { ReactComponent as GBMSVG } from "../build/images/googlegbm-new.svg";
import TWITERICON from "../build/images/twitter-new.svg";
import EMAILICON from "../build/images/email-new.svg";
import { ReactComponent as EMAILSVG } from "../build/images/email-new.svg";
import LINKEDINICON from "../build/images/linkedin-new.svg";
import SUCESS from "../build/images/add-note-success.png";
import LOADING from "../build/images/typing.gif";
import { Popover, Topover, Tooltippy, TippyPopper2 } from "../actions/Tippy";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/themes/light.css";
import "../build/css/attendance.css";
import ChatSimultComponent from "./ChatSimult";
import latinize from "latinize";
import { ReactComponent as ICONEMOJI } from "../build/images/icon_emoji.svg";
import MessageContainer from "./../components/chat-section/MessageContainer";
// import MessageContainerImg from "../components/chat-section/MessageContainerImg";
import MessageContainerPDF from "../components/chat-section/MessageContainerPDF";
import MessageContainerDefault from "../components/chat-section/MessageContainerDefault";
import MessageContainerDocs from "../components/chat-section/MessageContainerDocs";
// import MessageContainerAudio from "./../components/chat-section/MessageContainerAudio";
import MessageContainerMedia from "./../components/chat-section/MessageContainerMedia";
// import MessageContainerVideo from "../components/chat-section/MessageContainerVideo";
import SearchBox from "../components/chat-section/SearchBox";
import StatusAgentStatus from "../components/chat-section/StatusAgent-status";
import MicroModal from "micromodal";
import ForwardModal from "../components/modals/ForwardModal";
import { ReactComponent as ForwardIconSVG } from "../build/images/forward.svg";
import { ReactComponent as DangerIconSVG } from "../build/images/danger.svg";
import MessageContainerLocation from "../components/chat-section/MessageContainerLocation";
import { Picker } from "emoji-mart";
import MicRecorder from "mic-recorder-to-mp3";
import AgentButton from "../components/AgentButton";
import AddChannelCall from "../components/AddChannelCall";
import PHONE from "../build/images/callchat-new.svg";
import Tabulator from "../components/Tabulator";
import QuickAnswer from "./QuickAnswer";
import CryptoJS from "crypto-js";
import MailBox from "./MailBox";
import MailContainer from "../components/mail-section/MailContainer";
import Checkbox from "../components/manager-section/CheckboxIng/CheckboxIng";
import InteractionComment from "../components/InteractionComment/InteractionComment";
import InteractionChat from "../components/InteractionChat/InteractionChat";
import ReactHtmlParser from "react-html-parser";
import Typography from "../components/Typography";
// import AttachTypeFiles from "../components/AttachTypeFiles/AttachTypeFiles";
import Audio from "../components/Audio/Audio";
import unicodeToChar from "../actions/formatUnicode";
import urlIngWeb from "../actions/urlIngWeb";
import { handleFiles } from "../actions/files";
import UserPhoto from "../components/UserPhoto/userphoto";
import TextSlide from "../components/TextSlide/TextSlide";

import { ReactComponent as IconClips } from "../build/images/chatIcons/Clips.svg";
import { ReactComponent as Tick } from "../build/images/chatIcons/double-tick.svg";
import { ReactComponent as ErrorCircle } from "../build/images/chatIcons/info-circle.svg";
import { ReactComponent as Search } from "../build/images/teams/search-normal.svg";
import { ReactComponent as HappyRating } from "../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../build/images/icons-rating/star-slash.svg";
import { ReactComponent as IconMessagePreset } from "../build/images/message-text.svg";
import { ReactComponent as IconUploadFile } from "../build/images/link-2.svg";
import { ReactComponent as IconAudio } from "../build/images/microphone-2.svg";
import { ReactComponent as IconCallEnd } from "../build/images/attendanceIcons/call-remove.svg";
// import { ReactComponent as IconAudio } from "../build/images/attendanceIcons/call-calling.svg";
import { ReactComponent as IconCallPause } from "../build/images/attendanceIcons/call-minus.svg";
import { ReactComponent as IconTransferBot } from "../build/images/attendanceIcons/call-outgoing.svg";
import { ReactComponent as IconChannelAdd } from "../build/images/attendanceIcons/call-add.svg";
import { ReactComponent as IconVideoChat } from "../build/images/attendanceIcons/video.svg";
import { ReactComponent as IconAnottationAdd } from "../build/images/attendanceIcons/edit.svg";

import { ReactComponent as IconCRMOpen } from "../build/images/attendanceIcons/document-text.svg";
import { ReactComponent as IconEmail } from "../build/images/attendanceIcons/sms.svg";
import { ReactComponent as IconSearchChat } from "../build/images/attendanceIcons/search-normal.svg";
import { ReactComponent as IconMore } from "../build/images/attendanceIcons/more.svg";
import { ReactComponent as IconSend } from "../build/images/send-2.svg";
import { ReactComponent as IconMoreHeader } from "../build/images/attendanceIcons/warning-2.svg";
import { ReactComponent as IconDetalhes } from "../build/images/attendanceIcons/icon-detalhes.svg";
import { ReactComponent as IconPesquisa } from "../build/images/attendanceIcons/icon-pesquisa.svg";
import { ReactComponent as IconCampanha } from "../build/images/attendanceIcons/icon-campanha.svg";
import { ReactComponent as IconAjuda } from "../build/images/attendanceIcons/icon-ajuda.svg";
import { ReactComponent as IconQuarantine } from "../build/images/attendanceIcons/zona-quarentena.svg";

import { openSideContent } from "../actions/openSideContent";
import { sideContentAttendanceSelected } from "../actions/sideContentAttendanceSelected";
import MoreOptionsPopover from "../components/MoreOptionsPopover";
import messageFromHelpSideContent from "../reducers/messageFromHelpSideContent";
import { urlToFile } from "../utils/urlToFile";
import { delay } from "../utils/delay";
import { changeIsLoadingSideContent } from "../actions/changeIsLoadingSideContent";
import { replacePlaceholders } from "../utils/replacePlaceholders";
import QuarantineModal from "../components/modals/NewModals/QuarantineModal/QuarantineModal";
import EndCallModal from "../components/modals/NewModals/EndCallModal";
import StageAreaOfFiles from "../components/StageAreaOfFiles";
import { Box, CircularProgress, Tab } from "@mui/material";
import convertUnicodeEmoji from "../actions/convertUnicodeEmoji";
import { saudacaoPorHorario } from "../utils/saudacaoPorHorario";
import PreviousMessages from "./PreviousMessages";
import { generateUniqueMessageId } from "../utils/generateUniqueMessageId";
import { compareAsc, parse } from "date-fns";
import { tabulationHandler } from "../utils/tabulationHandler";
import TabulationModal from "../components/modals/NewModals/TabulationModal";

const { connection_platform } = require("../services/api");
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

MicroModal.init();

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
port = localStorage.getItem("port");

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const mimetypesPrincipal = [
  "image",
  "voice",
  "document",
  "audio",
  "txt",
  "video",
];

var typingTimer;
var doneTypingInterval = 5000;
var digitando = 0;
var mensagensnaolidas = [];
var outroatendimento = [];
var mensagemenviada = [];
var mensagemretorno = [];
var theaterStart = 20;
var AudioFile = [];
var disabledAudio = false;
var contador = 0;
var classe = "active-chats__tab";
var options = [];
var textMessage = [];
var checkAtd = false;
var arrayVariables = [];
var structAcwCall = [];

const dot = (color = "#ccc") => ({
  alignItems: "center",
  display: "flex",

  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      color: "#222020",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  input: (styles) => ({ ...styles, ...dot() }),
  placeholder: (styles) => ({ ...styles, ...dot() }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
};

const { meses, emoji } = require("../services/data");

async function createFile(url) {
  let response = await fetch(url);
  let data = await response.blob();
  let metadata = {
    type: "image/jpeg",
  };
  let file = new File([data], "test.jpg", metadata);
  return file;
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const mapStateToProps = (state) => {
  return {
    Interaction: state.interactioningdesk,
    Typing: state.typing,
    RespostasRapidas: state.respostas,
    UserGroups: state.groups,
    IvrCallTransfer: state.ivrcalltransfer,
    Messages: state.messages,
    MessagesHeader: state.messagesheader,
    InfoUsers: state.informationusers,
    ContactId: state.atendimento,
    IPCurrent: state.ipcurrent,
    DisplayDetails: state.displaydetailsatd,
    CriticidadesAnotacoes: state.criticalitys,
    StatusAgent: state.status,
    DisplayNextAtd: state.displaynextatd,
    AtdSimult: state.atdsimult,
    ChatSimult: state.chatsimult,
    Chat: state.chatinternal,
    outservices: state.outservices,
    servicegroup: state.servicegroup,
    ExternConf: state.conferencia,
    PermissionRouter: state.routergroups,
    listCallQueue: state.listcallqueue,
    MailMessage: state.messagemail,
    Connectionsapi: state.connectionsapi,
    Tabulator: state.tabulator,
    ServiceURL: state.serviceurl,
    Mimetypes: state.mimetypes,
    ActiveHeader: state.activeheader,
    RegisterNotifier: state.registernotifier,
    NpsDetails: state.npsdetails,
    IsSideContentOpen: state.isSideContentOpen,
    SideContentAttendanceSelected: state.sideContentAttendanceSelected,
    messageFromHelpSideContent: state.messageFromHelpSideContent,
    ingFaqConditions: state.ingFaqConditions,
    tabulatedInfos: state.tabulatedInfos,
  };
};

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

const mapDispatchToProps = (dispatch) => ({
  AddCcontactIdsToQuarentine: (contactId) => {
    dispatch(addCcontactIdsToQuarentine(contactId));
  },
  sendImageAsw: (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    options,
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "enviado",
          false,
          dia,
          "",
          "",
          "",
          "0",
          "",
          options,
          Moment().format("YYYY"),
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    }
  },
  ReturningCallbackIn: (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount,
    status,
  ) => {
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
    )(dispatch);
    if (status != "2") {
      dispatch(
        returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1), "você"),
      );
    }
  },
  ReturningCallbackIn2: (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount,
  ) => {
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
    )(dispatch);
    dispatch(returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1)));
  },
  RequestActiveConfSocketVoz: (
    outband,
    infouser,
    trunk,
    mediaid,
    chamado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    callback_count,
    tech,
    idgrupo_rota,
    idgrupo_transb,
    ipcurrent,
    cdrid,
    rotaencontrada,
    ContactId,
  ) => {
    dispatch(
      RequestActiveConfSocketVoz(
        outband,
        infouser,
        trunk,
        mediaid,
        chamado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        callback_count,
        tech,
        idgrupo_rota,
        idgrupo_transb,
        ipcurrent,
        cdrid,
        rotaencontrada,
        ContactId,
      ),
    );
  },
  AddExternalConference: (
    ContactId,
    atendimento,
    line,
    contactatd,
    serviceatd,
  ) => {
    dispatch(
      AddConference(ContactId, atendimento, line, contactatd, serviceatd),
    );
  },
  actionByeAcw: (cdrid) => {
    dispatch(byeAcwCall(cdrid));
  },
  RemoveExternalConference: (
    ContactId,
    atendimento,
    line,
    contactatd,
    serviceatd,
  ) => {
    dispatch(
      RemoveConference(ContactId, atendimento, line, contactatd, serviceatd),
    );
  },
  sendFileAswSocket: (InfoUsers, ContactId, path, texto, makeid) => {
    if (path != "") {
      senfFileQuickAsw(InfoUsers, ContactId, path, texto, makeid);
    }
  },
  InviteMessage: (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    msgsocket,
    url,
    hsm,
    paramshsm,
    idreplyop,
    checkparam,
    checkparam2,
    variablesRaw,
    options,
  ) => {
    let variables = variablesRaw;
    try {
      if (Array.isArray(variables) && variables.length > 0) {
        variables = variables.map((variable) => {
          const hasValue =
            typeof variable === "object" &&
            "value" in variable &&
            Boolean(variable.value) &&
            typeof variable.value === "string";
          if (hasValue) {
            let cleanValue = variable.value;
            cleanValue = cleanValue.replace(/\t/g, "    ");
            cleanValue = cleanValue.replace(/ {5,}/g, "    ");
            return {
              ...variable,
              value: cleanValue,
            };
          }
          return variable;
        });
      }
    } catch (error) {
      console.log("InviteMessage Error: ", error);
    }

    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    textMessage[contactid.idatendimento] = "";
    let msgFormatted = message;
    if (hsm) {
      msgFormatted = msgFormatted.replace(/<+/g, "*");
      msgFormatted = msgFormatted.replace(/>+/g, "*");
    }
    msgFormatted = msgFormatted.replace(/\t/g, "    ");
    if (message != "" && typemsg === "0") {
      dispatch(
        addMessage(
          makeid,
          msgFormatted,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "enviado",
          false,
          dia,
          "",
          "",
          "",
          "0",
          idreplyop,
          null,
          null,
          Moment().format("YYYY"),
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
        InviteMessages(
          infousers,
          contactid,
          msgsocket,
          author,
          makeid,
          hsm,
          paramshsm,
          idreplyop,
          checkparam,
          checkparam2,
          variables,
        ),
      );
    } else if (message != "" && typemsg != "0") {
      dispatch(
        addMessage(
          makeid,
          typemsg === "2" ? msgFormatted : url,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "enviado",
          false,
          dia,
          "",
          "",
          "",
          "0",
          idreplyop,
          options,
          null,
          Moment().format("YYYY"),
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );

      if (hsm) {
        InviteMessages(
          infousers,
          contactid,
          msgsocket,
          author,
          makeid,
          hsm,
          paramshsm,
          idreplyop,
          checkparam,
          checkparam2,
          variables,
        );
      } else {
        SendFileForward(infousers, contactid, msgsocket, makeid);
      }
    }
  },
  InviteMessagesNew: (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    msgsocket,
    url,
    hsm,
    paramshsm,
    idreplyop,
    checkparam,
    checkparam2,
    variablesRaw,
  ) => {
    let variables = variablesRaw;
    try {
      if (Array.isArray(variables) && variables.length > 0) {
        variables = variables.map((variable) => {
          const hasValue =
            typeof variable === "object" &&
            "value" in variable &&
            Boolean(variable.value) &&
            typeof variable.value === "string";
          if (hasValue) {
            let cleanValue = variable.value;
            cleanValue = cleanValue.replace(/\t/g, "    ");
            cleanValue = cleanValue.replace(/ {5,}/g, "    ");
            return {
              ...variable,
              value: cleanValue,
            };
          }
          return variable;
        });
      }
    } catch (error) {
      console.log("InviteMessage Error: ", error);
    }
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    textMessage[contactid.idatendimento] = "";
    InviteMessages(
      infousers,
      contactid,
      msgsocket,
      author,
      makeid,
      hsm,
      paramshsm,
      idreplyop,
      checkparam,
      checkparam2,
      variables,
    );
  },
  ByeChat: (simult, Chat, ChatSimult) => {
    dispatch(CloseChat(simult));
    dispatch(ProximoChatSimult(simult, Chat, ChatSimult));
  },
  tratarAfterCallWork: (tmoutacw, idatendimento, finalizar) => {
    dispatch(tratarAfterCallWork(tmoutacw, idatendimento, finalizar));
  },
  sendtyping: (typing, InfoUsers, ContactId) => {
    if (digitando === 0) {
      sendtypinwebsocket(1, InfoUsers, ContactId);
      digitando = 1;
      clearTimeout(typingTimer);
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    } else {
      doneTypingInterval = 5000;
    }

    function doneTyping() {
      digitando = 0;
      sendtypinwebsocket(0, InfoUsers, ContactId);
    }
  },
  editMsg: (msg, id) => {
    dispatch(editMsg(msg, id));
  },
  editAtendimentoAgent: (id) => {
    dispatch(editAtendimentoAgent(id));
  },
  TransferCall: (user) => {
    dispatch(TransferCall(user));
  },
  ShowVisibleDetailsAtdIns: (post) => {
    dispatch(ShowVisibleDetailsAtd(post));
  },
  changeInfoMail: (post, idatendimento) => {
    dispatch(changeInfoMail(idatendimento, post, post));
  },
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
  UploadFile: (data, InfoUsers, ContactId, caption, makeid, size, replyid) => {
    dispatch(
      InsertUpload(data, InfoUsers, ContactId, caption, makeid, size, replyid),
    );
  },
  ProximoAtendimento: (
    proximoatd,
    novamensagem,
    contactid,
    infousers,
    ipcurrent,
    atdsimult,
  ) => {
    SendNextAtd(
      proximoatd,
      novamensagem,
      contactid,
      infousers,
      ipcurrent,
      atdsimult,
    )(dispatch);
  },
  ByeAttendant: (contactid, infousers, reason) => {
    dispatch(CloseAttendant(contactid, infousers, reason));
  },
  SetMute: (boolmute) => {
    dispatch(MuteStatus(boolmute));
  },
  SetHold: (boolmute) => {
    dispatch(PauseStatus(boolmute));
  },
  MarkStar: (markstar, infouser, verificarfavorito, favorite, cdrid) => {
    MarkMessage(
      markstar,
      infouser,
      verificarfavorito,
      favorite,
      cdrid,
    )(dispatch);
    dispatch(markstarRedux(markstar, favorite, cdrid));
  },
  RespostasRapidasida: (userid) => {
    RespostasRapidasida(userid)(dispatch);
  },
  refreshReturnAtd: (id, telefone) => {
    dispatch(refreshReturnAtd(id, telefone));
  },
  InsertAnotationsIn: (idcdr, criticidade, comentario, userid, serviceatd) => {
    InsertAnotations(
      idcdr,
      criticidade,
      comentario,
      userid,
      serviceatd,
    )(dispatch);
  },
  AlterStatus: (data, reason) => {
    dispatch(
      createStatusAgent(data, reason, Moment().format("DD/MM/YYYY HH:mm:ss")),
    );
  },
  InviteChat: (
    makeid,
    message,
    author,
    infousers,
    chat,
    typemsg,
    msgsocket,
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          chat.iduserout,
          typemsg,
          "Enviando",
          false,
          dia,
          "",
          "",
          "",
          "0",
          undefined,
          "",
          "",
          Moment().format("YYYY"),
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
        InviteChats(infousers, chat.iduserout, msgsocket, author, makeid),
      );
    }
  },
  clearConference: (atendimento) => {
    dispatch(clearConferenceExt(atendimento));
  },
  ChangeAtdSimult: (
    infouser,
    atendimento,
    atdsimultaneo,
    ipcurrent,
    status,
  ) => {
    //
    dispatch(
      addAtendimento(
        atendimento.idatendimento,
        atendimento.cliente,
        atendimento.telefone,
        atendimento.servico,
        atendimento.datatimeatd,
        atendimento.criticidade,
        atendimento.menubot,
        atendimento.subservico,
        atendimento.serviceatd,
        atendimento.recuperation,
        atendimento.time,
        atendimento.direction,
        atendimento.idmidia,
        atendimento.timecomplete,
        atendimento.statusagent,
        atendimento.line,
        atendimento.queueid,
        atendimento.serverid,
        atendimento.qtdmessage,
        atendimento.pathfile,
        atendimento.mcdu,
        atendimento.nomesubservico,
        atendimento.infoinitcall,
        atendimento.nomecliente,
        atendimento.protocolo,
        atendimento.idsubservico,
        atendimento.acw,
        atendimento.isDialNc2,
        atendimento.arrayChannels,
        atendimento.caseId,
        atendimento.statusatd,
        atendimento.score_class,
        atendimento.score_value,
        atendimento.nps_call,
        atendimento.isTabulation,
      ),
      InteracoesContactNumberPeer(atendimento.telefone, infouser.idgroup),
      UpdateRgBlockReturn(infouser, status),
      ChangeAtendimento(
        infouser,
        atendimento,
        atdsimultaneo,
        ipcurrent,
        status,
      ),
      clearQtdMsg(atdsimultaneo.idatendimento),
    );
    SendReadingMsg(atendimento, infouser);

    dispatch(clearQtdMsg(atendimento.idatendimento));
    dispatch(GetHistory([]));
    dispatch(GetInteractionsContact([]));
    dispatch(GetMarkstar([]));
    dispatch(GetFileShared([]));
    dispatch(GetAnotations([]));
  },
  InterationNotifier: (texto, status) => {
    dispatch(InterationNotifier(texto, status));
  },
  actionScheduleNc2: () => {
    nc2Service.nc2ObterResultados(dispatch);
    nc2Service.nc2ObterTelefones(dispatch);
    MicroModal.show("modal__encerrar-atendimento");
  },
  addIteractionIngDesk: (jsonIngDesk) => {
    dispatch(addInteractionIngDesk(jsonIngDesk));
  },
  changeCopiedLinkAnswer: () => {
    dispatch(changeLinkCopied());
  },
  addMessageHeader: (contactid, header) => {
    dispatch(addMessageHeader(contactid.idatendimento, header));
  },
  deleteMessageHeader: (contactid) => {
    dispatch(deleteMessageHeader(contactid.telefone));
  },
  RemoveNotifier: (post) => {
    dispatch(RemoveRemoteNotifier(post));
  },
  GetDetailsContacts: (value, data, datacontact) => {
    dispatch(GetDetailsContacts(value, data, datacontact));
  },
  RequestActiveCallSocketVoz: (
    outband,
    infouser,
    trunk,
    mediaid,
    chamado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    callback_count,
    tech,
    idgrupo_rota,
    idgrupo_transb,
    ipcurrent,
    cdrid,
    rotaencontrada,
  ) => {
    dispatch(
      RequestActiveCallSocketVoz(
        outband,
        infouser,
        trunk,
        mediaid,
        chamado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        callback_count,
        tech,
        idgrupo_rota,
        idgrupo_transb,
        ipcurrent,
        cdrid,
        rotaencontrada,
      ),
    );
  },
  RequestActiveCall: (
    outband,
    infouser,
    trunk,
    mediaid,
    calledDigitado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    cbackcount,
    idgrupo_transb,
    cdrold,
  ) => {
    dispatch(
      RequestActiveCall(
        outband,
        infouser,
        trunk,
        mediaid,
        calledDigitado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        cbackcount,
        idgrupo_transb,
        cdrold,
      ),
    );
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
  },
  AddNumberContact: (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
  },
  OpenSideContent: () => {
    dispatch(openSideContent());
  },
  SideContentAttendanceSelectedAction: (selected) => {
    dispatch(sideContentAttendanceSelected(selected));
  },
  SendFileFromPath: (InfoUsers, ContactId, path, caption, makeid, size) => {
    SendFile(InfoUsers, ContactId, path, caption, makeid);
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    let tamanhoimg = dbfileSize(size);

    dispatch(
      addMessage(
        makeid,
        " ~¿" + caption + "~¿" + path + "~¿" + tamanhoimg,
        "Me",
        time,
        ContactId.idatendimento,
        "1",
        "enviado",
        false,
        dia,
        "",
        "",
        "",
        "0",
        undefined,
        "",
        "",
        Moment().format("YYYY"),
        Moment().format("DD/MM/YYYY HH:mm:ss"),
      ),
    );
  },
  ChangeSideContentLoading: (isLoading) => {
    dispatch(changeIsLoadingSideContent(isLoading));
  },
  ChangeSearchText: (value) => {
    dispatch(activeSearchText(value));
  },
  ChangeLastCdrClickedAction: (cdr, lastCdrClicked) => {
    dispatch(ChangeLastCdrClicked(cdr, lastCdrClicked));
  },
});

class Attendance extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileasw: [],
      arrowterm: 0,
      activeconsulta: false,
      transfers: [],
      visible: "",
      atdsimultsec: [],
      searchText: "",
      groups: [],
      respostas: [],
      respostasinicial: [],
      selectedFile: null,
      loaded: 0,
      active: [],
      checked: false,
      DescAnotacoes: [],
      criticidadeSelec: "",
      iconeCriticidade: "",
      idCriticidadeSelec: 0,
      SaveSucess2: false,
      showbuttondetails: " active",
      scroller: 0,
      scrollerMail: 0,
      auxIvr: [],
      atdsimult: [],
      messages: [],
      focus: false,
      auxIvrRadio: 0,
      typing: [],
      mute: true,
      pause: true,
      chatsimult: [],
      contactid: [],
      servicegroup: [],
      outservices: [],
      record: false,
      timerecording: -1,
      forwardMsgList: [],
      forwardContactList: [],
      isRecording: false,
      blobURL: "",
      isBlocked: false,
      previewImage: true,
      isHSM: false,
      paramsHSM: [],
      showreplyop: false,
      activedtmf: false,
      activeCrm: false,
      messageQuickAnswer: "",
      variableQuickAnwser: [],
      isVisibleBox: true,
      searchUra: "",
      searchQuickMsg: "",
      lengthLast: 0,
      isDragging: false,
      filesInStage: [],
      isStartingRecord: false,
      mensagensNaoLidasDocliente: [],
      isFirstsLoad: true,
      showreplyopNew: {},
      buttonQuickAnswer: false,
      respostasinicial: [],
      tabulationModalInfos: {
        isOpen: false,
        data: null,
      },
    };
    this.dragCounter = 0;
    this.handleClick = this.handleClick.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
    this.scrollDownChat = this.scrollDownChat.bind(this);
    this.handleselectedFile = this.handleselectedFile.bind(this);
    this.filterList = this.filterList.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.ChangeAtd = this.ChangeAtd.bind(this);
    //this.onInput = this.onInput.bind(this);
    this.node = null;
    this.handleClickOnMoreOptionsItem =
      this.handleClickOnMoreOptionsItem.bind(this);
    this.sendOnlyFile = this.sendOnlyFile.bind(this);
    this.sendOnlyText = this.sendOnlyText.bind(this);
    this.putMessageFromHelpSideContentOnChatMessage =
      this.putMessageFromHelpSideContentOnChatMessage.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  // handle SearchBox Change
  handleSearchChange = ({ searchText, arrowterm }) => {
    this.setState({
      searchText,
      arrowterm,
    });
  };

  ChangeAtd(infouser, atendimento, atdsimultaneo, ipcurrent, status) {
    let atendimentoid = atendimento.idatendimento;
    mensagensnaolidas[atendimento.idatendimento] = false;
    let contactid = this.state.contactid;

    let nov = [];

    this.props.clearConference(atendimento);

    if (!this.state.mute) {
      nov[contactid.idatendimento] = this.state.mute;
    }
    if (!this.state.pause) {
      nov[contactid.idatendimento] = this.state.mute;
    }

    this.props.ChangeAtdSimult(
      infouser,
      atendimento,
      atdsimultaneo,
      ipcurrent,
      status,
    );
    if (atendimento.direction == "2" && atendimento.line == "0") {
      if (atendimento.acw === true)
        this.props.AlterStatus(
          "Aftercallwork",
          "S.(" + atendimento.telefone + ")",
        );
      else
        this.props.AlterStatus(
          "Atendimento",
          "S.(" + atendimento.telefone + ")",
        );
    } else if (atendimento.direction == "1" && atendimento.line == "0") {
      if (atendimento.acw === true)
        this.props.AlterStatus(
          "Aftercallwork",
          "S.(" + atendimento.telefone + ")",
        );
      else
        this.props.AlterStatus(
          "Atendimento",
          "E.(" + atendimento.telefone + ")",
        );
    } else if (atendimento.line != "0" && atendimento.direction == "2") {
      if (atendimento.acw === true)
        this.props.AlterStatus(
          "Aftercallwork",
          "S.(" + atendimento.telefone + ")",
        );
      else
        this.props.AlterStatus("Ligação", "S.(" + atendimento.telefone + ")");
    } else if (atendimento.line != "0" && atendimento.direction == "1") {
      if (atendimento.acw === true)
        this.props.AlterStatus(
          "Aftercallwork",
          "S.(" + atendimento.telefone + ")",
        );
      else
        this.props.AlterStatus("Ligação", "E.(" + atendimento.telefone + ")");
    }
    this.setState({ buttonMore: false });
    // document.getElementById("chat-message").innerText = atendimento.msg;
    if (textMessage[atendimento.idatendimento] != undefined) {
      document.getElementById("chat-message").innerText =
        textMessage[atendimento.idatendimento];
    } else {
      document.getElementById("chat-message").innerText = "";
    }

    this.SendInfoInteractionIngDesk(atendimento);
    this.setState({ editableQuickAnswer: false });
    document.getElementById("chat-message").contentEditable = true;
  }

  filterList(event, respostas) {
    // var updatedList = respostas;
    // updatedList = updatedList.filter(function (item) {
    //   let asw = item.qck_asw_keyword;
    //   let filtro = event.target.value;

    //   //let er = /[^a-z0-9]/gi;
    //   //filtro = filtro.replace(er, "");
    //   //let resultado = asw.search(filtro);

    //   return asw.toLowerCase().search(filtro.toLowerCase()) != -1;
    // });
    this.setState({
      // respostas: updatedList,
      searchQuickMsg: event.target.value,
    });
  }

  scrollDown() {
    try {
      const { containers } = this.refs;
      if (this.state.scroller != containers.scrollHeight) {
        containers.scrollTop = containers.scrollHeight;
        this.state.scroller = containers.scrollHeight;
      }
      this.limparMensagensNaoLidasDoCliente();
    } catch (error) {}
  }

  scrollDownMail() {
    const { containers_mails } = this.refs;
    if (containers_mails) {
      if (this.state.scrollerMail != containers_mails.scrollHeight) {
        containers_mails.scrollTop = containers_mails.scrollHeight;
        this.state.scrollerMail = containers_mails.scrollHeight;
      }
    }
  }

  scrollDownChat(id) {
    const containerminichat = document.getElementById("containerminichat" + id);
    if (this.state.scroller != containerminichat.scrollHeight) {
      containerminichat.scrollTop = containerminichat.scrollHeight;
      this.state.scroller = containerminichat.scrollHeight;
    }
  }

  markstar(idmessenger, infouser) {
    let select_active = this.state.active;
    if (select_active.includes(idmessenger) === false) {
      this.setState({ active: [...this.state.active, idmessenger] });
      this.props.MarkStar(idmessenger, infouser, "t");
    } else {
      select_active.splice(select_active.indexOf(idmessenger), 1);
      this.setState({ active: [...this.state.active] });
      this.props.MarkStar(idmessenger, infouser, "f");
    }
  }

  markstar2 = (idmessenger, infouser, favorite, cdrid) => {
    if (favorite === "true") {
      this.props.MarkStar(idmessenger, infouser, "f", "false", cdrid);
    } else {
      this.props.MarkStar(idmessenger, infouser, "t", "true", cdrid);
    }
  };

  atenderchamada() {
    CallButtonAccept();
  }

  SaveAnotation2(e, infoatendimento, infouser) {
    var criticidade = this.state.idCriticidadeSelec;
    var comentario = this.comentarioAnotacoes.value;
    var erro = 0;
    var userid = infouser.id;
    var idcdr = infoatendimento.idatendimento;
    var serviceatd = infoatendimento.serviceatd;

    this.closeToast();

    if (criticidade === "" || criticidade === 0) erro = 1;

    if (userid === "") erro = 1;

    if (idcdr === "") erro = 1;

    if (erro === 0) {
      document.getElementById("add-note-text").value = "";

      this.setState({ SaveSucess2: !this.state.SaveSucess2 });
      this.props.InsertAnotationsIn(
        idcdr,
        criticidade,
        comentario,
        userid,
        serviceatd,
      );
    } else {
      console.log("INGENIUM_ANOTT_ERRO : ");

      toast.custom(
        <div className="container__pause-automatic-tabulator">
          <div className="container__pause-automatic__icon customer">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                Atenção! Campo criticidade é de preenchimento obrigatório.
              </strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={(event) => this.closeToast(event)}
              >
                <IconClose />
              </div>
            </div>
          </div>
        </div>,
        {
          id: 2,
          position: "top-left",
        },
      );
    }

    if (this.state.buttonShowCriticits === true)
      this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ReturnSaveSucess2() {
    document.getElementById("simulation_click").click();
    this.setState({ SaveSucess2: !this.state.SaveSucess2 });
  }

  clearReplyToThisCdr() {
    try {
      this.setState((prev) => {
        const {
          [this.props.ContactId.idatendimento]: stateToRemove,
          ...updatedValue
        } = prev.showreplyopNew;
        return {
          showreplyopNew: updatedValue,
        };
      });
    } catch (error) {
      console.log("clearReplyToThisCdr Error: ", error);
    }
  }

  addReplyToThisCdr(messageid) {
    try {
      this.setState((prev) => {
        return {
          showreplyopNew: {
            ...prev.showreplyopNew,
            [this.props.ContactId.idatendimento]: messageid,
          },
        };
      });
    } catch (error) {
      console.log("addReplyToThisCdr ERROR: ", error);
    }
  }

  handleselectedFileOnDrop(files, infousers, contactid) {
    for (let fileUp = 0; fileUp < files.length; fileUp++) {
      let filesend = files[fileUp];

      if (filesend != undefined) {
        this.setState({
          selectedFile: filesend,
          loaded: 0,
        });
        let data = new FormData();

        let namefile = filesend.name;
        let parts = namefile.split(".");
        let extension = parts.pop(); // Remove e guarda a última parte como extensão
        let name = parts.join("."); // Reúne as partes restantes como nome do arquivo

        name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
        name = name.replace(/[^a-zA-Z0-9_]/g, ""); // Remove caracteres especiais
        const date = new Date();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        namefile = `${name}_${minutes}_${seconds}_${
          contactid.idatendimento
        }_${crypto.randomUUID()}.${extension}`;

        data.append("file", filesend, namefile);

        let msgweb = document.getElementById("chat-message").innerText;

        let msgsocket = document.getElementById("chat-message").innerText;
        this.props.editMsg(msgweb, contactid.idatendimento);
        let str = msgsocket.replace(/\s/g, "");
        if (str != "") {
          if (this.state.headerMessage.length > 0) {
            let findChecked = this.props.ActiveHeader.find(
              (header) => header.label === this.props.ContactId.telefone,
            );

            if (
              findChecked &&
              findChecked.active &&
              this.props.InfoUsers.variables_integration
            ) {
              let infos = this.state.headerMessage[0].header;
              const items =
                this.props.InfoUsers.variables_integration.split(",");
              let headerMsg = "";
              for (let index = 0; index < items.length; index++) {
                let label = "";
                if (items[index] === "codigo_ticket") {
                  label = "Número do caso";
                } else {
                  label =
                    items[index].substring(0, 1).toUpperCase() +
                    items[index].substring(1).toLowerCase();
                }

                if (index === items.length - 1) {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
                } else {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
                }
              }
              // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
              // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
              msgweb = headerMsg + msgweb;
              msgsocket = headerMsg + msgsocket;
            }
          }
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgweb = msgweb.replace(/"/gm, '\\"');
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          msgsocket = msgsocket.replace(/"/gm, '\\"');
          document.getElementById("chat-message").innerHTML = "";
          this.props.UploadFile(
            data,
            infousers,
            contactid,
            msgweb,
            makeid(32),
            filesend.size,
            this.state.showreplyopNew[this.props.ContactId.idatendimento]
              ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
              : 0,
            // this.state.idreplyop
          );
        } else {
          this.props.UploadFile(
            data,
            infousers,
            contactid,
            "",
            makeid(32),
            filesend.size,
            this.state.showreplyopNew[this.props.ContactId.idatendimento]
              ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
              : 0,
            // this.state.idreplyop
          );
        }
      }
    }
    // this.setState({ idreplyop: 0, showreplyop: false });
    this.clearReplyToThisCdr();
    document.getElementById("file-input").value = "";
    textMessage[contactid.idatendimento] = "";
  }

  handleselectedFile(event, infousers, contactid) {
    for (let fileUp = 0; fileUp < event.target.files.length; fileUp++) {
      let filesend = event.target.files[fileUp];

      if (filesend != undefined) {
        this.setState({
          selectedFile: filesend,
          loaded: 0,
        });
        let data = new FormData();

        let namefile = filesend.name;
        let parts = namefile.split(".");
        let extension = parts.pop(); // Remove e guarda a última parte como extensão
        let name = parts.join("."); // Reúne as partes restantes como nome do arquivo

        name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
        name = name.replace(/[^a-zA-Z0-9_]/g, ""); // Remove caracteres especiais
        const date = new Date();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        namefile = `${name}_${minutes}_${seconds}_${
          contactid.idatendimento
        }_${crypto.randomUUID()}.${extension}`;

        data.append("file", filesend, namefile);

        let msgweb = document.getElementById("chat-message").innerText;

        let msgsocket = document.getElementById("chat-message").innerText;
        this.props.editMsg(msgweb, contactid.idatendimento);
        let str = msgsocket.replace(/\s/g, "");
        if (str != "") {
          if (this.state.headerMessage.length > 0) {
            let findChecked = this.props.ActiveHeader.find(
              (header) => header.label === this.props.ContactId.telefone,
            );

            if (
              findChecked &&
              findChecked.active &&
              this.props.InfoUsers.variables_integration
            ) {
              let infos = this.state.headerMessage[0].header;
              const items =
                this.props.InfoUsers.variables_integration.split(",");
              let headerMsg = "";
              for (let index = 0; index < items.length; index++) {
                let label = "";
                if (items[index] === "codigo_ticket") {
                  label = "Número do caso";
                } else {
                  label =
                    items[index].substring(0, 1).toUpperCase() +
                    items[index].substring(1).toLowerCase();
                }

                if (index === items.length - 1) {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
                } else {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
                }
              }
              // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
              // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
              msgweb = headerMsg + msgweb;
              msgsocket = headerMsg + msgsocket;
            }
          }
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgweb = msgweb.replace(/"/gm, '\\"');
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          msgsocket = msgsocket.replace(/"/gm, '\\"');
          document.getElementById("chat-message").innerHTML = "";
          this.props.UploadFile(
            data,
            infousers,
            contactid,
            msgweb,
            makeid(32),
            filesend.size,
            this.state.showreplyopNew[this.props.ContactId.idatendimento]
              ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
              : 0,
            // this.state.idreplyop
          );
        } else {
          this.props.UploadFile(
            data,
            infousers,
            contactid,
            "",
            makeid(32),
            filesend.size,
            this.state.showreplyopNew[this.props.ContactId.idatendimento]
              ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
              : 0,
            // this.state.idreplyop
          );
        }
      }
    }

    this.clearReplyToThisCdr();
    document.getElementById("file-input").value = "";
  }

  handleCreateFileSplit(file, infousers, contactid) {
    let filesend = file;
    if (filesend != undefined) {
      this.setState({
        selectedFile: filesend,
        loaded: 0,
      });
      let data = new FormData();
      let namefile = filesend.name;
      let hora = Moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let ext = namefile.split(".").pop();
      namefile = random + "." + ext;
      data.append("file", filesend, namefile);
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      this.props.editMsg(msgweb, contactid.idatendimento);
      let str = msgsocket.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgweb = msgweb.replace(/"/gm, '\\"');
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        msgsocket = msgsocket.replace(/"/gm, '\\"');
        document.getElementById("chat-message").innerHTML = "";
        this.props.UploadFile(
          data,
          infousers,
          contactid,
          msgweb,
          makeid(32),
          filesend.size,
        );
      } else {
        this.props.UploadFile(
          data,
          infousers,
          contactid,
          "",
          makeid(32),
          filesend.size,
        );
      }
    }
  }

  HandleDetails(e, visible) {
    e.preventDefault();
    this.props.ShowVisibleDetailsAtdIns(visible);
  }

  SendInfoInteractionIngDesk(ContactId) {
    const { Connectionsapi, ServiceURL, InfoUsers } = this.props;
    let url_iframe = "";

    if (ServiceURL.length !== 0) {
      let ArrayServiceURL = "";
      if (InfoUsers.nameauth === "IngDesk") {
        ArrayServiceURL = ServiceURL.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    if (url_iframe !== "") {
      let channel = "0";

      if (parseInt(ContactId.idmidia) === 1) channel = "Voz";
      else if (parseInt(ContactId.idmidia) === 5) channel = "Whatsapp";
      else if (parseInt(ContactId.idmidia) === 8) channel = "Telegram";
      else if (parseInt(ContactId.idmidia) === 16) channel = "Whatsapp Voz";

      let jsonIngDesk = {
        origin: "ingweb",
        id: "currentInteraction",
        payload: {
          clientId: null,
          clientName: ContactId.cliente,
          channelId: ContactId.idmidia,
          channelName: channel,
          destination: ContactId.telefone,
          protocol: ContactId.protocolo,
        },
      };
      Connectionsapi.iframe_ref.current.contentWindow.postMessage(
        jsonIngDesk,
        url_iframe,
      );
      this.props.addIteractionIngDesk(jsonIngDesk.payload);
      Connectionsapi.iframe_ref.current.contentWindow.postMessage(
        {
          origin: "ingweb",
          id: "getContactIdInteraction",
          telefone: ContactId.telefone,
        },
        url_iframe,
      );
    }
    this.setState({ activeCrm: true });
  }

  HandleNextAtd(e, visible, temp) {
    e.preventDefault();
    if (this.state.activeCrm === true) {
      this.setState({ activeCrm: false });
      this.props.ShowVisibleNextAtdIn(false, false);
    } else {
      this.props.ShowVisibleNextAtdIn(visible, temp);
      const { Connectionsapi, ContactId, InfoUsers, ServiceURL } = this.props;
      let url_iframe = "";

      if (ServiceURL.length !== 0) {
        let ArrayServiceURL = "";
        if (InfoUsers.nameauth === "IngDesk") {
          ArrayServiceURL = ServiceURL.filter(
            (url) => url.typeofcrm === "IngDesk",
          );
          if (ArrayServiceURL.length !== 0) {
            url_iframe = ArrayServiceURL[0].param;
          }
        }
      }

      if (url_iframe !== "") {
        let channel = "0";

        if (parseInt(ContactId.idmidia) === 1) channel = "Voz";
        else if (parseInt(ContactId.idmidia) === 5) channel = "Whatsapp";
        else if (parseInt(ContactId.idmidia) === 8) channel = "Telegram";
        else if (parseInt(ContactId.idmidia) === 16) channel = "Whatsapp Voz";

        let idChannel = ContactId.idmidia;

        let jsonIngDesk = {
          origin: "ingweb",
          id: "currentInteraction",
          payload: {
            clientId: null,
            clientName: ContactId.cliente,
            channelId: idChannel,
            channelName: channel,
            destination: ContactId.telefone,
            protocol: ContactId.protocolo,
          },
        };
        Connectionsapi.iframe_ref.current.contentWindow.postMessage(
          jsonIngDesk,
          url_iframe,
        );
      }
      this.setState({ activeCrm: true });
    }
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 0;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
  }

  /*
  putMessageFromHelpSideContentOnChatMessage(prevProps) {
    const isMessageFromHelpSideContentChanged =
      prevProps.messageFromHelpSideContent !==
      this.props.messageFromHelpSideContent;
    const hasMessage = !!this.props.messageFromHelpSideContent.textMessage;
    const hasIdatendimento =
      !!this.props.messageFromHelpSideContent.idatendimento ||
      this.props.messageFromHelpSideContent.idatendimento === 0;
    if (isMessageFromHelpSideContentChanged && hasMessage && hasIdatendimento) {
      const currentIdatendimento =
        this.props.messageFromHelpSideContent.idatendimento;
      const message = this.props.messageFromHelpSideContent.textMessage;
      textMessage[currentIdatendimento] = message;
      const input = document.getElementById("chat-message");
      if (input) {
        input.innerText = textMessage[currentIdatendimento];
      }
    }



    console.log("INGENIUM_VERIFICANDO_MESSAGE_FROM", {
      isMessageFromHelpSideContentChanged,
      hasMessage,
      hasIdatendimento,
      id: this.props.messageFromHelpSideContent.idatendimento,
      text: this.props.messageFromHelpSideContent.textMessage,
      messageFromHelpSideContent,
      textMessage,
    });
  }

  */

  /*
  putMessageFromHelpSideContentOnChatMessage(prevProps) {
    const isMessageFromHelpSideContentChanged =
      prevProps.messageFromHelpSideContent !==
      this.props.messageFromHelpSideContent;
    const hasMessage = !!this.props.messageFromHelpSideContent.textMessage;
    const hasIdatendimento =
      !!this.props.messageFromHelpSideContent.idatendimento ||
      this.props.messageFromHelpSideContent.idatendimento === 0;
    if (isMessageFromHelpSideContentChanged && hasMessage && hasIdatendimento) {
      const currentIdatendimento =
        this.props.messageFromHelpSideContent.idatendimento;
      const message = this.props.messageFromHelpSideContent.textMessage;
      textMessage[currentIdatendimento] = message;
      const chatMessage = document.getElementById("chat-message");
      if (chatMessage) {
        chatMessage.innerText = message;
      }
      const buttonToSend = document.getElementById("button-send-message");
      if (buttonToSend) {
        buttonToSend.click();
      }
    }
  }
  */

  sendOnlyText(infoUsers, contactId, text) {
    let msgweb = text;
    let msgsocket = text;

    let str = msgweb.replace(/\s/g, "");
    var img = document.getElementById("contein");
    let callid = makeid(32);

    if (str != "") {
      let opcoes = "";

      msgweb = msgweb.trim();
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgweb = msgweb.replace(/"/gm, '\\"');

      msgsocket = msgsocket.trim();
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      msgsocket = msgsocket.replace(/"/gm, '\\"');

      this.props.InviteMessage(
        callid,
        msgweb,
        "Me",
        infoUsers,
        contactId,
        "0",
        msgsocket,
        "url",
        false,
        [],
        undefined,
        undefined,
        undefined,
        [],
        "hsm" + "§" + opcoes,
      );

      //this.setState({ isHSM: false });
    }

    if (mensagemretorno[contactId.idatendimento] != true) {
      this.props.refreshReturnAtd(1, contactId.telefone);
      mensagemretorno[contactId.idatendimento] = true;
    }
    if (mensagemenviada[contactId.idatendimento] != true) {
      this.props.editAtendimentoAgent(contactId.idatendimento);
      mensagemenviada[contactId.idatendimento] = true;
    }
  }

  sendOnlyFile(infoUsers, contactId, path, caption, size) {
    const hasHttp = path.startsWith(urlIngWeb);
    const formatedPaht = hasHttp ? path.replace(urlIngWeb, "") : path;
    let callid = makeid(32);

    this.props.SendFileFromPath(
      infoUsers,
      contactId,
      formatedPaht,
      caption,
      callid,
      size,
    );
  }

  async putMessageFromHelpSideContentOnChatMessage(prevProps) {
    const isMessageFromHelpSideContentChanged =
      prevProps.messageFromHelpSideContent !==
      this.props.messageFromHelpSideContent;
    const hasMessage =
      !!this.props.messageFromHelpSideContent.textMessage &&
      Array.isArray(this.props.messageFromHelpSideContent.textMessage) &&
      this.props.messageFromHelpSideContent.textMessage.length > 0;
    const hasIdatendimento =
      !!this.props.messageFromHelpSideContent.idatendimento ||
      this.props.messageFromHelpSideContent.idatendimento === 0;
    if (isMessageFromHelpSideContentChanged && hasMessage && hasIdatendimento) {
      this.props.ChangeSideContentLoading(true);
      const currentIdatendimento =
        this.props.messageFromHelpSideContent.idatendimento;
      const messagesToSend = this.props.messageFromHelpSideContent.textMessage;

      let index = 0;
      let isToJumpThisMessage = false;
      for (let messageToSend of messagesToSend) {
        if (isToJumpThisMessage) {
          isToJumpThisMessage = false;
          index++;
          continue;
        }
        const isOnlyText = messageToSend.typeOfContent === "onlyText";
        if (isOnlyText) {
          const textToSend = replacePlaceholders(
            messageToSend.treatedText,
            this.props.messageFromHelpSideContent.infoUsers,
            this.props.messageFromHelpSideContent.contactId,
          );
          this.sendOnlyText(
            this.props.messageFromHelpSideContent.infoUsers,
            this.props.messageFromHelpSideContent.contactId,
            textToSend,
          );
          await delay(500);
        }

        const isOnlyFile = messageToSend.typeOfContent === "onlyFile";
        if (isOnlyFile) {
          const treatedPathFile =
            messageToSend.linkOfFile.includes("https://") ||
            messageToSend.linkOfFile.includes("http://")
              ? messageToSend.linkOfFile
              : `${urlIngWeb}${messageToSend.linkOfFile}`;
          const fileObject = await urlToFile(
            treatedPathFile,
            `arquivo--${index}.${messageToSend.linkOfFile.split(".").pop()}`,
          );

          const hasFileObject = !!fileObject;

          if (!hasFileObject) {
            toast.error("Não foi possível enviar o arquivo!", {
              duration: 3000,
            });
            this.props.ChangeSideContentLoading(false);
            return;
          }

          const size = !!fileObject ? fileObject.size : 0;

          const data = new FormData();

          let namefile = fileObject.name;
          let parts = namefile.split(".");
          let extension = parts.pop(); // Remove e guarda a última parte como extensão
          let name = parts.join("."); // Reúne as partes restantes como nome do arquivo

          name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
          name = name.replace(/[^a-zA-Z0-9_]/g, "");

          const date = new Date();
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          namefile = `${name}_${minutes}_${seconds}.${extension}`;

          data.append("file", fileObject, namefile);

          const response = await uploadFileSideContent(
            data,
            this.props.messageFromHelpSideContent.contactId,
            this.props.IPCurrent,
          );
          const hasResponse = !!response && response.status === 200;
          const hasData = hasResponse && !!response.data;
          const hasFile = hasData && response.data.file;

          if (hasFile) {
            const lastIndex = messagesToSend.length - 1;
            //verifica se o outro elemento é apenas texto para colocar ele como caption deste arquivo
            const hasAnotherMessage = index + 1 <= lastIndex;

            const isAudio =
              [4, 6, 15, 17, 21, 25, 26, 27, 28, 39, 40].includes(
                messageToSend.mimetypeid,
              ) ||
              messageToSend.typename === "audio" ||
              messageToSend.typename === "voice";
            if (hasAnotherMessage && !isAudio) {
              //define que o proximo elemento vai ser pulado
              const nextElement = messagesToSend[index + 1];
              //verificando se é do tipo apenas mensagem
              const isNextMessageOnlyText =
                nextElement.typeOfContent === "onlyText";
              if (isNextMessageOnlyText) {
                let caption = replacePlaceholders(
                  nextElement.treatedText,
                  this.props.messageFromHelpSideContent.infoUsers,
                  this.props.messageFromHelpSideContent.contactId,
                );
                this.props.editMsg(
                  caption,
                  this.props.messageFromHelpSideContent.contactId.idatendimento,
                );
                caption = caption.trim();
                caption = caption.replace(/(?:\r\n|\r|\n)/gm, "\\n");
                caption = caption.replace(/"/gm, '\\"');
                this.sendOnlyFile(
                  this.props.messageFromHelpSideContent.infoUsers,
                  this.props.messageFromHelpSideContent.contactId,
                  response.data.file,
                  caption,
                  size,
                );
                //pula a proxima mensagem visto que já enviamos aqui

                isToJumpThisMessage = true;
              } else {
                this.sendOnlyFile(
                  this.props.messageFromHelpSideContent.infoUsers,
                  this.props.messageFromHelpSideContent.contactId,
                  response.data.file,
                  "",
                  size,
                );
              }
            } else {
              this.sendOnlyFile(
                this.props.messageFromHelpSideContent.infoUsers,
                this.props.messageFromHelpSideContent.contactId,
                response.data.file,
                "",
                size,
              );
            }
          }
          await delay(600);
        }

        const isTextAndFile = messageToSend.typeOfContent === "textAndFile";
        if (isTextAndFile) {
          const treatedPathFile =
            messageToSend.linkOfFile.includes("https://") ||
            messageToSend.linkOfFile.includes("http://")
              ? messageToSend.linkOfFile
              : `${urlIngWeb}${messageToSend.linkOfFile}`;
          const fileObject = await urlToFile(
            treatedPathFile,
            `arquivo--${index}.${messageToSend.linkOfFile.split(".").pop()}`,
          );

          const hasFileObject = !!fileObject;

          if (!hasFileObject) {
            toast.error("Não foi possível enviar o arquivo!", {
              duration: 3000,
            });
            this.props.ChangeSideContentLoading(false);
            return;
          }
          const size = !!fileObject ? fileObject.size : 0;

          const data = new FormData();

          let namefile = fileObject.name;
          let parts = namefile.split(".");
          let extension = parts.pop(); // Remove e guarda a última parte como extensão
          let name = parts.join("."); // Reúne as partes restantes como nome do arquivo

          name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
          name = name.replace(/[^a-zA-Z0-9_]/g, "");

          const date = new Date();
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          namefile = `${name}_${minutes}_${seconds}.${extension}`;

          data.append("file", fileObject, namefile);

          const response = await uploadFileSideContent(
            data,
            this.props.messageFromHelpSideContent.contactId,
            this.props.IPCurrent,
          );
          const hasResponse = !!response && response.status === 200;
          const hasData = hasResponse && !!response.data;
          const hasFile = hasData && response.data.file;

          let caption = replacePlaceholders(
            messageToSend.treatedText,
            this.props.messageFromHelpSideContent.infoUsers,
            this.props.messageFromHelpSideContent.contactId,
          );
          this.props.editMsg(
            caption,
            this.props.messageFromHelpSideContent.contactId.idatendimento,
          );
          caption = caption.trim();
          caption = caption.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          caption = caption.replace(/"/gm, '\\"');

          if (hasFile) {
            this.sendOnlyFile(
              this.props.messageFromHelpSideContent.infoUsers,
              this.props.messageFromHelpSideContent.contactId,
              response.data.file,
              caption,
              size,
            );
          }
          await delay(600);
        }

        const isExternalLink = messageToSend.typeOfContent === "externalLink";
        if (isExternalLink) {
          const textToSend = messageToSend.treatedText;
          this.sendOnlyText(
            this.props.messageFromHelpSideContent.infoUsers,
            this.props.messageFromHelpSideContent.contactId,
            textToSend,
          );
          await delay(500);
        }

        //tempo de espera para enviar a mensagem e aparecer na tela
        index++;
      }
      this.props.ChangeSideContentLoading(false);
    }
  }

  // async putMessageFromHelpSideContentOnChatMessage(prevProps) {
  //   const isMessageFromHelpSideContentChanged =
  //     prevProps.messageFromHelpSideContent !==
  //     this.props.messageFromHelpSideContent;
  //   const hasMessage =
  //     !!this.props.messageFromHelpSideContent.textMessage &&
  //     Array.isArray(this.props.messageFromHelpSideContent.textMessage) &&
  //     this.props.messageFromHelpSideContent.textMessage.length > 0;
  //   const hasIdatendimento =
  //     !!this.props.messageFromHelpSideContent.idatendimento ||
  //     this.props.messageFromHelpSideContent.idatendimento === 0;
  //   if (isMessageFromHelpSideContentChanged && hasMessage && hasIdatendimento) {
  //     this.props.ChangeSideContentLoading(true);
  //     const currentIdatendimento =
  //       this.props.messageFromHelpSideContent.idatendimento;
  //     const messagesToSend = this.props.messageFromHelpSideContent.textMessage;

  //     let index = 0;
  //     for (let messageToSend of messagesToSend) {
  //       const isOnlyText = messageToSend.typeOfContent === "onlyText";
  //       if (isOnlyText) {
  //         const textToSend = replacePlaceholders(
  //           messageToSend.treatedText,
  //           this.props.messageFromHelpSideContent.infoUsers,
  //           this.props.messageFromHelpSideContent.contactId
  //         );
  //         this.sendOnlyText(
  //           this.props.messageFromHelpSideContent.infoUsers,
  //           this.props.messageFromHelpSideContent.contactId,
  //           textToSend
  //         );
  //         await delay(500);
  //       }

  //       const isOnlyFile = messageToSend.typeOfContent === "onlyFile";
  //       if (isOnlyFile) {
  //         const treatedPathFile =
  //           messageToSend.linkOfFile.includes("https://") ||
  //           messageToSend.linkOfFile.includes("http://")
  //             ? messageToSend.linkOfFile
  //             : `${urlIngWeb}${messageToSend.linkOfFile}`;
  //         const fileObject = await urlToFile(
  //           treatedPathFile,
  //           `arquivo--${index}.${messageToSend.linkOfFile.split(".").pop()}`
  //         );
  //         const size = !!fileObject ? fileObject.size : 0;

  //         const data = new FormData();

  //         let namefile = fileObject.name;
  //         let parts = namefile.split(".");
  //         let extension = parts.pop(); // Remove e guarda a última parte como extensão
  //         let name = parts.join("."); // Reúne as partes restantes como nome do arquivo

  //         name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
  //         name = name.replace(/[^a-zA-Z0-9_]/g, "");

  //         const date = new Date();
  //         const minutes = String(date.getMinutes()).padStart(2, "0");
  //         const seconds = String(date.getSeconds()).padStart(2, "0");
  //         namefile = `${name}_${minutes}_${seconds}.${extension}`;

  //         data.append("file", fileObject, namefile);

  //         const response = await uploadFileSideContent(
  //           data,
  //           this.props.messageFromHelpSideContent.contactId,
  //           this.props.IPCurrent
  //         );
  //         const hasResponse = !!response && response.status === 200;
  //         const hasData = hasResponse && !!response.data;
  //         const hasFile = hasData && response.data.file;

  //         if (hasFile) {
  //           this.sendOnlyFile(
  //             this.props.messageFromHelpSideContent.infoUsers,
  //             this.props.messageFromHelpSideContent.contactId,
  //             response.data.file,
  //             "",
  //             size
  //           );
  //         }
  //         await delay(2000);
  //       }

  //       const isTextAndFile = messageToSend.typeOfContent === "textAndFile";
  //       if (isTextAndFile) {
  //         const treatedPathFile =
  //           messageToSend.linkOfFile.includes("https://") ||
  //           messageToSend.linkOfFile.includes("http://")
  //             ? messageToSend.linkOfFile
  //             : `${urlIngWeb}${messageToSend.linkOfFile}`;
  //         const fileObject = await urlToFile(
  //           treatedPathFile,
  //           `arquivo--${index}.${messageToSend.linkOfFile.split(".").pop()}`
  //         );
  //         const size = !!fileObject ? fileObject.size : 0;

  //         const data = new FormData();

  //         let namefile = fileObject.name;
  //         let parts = namefile.split(".");
  //         let extension = parts.pop(); // Remove e guarda a última parte como extensão
  //         let name = parts.join("."); // Reúne as partes restantes como nome do arquivo

  //         name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
  //         name = name.replace(/[^a-zA-Z0-9_]/g, "");

  //         const date = new Date();
  //         const minutes = String(date.getMinutes()).padStart(2, "0");
  //         const seconds = String(date.getSeconds()).padStart(2, "0");
  //         namefile = `${name}_${minutes}_${seconds}.${extension}`;

  //         data.append("file", fileObject, namefile);

  //         const response = await uploadFileSideContent(
  //           data,
  //           this.props.messageFromHelpSideContent.contactId,
  //           this.props.IPCurrent
  //         );
  //         const hasResponse = !!response && response.status === 200;
  //         const hasData = hasResponse && !!response.data;
  //         const hasFile = hasData && response.data.file;

  //         let caption = replacePlaceholders(
  //           messageToSend.treatedText,
  //           this.props.messageFromHelpSideContent.infoUsers,
  //           this.props.messageFromHelpSideContent.contactId
  //         );
  //         this.props.editMsg(
  //           caption,
  //           this.props.messageFromHelpSideContent.contactId.idatendimento
  //         );
  //         caption = caption.trim();
  //         caption = caption.replace(/(?:\r\n|\r|\n)/gm, "\\n");
  //         caption = caption.replace(/"/gm, '\\"');

  //         if (hasFile) {
  //           this.sendOnlyFile(
  //             this.props.messageFromHelpSideContent.infoUsers,
  //             this.props.messageFromHelpSideContent.contactId,
  //             response.data.file,
  //             caption,
  //             size
  //           );
  //         }
  //         await delay(2000);
  //       }

  //       /*
  //       if (isTextAndFile) {
  //         const textToSend = messageToSend.treatedText;
  //         textMessage[currentIdatendimento] = textToSend;
  //         const chatMessage = document.getElementById("chat-message");
  //         if (chatMessage) {
  //           chatMessage.innerText = textToSend;
  //         }
  //         const treatedPathFile =
  //           messageToSend.linkOfFile.includes("https://") ||
  //           messageToSend.linkOfFile.includes("http://")
  //             ? messageToSend.linkOfFile
  //             : `${urlIngWeb}${messageToSend.linkOfFile}`;
  //         const fileObject = await urlToFile(
  //           treatedPathFile,
  //           `arquivo--${index}.${messageToSend.subtypename}`
  //         );
  //         const hasFileObject = !!fileObject;
  //         if (hasFileObject) {
  //           const event = {
  //             target: {
  //               files: [fileObject],
  //             },
  //           };
  //           this.handleselectedFile(
  //             event,
  //             this.props.InfoUsers,
  //             this.props.ContactId
  //           );
  //         }
  //       }
  //       */

  //       //tempo de espera para enviar a mensagem e aparecer na tela
  //       index++;
  //     }
  //     this.props.ChangeSideContentLoading(false);
  //   }
  // }

  updateTextMessageOnChangeChat(prevProps) {
    const isIdatendimentoChanged =
      prevProps.ContactId.idatendimento !== this.props.ContactId.idatendimento;
    if (isIdatendimentoChanged) {
      if (
        this.props.ContactId &&
        (this.props.ContactId.idatendimento ||
          this.props.ContactId.idatendimento === 0) &&
        textMessage &&
        textMessage.length
      ) {
        const isTextMessageUndefined =
          textMessage[this.props.ContactId.idatendimento] === undefined;
        if (isTextMessageUndefined) {
          const input = document.getElementById("chat-message");
          if (input) {
            input.innerText = "";
          }
        } else {
          const input = document.getElementById("chat-message");
          if (input) {
            input.innerText = textMessage[this.props.ContactId.idatendimento];
          }
        }
      }
    }
  }

  handleScroll = () => {
    try {
      const { containers } = this.refs;
      if (containers) {
        const { scrollTop, scrollHeight, clientHeight } = containers;

        if (scrollTop + clientHeight >= scrollHeight) {
          this.limparMensagensNaoLidasDoCliente();
        }
      }
    } catch (error) {
      console.log("handleScroll ERROR: ", error);
    }
  };

  isEndOfTheChat = (messageId) => {
    try {
      const { containers } = this.refs;
      if (containers) {
        const { scrollTop, scrollHeight, clientHeight } = containers;

        const childrenArray = Array.from(containers.children);

        let elementHight = 100;
        if (Array.isArray(childrenArray)) {
          const matchingChildren = childrenArray.find(
            (child) =>
              child.getAttribute("datamessageid") ===
              String(generateUniqueMessageId(this.props.ContactId, messageId)),
          );
          if (matchingChildren) {
            elementHight = matchingChildren.offsetHeight;
          }
        }

        if (scrollTop + clientHeight >= scrollHeight - elementHight) {
          return true;
        }
      }

      return false;
    } catch (error) {
      console.log("isEndOfTheChat ERROR: ", error);
      return false;
    }
  };

  limparMensagensNaoLidasDoCliente() {
    try {
      if (this.state.mensagensNaoLidasDocliente.length !== 0) {
        this.setState({ mensagensNaoLidasDocliente: [] });
      }
    } catch (error) {
      console.log("limparMensagensNaoLidasDoCliente ERROR: ", error);
    }
  }

  // scrollPageWhenReceiveMessage(prevProps) {
  //   try {
  //     const prevMessages =
  //       prevProps.Messages[this.props.ContactId.idatendimento];
  //     const currentMessages =
  //       this.props.Messages[this.props.ContactId.idatendimento];
  //     const currentLastMessage =
  //       Array.isArray(currentMessages) &&
  //       currentMessages.length > 0 &&
  //       currentMessages[currentMessages.length - 1];
  //     const qtdPrevMessages = Array.isArray(prevMessages)
  //       ? prevMessages.length
  //       : 0;
  //     const qtdCurrentMessages = Array.isArray(currentMessages)
  //       ? currentMessages.length
  //       : 0;

  //     const isChatChanged =
  //       this.props.ContactId.idatendimento !==
  //       prevProps.ContactId.idatendimento;

  //     if (isChatChanged) {
  //       requestAnimationFrame(() => this.scrollDown());
  //       return;
  //     }

  //     const isPreviousMessagesLoaded =
  //       qtdPrevMessages !== qtdCurrentMessages &&
  //       Boolean(this.props.ContactId.lastCdrClicked) &&
  //       this.props.ContactId.lastCdrClicked.isLoading;
  //     if (isPreviousMessagesLoaded) {
  //       this.props.ChangeLastCdrClickedAction(
  //         parseInt(this.props.ContactId.idatendimento),
  //         { ...this.props.ContactId.lastCdrClicked, isLoading: false }
  //       );
  //       return;
  //     }

  //     const isClientMessageAndOperatorIsOnPageEnd =
  //       qtdPrevMessages !== qtdCurrentMessages &&
  //       Boolean(currentLastMessage) &&
  //       currentLastMessage.author !== "Me" &&
  //       this.isEndOfTheChat(currentLastMessage.messageid);
  //     if (isClientMessageAndOperatorIsOnPageEnd) {
  //       requestAnimationFrame(() => this.scrollDown());
  //       return;
  //     }

  //     const isTheMessageOfOperator =
  //       qtdPrevMessages !== qtdCurrentMessages &&
  //       Boolean(currentLastMessage) &&
  //       currentLastMessage.author === "Me";
  //     if (isTheMessageOfOperator) {
  //       requestAnimationFrame(() => this.scrollDown());
  //       return;
  //     }

  //     const isClientMessageAndOperatorIsNotInThePageEnd =
  //       qtdPrevMessages !== qtdCurrentMessages &&
  //       Boolean(currentLastMessage) &&
  //       currentLastMessage.author !== "Me" &&
  //       !this.isEndOfTheChat(currentLastMessage.messageid) &&
  //       !this.state.mensagensNaoLidasDocliente.includes(
  //         parseInt(currentLastMessage.messageid)
  //       );
  //     if (isClientMessageAndOperatorIsNotInThePageEnd) {
  //       this.setState((prev) => ({
  //         mensagensNaoLidasDocliente: [
  //           ...prev.mensagensNaoLidasDocliente,
  //           parseInt(currentLastMessage.messageid),
  //         ],
  //       }));
  //       return;
  //     }
  //     // this.scrollDown();
  //     return;
  //   } catch (error) {
  //     console.log("scrollPageWhenReceiveMessage ERROR: ", error);
  //   }
  // }
  scrollPageWhenReceiveMessage(prevProps) {
    try {
      const prevMessages =
        prevProps.Messages[this.props.ContactId.idatendimento];
      const currentMessages =
        this.props.Messages[this.props.ContactId.idatendimento];
      const currentLastMessage =
        Array.isArray(currentMessages) &&
        currentMessages.length > 0 &&
        currentMessages[currentMessages.length - 1];
      const qtdPrevMessages = Array.isArray(prevMessages)
        ? prevMessages.length
        : 0;
      const qtdCurrentMessages = Array.isArray(currentMessages)
        ? currentMessages.length
        : 0;

      const isChatChanged =
        this.props.ContactId.idatendimento !==
        prevProps.ContactId.idatendimento;

      if (isChatChanged) {
        requestAnimationFrame(() => this.scrollDown());
        return;
      }

      if (this.state.isFirstsLoad && qtdCurrentMessages !== 0) {
        this.setState({
          isFirstsLoad: false,
        });
        requestAnimationFrame(() => this.scrollDown());
      }

      // const isPreviousMessagesLoaded =
      //   qtdPrevMessages !== qtdCurrentMessages &&
      //   Boolean(this.props.ContactId.lastCdrClicked) &&
      //   this.props.ContactId.lastCdrClicked.isLoading;
      // if (isPreviousMessagesLoaded) {
      //   this.props.ChangeLastCdrClickedAction(
      //     parseInt(this.props.ContactId.idatendimento),
      //     { ...this.props.ContactId.lastCdrClicked, isLoading: false }
      //   );
      //   return;
      // }

      const isClientMessageAndOperatorIsOnPageEnd =
        qtdPrevMessages !== qtdCurrentMessages &&
        Boolean(currentLastMessage) &&
        currentLastMessage.author !== "Me" &&
        this.isEndOfTheChat(currentLastMessage.messageid);

      const isClientMessageAndOperatorIsOnPageEndAndHasPreviousMessagesAdded =
        isClientMessageAndOperatorIsOnPageEnd &&
        qtdPrevMessages > 0 &&
        prevMessages[qtdPrevMessages - 1].messageid ===
          currentLastMessage.messageid;
      if (isClientMessageAndOperatorIsOnPageEndAndHasPreviousMessagesAdded) {
        return;
      }
      if (isClientMessageAndOperatorIsOnPageEnd) {
        requestAnimationFrame(() => this.scrollDown());
        return;
      }

      const isTheMessageOfOperator =
        qtdPrevMessages !== qtdCurrentMessages &&
        Boolean(currentLastMessage) &&
        currentLastMessage.author === "Me";

      const isTheMessageOfOperatorAndHasPreviousMessagesAdded =
        isTheMessageOfOperator &&
        qtdPrevMessages > 0 &&
        prevMessages[qtdPrevMessages - 1].messageid ===
          currentLastMessage.messageid;
      if (isTheMessageOfOperatorAndHasPreviousMessagesAdded) {
        return;
      }
      if (isTheMessageOfOperator) {
        requestAnimationFrame(() => this.scrollDown());
        return;
      }

      const isClientMessageAndOperatorIsNotInThePageEnd =
        qtdPrevMessages !== qtdCurrentMessages &&
        Boolean(currentLastMessage) &&
        currentLastMessage.author !== "Me" &&
        !this.isEndOfTheChat(currentLastMessage.messageid) &&
        !this.state.mensagensNaoLidasDocliente.includes(
          parseInt(currentLastMessage.messageid),
        );
      const isClientMessageAndOperatorIsNotInThePageEndAndHasPreviousMessagesAdded =
        isClientMessageAndOperatorIsNotInThePageEnd &&
        qtdPrevMessages > 0 &&
        prevMessages[qtdPrevMessages - 1].messageid ===
          currentLastMessage.messageid;

      if (
        isClientMessageAndOperatorIsNotInThePageEndAndHasPreviousMessagesAdded
      ) {
        return;
      }
      if (isClientMessageAndOperatorIsNotInThePageEnd) {
        this.setState((prev) => ({
          mensagensNaoLidasDocliente: [
            ...prev.mensagensNaoLidasDocliente,
            parseInt(currentLastMessage.messageid),
          ],
        }));
        return;
      }
      // if (qtdPrevMessages !== qtdCurrentMessages) {
      //   console.log("raimundo_neto 2627");
      //   requestAnimationFrame(() => this.scrollDown());
      //   return;
      // }
      return;
    } catch (error) {
      console.log("scrollPageWhenReceiveMessage ERROR: ", error);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    this.scrollPageWhenReceiveMessage(prevProps);
    // this.scrollDownMail();
    let chatsimult = prevState.chatsimult;
    chatsimult.forEach((simult) => {
      if (document.getElementById("containerminichat" + simult.iduserout))
        document.getElementById(
          "containerminichat" + simult.iduserout,
        ).scrollTop = document.getElementById(
          "containerminichat" + simult.iduserout,
        ).scrollHeight;
    });
    let lengthDiv = document.getElementById("chat-wrapper").offsetWidth;
    this.setState({ lengthLast: lengthDiv });
    // this.state.lengthLast = lengthDiv;
    theaterStart = Math.trunc(lengthDiv / 160);
    prevState.atdsimult.map((simult) => {
      if (simult.mtnow === "newatd") {
        const timer = setTimeout(() => {
          simult.mtnow = "new";
        }, 500);
        return () => clearTimeout(timer);
      }
    });
    if (this.state.blobURL && this.state.isRecording === true) {
      let data = new FormData();
      let hora = Moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let namefile = random + ".mp3";
      data.append("file", this.state.blobURL, namefile);
      AudioFile = data;
      this.props.UploadFile(
        AudioFile,
        this.props.InfoUsers,
        this.props.ContactId,
        "",
        makeid(32),
        this.state.blobURL.size,
        this.state.showreplyopNew[this.props.ContactId.idatendimento]
          ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
          : 0,
      );
      this.clearReplyToThisCdr();
      this.setState({ blobURL: "" });
    }

    if (prevProps.AtdSimult.length !== 0) {
      var i = 0;
      prevProps.AtdSimult.map((simult) => {
        if (parseInt(simult.idmidia) !== 1 && parseInt(simult.idmidia) !== 16) {
          i = i + simult.qtdmessage;
        }
      });
      if (i !== 0 && i !== "undefined" && i !== undefined)
        document.title = "(" + i + ") Ingweb";
      else document.title = "Ingweb";
    }
    if (
      prevProps.AtdSimult.length === 0 &&
      prevProps.StatusAgent.status === "Ligação"
    ) {
      this.props.AlterStatus(
        "Encerrou",
        "",
        Moment().format("DD/MM/YYYY HH:mm:ss"),
      );
    }

    this.putMessageFromHelpSideContentOnChatMessage(prevProps);

    this.updateTextMessageOnChangeChat(prevProps);
  }

  componentDidMount() {
    try {
      const { containers } = this.refs;
      if (containers) {
        containers.addEventListener("scroll", this.handleScroll);
      }
    } catch (error) {
      console.log("componentDidMount 2571 ERROR: ", error);
    }
    var indexElemAtual = 0;
    var libBusca = null;
    var armazenador = [];
    var contador = null;
    var elems = null;
    this.props.RespostasRapidasida(this.props.InfoUsers.id);
    var topBarHeight = $("header").outerHeight(true);
    var windowHeight = $("body").outerHeight(true);
    var activeChatsHeight = $(".active-chats").outerHeight(true);
    var canvasHeight = windowHeight - topBarHeight - activeChatsHeight;
    var proximosAtendimentosHeight = windowHeight - topBarHeight;

    // if (this.node) {
    //   this.node.innerText = valorInput;
    // }
    document.getElementById("contein").style.display = "none";

    if (this.props.ContactId) {
      if (textMessage[this.props.ContactId.idatendimento] != undefined) {
        document.getElementById("chat-message").innerText =
          textMessage[this.props.ContactId.idatendimento];
      } else {
        document.getElementById("chat-message").innerText = "";
      }
    }

    if (connection_platform.type_connect === "https") {
      navigator.getMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

      navigator.getMedia(
        { audio: true },
        () => {
          this.setState({ isBlocked: false });
        },
        () => {
          this.setState({ isBlocked: true });
        },
      );
    }
    requestAnimationFrame(() => this.scrollDown());
    // this.scrollDown();
  }

  componentWillUnmount() {
    try {
      const { containers } = this.refs;
      if (containers) {
        containers.removeEventListener("scroll", this.handleScroll);
      }
    } catch (error) {
      console.log("componentWillUnmount 2627 ERROR: ", error);
    }
  }

  mute(event, statusatd) {
    event.preventDefault();
    // if (this.state.pause === false) this.setState({ pause: true });
    // this.setState({ mute: !this.state.mute });
    this.props.SetMute(statusatd === 3 ? false : true);
  }

  pause(event, statusatd) {
    // if (this.state.mute === false) this.setState({ mute: true });
    // this.setState({ pause: !this.state.pause });
    this.props.SetHold(statusatd === 2 ? false : true);
  }

  async changeCopiedLinkDinamicy(e, atendimento, userRedux) {
    const encryptedStr = CryptoJS.AES.encrypt(
      `${atendimento.idatendimento}`,
      "secret key 123",
    );
    // setTimeout(() => {
    this.props.changeCopiedLinkAnswer();
    // }, [2000])
    await navigator.clipboard.writeText(
      `${userRedux.link_webchat}?${encryptedStr}`,
    );
  }

  closeToast() {
    toast.remove();
  }

  openTabulationModal(tabulatedInfos, ContactId, InfoUsers) {
    this.setState({
      tabulationModalInfos: {
        isOpen: true,
        data: {
          tabulatedInfos: tabulatedInfos,
          ContactId: ContactId,
          InfoUsers: InfoUsers,
        },
      },
    });
  }

  ByeCall(
    event,
    contactid,
    infousers,
    atdsimult,
    novamensagem,
    reason,
    ipcurrent,
    status,
  ) {
    event.preventDefault();

    if (
      infousers.classificationcount > 0 &&
      !tabulationHandler.hasAnyTabulatedInfo(
        this.props.tabulatedInfos,
        contactid,
      )
    ) {
      this.openTabulationModal(this.props.tabulatedInfos, contactid, infousers);
      // document.getElementById("chat-action-add-tabulator").click();
      const timeOutIdClassification = setTimeout(() => {
        this.closeToast();
        clearTimeout(timeOutIdClassification);
      }, 7000);
      toast.custom(
        <div className="container__pause-automatic-tabulator">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                Atenção! Encerre a conversa tabulando o atendimento.
              </strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={(event) => this.closeToast(event)}
              >
                <IconClose />
              </div>
            </div>
            <span>
              Efetue a tabulação deste atendimento, logo após poderá efetuar o
              encerramento.
            </span>
          </div>
        </div>,
        {
          id: 2,
          position: "top-left",
        },
      );
      return true;
    }

    if (
      infousers.classificationcount > 0 &&
      !tabulationHandler.hasAnyTabulatedInfo(
        this.props.tabulatedInfos,
        contactid,
      ) &&
      infousers.tmoutacw === 0
    ) {
      this.openTabulationModal(this.props.tabulatedInfos, contactid, infousers);
      // document.getElementById("chat-action-add-tabulator").click();
      const timeOutIdClassification = setTimeout(() => {
        this.closeToast();
        clearTimeout(timeOutIdClassification);
      }, 7000);
      toast.custom(
        <div className="container__pause-automatic-tabulator">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                Atenção! Encerre a conversa tabulando o atendimento.
              </strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={(event) => this.closeToast(event)}
              >
                <IconClose />
              </div>
            </div>
            <span>
              Efetue a tabulação deste atendimento, logo após poderá efetuar o
              encerramento.
            </span>
          </div>
        </div>,
        {
          id: 2,
          position: "top-left",
        },
      );
      return true;
    }

    var permissionclose = true;

    if (
      connection_platform.nc2_integration === true &&
      connection_platform.nc2_users.indexOf(infousers.ramal) !== -1
    ) {
      if (
        infousers.nc2schedule !== true &&
        contactid.isDialNc2 === true &&
        contactid.acw === true &&
        (contactid.nomesubservico !== "CAMPANHA" ||
          (status.status !== "Chamando" && status.status !== "Discando"))
      ) {
        if (infousers.numbersnc2 !== 0) {
          this.props.actionScheduleNc2();
        } else if (infousers.reasonsnc2) {
          this.props.actionScheduleNc2();
        }
        permissionclose = false;
      }
    }

    if (permissionclose) {
      var button = document.getElementById("chat-action-shutdown");

      if (!button.getAttribute("disabled") != "disabled") {
        button.setAttribute("disabled", "disabled");
        setTimeout(function () {
          button.removeAttribute("disabled");
        }, 1000);
      }

      this.props.ByeAttendant(contactid, infousers, reason);

      this.props.deleteMessageHeader(contactid);
      delete mensagensnaolidas[contactid.idatendimento];
      delete outroatendimento[contactid.idatendimento];

      if (atdsimult.length > 1) {
        let i = 0;
        if (atdsimult[0].idatendimento == contactid.idatendimento) i = 1;

        //considerar acw em qualquer midia
        // if(parseInt(contactid.idmidia) === 1){
        if (
          infousers.tmoutacw === 0 &&
          parseInt(contactid.idmidia) !== 1 &&
          parseInt(contactid.idmidia) !== 16
        ) {
          const storageAtdActually = localStorage.getItem("current-service");
          if (
            storageAtdActually &&
            parseInt(contactid.idatendimento) !== parseInt(storageAtdActually)
          ) {
            const indice = atdsimult.findIndex(
              (item) =>
                parseInt(item.idatendimento) === parseInt(storageAtdActually),
            );
            if (indice !== -1) {
              i = indice;
              localStorage.removeItem("current-service");
            }
          }
          this.props.ProximoAtendimento(
            atdsimult[i],
            novamensagem,
            contactid,
            infousers,
            ipcurrent,
            atdsimult,
          );
          setTimeout(() => {
            this.SendInfoInteractionIngDesk(atdsimult[i]);
          }, [500]);
        } else if (infousers.tmoutacw !== 0 && contactid.acw === true) {
          const storageAtdActually = localStorage.getItem("current-service");
          if (
            storageAtdActually &&
            parseInt(contactid.idatendimento) !== parseInt(storageAtdActually)
          ) {
            const indice = atdsimult.findIndex(
              (item) =>
                parseInt(item.idatendimento) === parseInt(storageAtdActually),
            );
            if (indice !== -1) {
              i = indice;
              localStorage.removeItem("current-service");
            }
          }
          this.props.ProximoAtendimento(
            atdsimult[i],
            novamensagem,
            contactid,
            infousers,
            ipcurrent,
            atdsimult,
          );
          setTimeout(() => {
            this.SendInfoInteractionIngDesk(atdsimult[i]);
          }, [500]);
        }

        // considerar acw em qualquer midia
        // }else if(parseInt(contactid.idmidia) !== 1){
        //   this.props.ProximoAtendimento(atdsimult[i],novamensagem,contactid,infousers,ipcurrent);
        // }
        // document.getElementById("chat-message").innerText = atdsimult[i].msg;
        document.getElementById("chat-message").innerText = "";
      }
      if (
        infousers.tmoutacw !== 0 &&
        contactid.acw !== true &&
        parseInt(contactid.idmidia) !== 1 &&
        parseInt(contactid.idmidia) !== 16
      ) {
        this.props.tratarAfterCallWork(
          infousers.tmoutacw,
          contactid.serviceatd,
          false,
        );
      } else if (infousers.tmoutacw !== 0 && contactid.acw === true) {
        this.props.tratarAfterCallWork(
          infousers.tmoutacw,
          contactid.serviceatd,
          true,
        );
      }

      if (contactid.acw !== true) {
        InsertActivityATT(
          contactid.serviceatd,
          16,
          infousers.id,
          "Operador clicou em encerrar",
        );
      }
    }

    this.setState({ editableQuickAnswer: false });
    document.getElementById("chat-message").contentEditable = true;
  }

  RemoveExternalConference(
    ContactId,
    atendimento,
    line,
    contactatd,
    serviceatd,
  ) {
    this.props.RemoveExternalConference(
      ContactId,
      atendimento,
      line,
      contactatd,
      serviceatd,
    );
  }

  AddExternalConference(ContactId, atendimento, line, contactatd, serviceatd) {
    this.props.AddExternalConference(
      ContactId,
      atendimento,
      line,
      contactatd,
      serviceatd,
    );
  }

  GiveBackCheckbox(e, serviceinid) {
    if (e.target.checked) {
      this.setState({
        auxIvr: this.state.auxIvr.concat([serviceinid]),
      });
    } else {
      this.setState({
        auxIvr: this.state.auxIvr.filter(function (val) {
          return val != serviceinid;
        }),
      });
    }
  }

  GiveBackRadio(e, serviceinid, todosids) {
    // var teste = [];
    // todosids = todosids.transfers;
    // for (let i = 0; i < todosids.length; i++) {
    //   teste.push(todosids[i].id);
    //   if (todosids[i].ura === true) {
    //     var myCheckbox = document.getElementById("radio" + todosids[i].id);
    //     if (document.getElementById("radio" + todosids[i].id) != null)
    //       myCheckbox.checked = false;
    //   }
    // }
    // var myCheckbox = document.getElementById("radio" + serviceinid);
    // myCheckbox.checked = true;

    if (this.state.auxIvrRadio === serviceinid) {
      this.setState({ auxIvrRadio: 0 });
    } else {
      this.setState({ auxIvrRadio: serviceinid });
    }
  }

  SetCancelIvr(e, todosids) {
    var serviceinid = this.state.auxIvr;
    todosids = todosids.transfers;
    // if (this.state.auxIvrRadio != 0) {
    //   var ivrradio = this.state.auxIvrRadio;
    //   serviceinid = serviceinid.concat([ivrradio]);
    // }

    if (serviceinid.length != 0) {
      for (let i = 0; i < todosids.length; i++) {
        // teste.push(todosids[i].id);
        if (todosids[i].ura === false) {
          var myCheckbox = document.getElementById("checkbox" + todosids[i].id);
          if (myCheckbox != null) myCheckbox.checked = false;
        }
      }
    }

    this.setState({ auxIvr: [] });
    this.setState({ auxIvrRadio: 0 });

    document.getElementById("simulation_click").click();
  }

  SetTransferIvr(
    e,
    todosids,
    contactid,
    infousers,
    atdsimult,
    novamensagem,
    ipcurrent,
  ) {
    document.getElementById("simulation_click").click();
    var serviceinid = this.state.auxIvr;

    var teste = [];
    if (this.state.auxIvrRadio != 0) {
      var ivrradio = this.state.auxIvrRadio;
      serviceinid = serviceinid.concat([ivrradio]);
    }
    if (serviceinid.length != 0) {
      for (let i = 0; i < todosids.length; i++) {
        teste.push(todosids[i].id);
        if (todosids[i].ura === false) {
          var myCheckbox = document.getElementById("checkbox" + todosids[i].id);
          if (myCheckbox != null) myCheckbox.checked = false;
        }
        if (todosids[i].ura === true) {
          var myCheckbox = document.getElementById("radio" + todosids[i].id);
          if (myCheckbox != null) myCheckbox.checked = false;
        }
      }

      const socket = SendSocketIvrCall(contactid, serviceinid, infousers);

      delete mensagensnaolidas[contactid.idatendimento];
      delete outroatendimento[contactid.idatendimento];

      if (atdsimult.length > 1) {
        let i = 0;
        if (atdsimult[0].idatendimento == contactid.idatendimento) i = 1;

        this.props.ByeAttendant(contactid, infousers, "URA");
        this.props.ProximoAtendimento(
          atdsimult[i],
          novamensagem,
          contactid,
          infousers,
          ipcurrent,
        );
      } else {
        this.props.ByeAttendant(contactid, infousers, "URA");
      }
      if (
        infousers.tmoutacw !== 0 &&
        contactid.acw !== true &&
        parseInt(contactid.idmidia) !== 1 &&
        parseInt(contactid.idmidia) !== 16
      ) {
        this.props.tratarAfterCallWork(
          infousers.tmoutacw,
          contactid.serviceatd,
          false,
        );
      }

      this.setState({ auxIvr: [] });
      this.setState({ auxIvrRadio: 0 });
    }
  }
  // event, InfoUsers, ContactId, agent, atdsimult, Messages,chat
  TransferAgent(
    event,
    infousers,
    ContactId,
    agent,
    atdsimult,
    Messages,
    outservices,
    servicegroup,
  ) {
    if (infousers.id) {
      delete mensagensnaolidas[ContactId.idatendimento];
      delete outroatendimento[ContactId.idatendimento];
      if (ContactId.length != 0) {
        const socket = SendSocketTransferCallIn(
          infousers,
          ContactId,
          agent,
          atdsimult,
          outservices,
          servicegroup,
        );
      } else {
        this.props.ByeAttendant(ContactId, infousers, "transferencia");
      }
    }
    document.getElementById("simulation_click").click();
    if (Messages === "1") {
    }
    this.props.TransferCall(infousers);
    this.props.ShowVisibleNextAtdIn(true, true);
  }

  ByeChat(e, simult, Chat, ChatSimult) {
    this.props.ByeChat(simult, Chat, ChatSimult);
  }

  ClosePopovers(e) {
    document.getElementById("add-note-text").value = "";
    document.getElementById("simulation_click").click();
  }

  FilterOptions(transfer) {
    if (this.state.searchUra) {
      if (
        transfer.name.toLowerCase().includes(this.state.searchUra.toLowerCase())
      ) {
        return transfer;
      } else {
        return;
      }
    } else {
      return transfer;
    }
  }

  renderPopover2 = (e, IvrCallTransfer, ContactId, InfoUsers, ipcurrent) => (
    <div id="popover-return-ura">
      <div className="popover">
        <div className="popover__header">
          <span className="popover__header-title">Devolver para o BOT</span>
          <span className="popover__header-subtitle">
            Selecione a URA para devolver esse atendimento
          </span>
        </div>
        <div className="popover__body">
          <div className="full-search_container">
            <input
              type="text"
              name="client-search"
              id="client-search"
              value={this.state.searchUra}
              onChange={(event) => this.handleValueUra(event)}
              placeholder="Pesquisar"
            />
            <button type="submit" className="full-search__btn">
              <Search />
            </button>
          </div>
          <div className="options-list">
            <ul>
              {this.state.transfers
                .filter(this.FilterOptions.bind(this))
                .map((transfer) =>
                  (() => {
                    if (
                      transfer.ura === true &&
                      parseInt(transfer.idmidia) === parseInt(ContactId.idmidia)
                    ) {
                      return (
                        <li key={transfer.id}>
                          {/* <input
                          onChange={(event) =>
                            this.GiveBackRadio(
                              event,
                              transfer.id,
                              IvrCallTransfer
                            )
                          }
                          type="radio"
                          name={"radio" + transfer.id}
                          value={transfer.id}
                          id={"radio" + transfer.id}
                          checked={this.state.auxIvrRadio === transfer.id}
                        /> */}
                          <Checkbox
                            onChange={(event) =>
                              this.GiveBackRadio(
                                event,
                                transfer.id,
                                IvrCallTransfer,
                              )
                            }
                            radioBox={true}
                            type="radio"
                            name={"radio" + transfer.id}
                            value={transfer.id}
                            id={"radio" + transfer.id}
                            checked={this.state.auxIvrRadio === transfer.id}
                          />
                          <label htmlFor={"radio" + transfer.id}>
                            {transfer.name}
                          </label>
                        </li>
                      );
                    }
                  })(),
                )}
              <li className="title-list">ANÚNCIO / PESQUISA</li>
              {this.state.transfers
                .filter(this.FilterOptions.bind(this))
                .map((transfer) =>
                  (() => {
                    if (
                      transfer.ura === false &&
                      parseInt(transfer.idmidia) === parseInt(ContactId.idmidia)
                    ) {
                      return (
                        <li key={transfer.id}>
                          {/* <input
                          onChange={(event) =>
                            this.GiveBackCheckbox(event, transfer.id)
                          }
                          type="checkbox"
                          name={"checkbox" + transfer.id}
                          id={"checkbox" + transfer.id}
                        /> */}
                          <Checkbox
                            onChange={(event) =>
                              this.GiveBackCheckbox(event, transfer.id)
                            }
                            typeCheck="checkbox"
                            name={"checkbox" + transfer.id}
                            id={"checkbox" + transfer.id}
                            value={transfer.id}
                            checked={this.state.auxIvr.includes(transfer.id)}
                          />
                          <label htmlFor={"checkbox" + transfer.id}>
                            {transfer.name}
                          </label>
                        </li>
                      );
                    }
                  })(),
                )}
            </ul>
          </div>
        </div>
        <div className="popover__footer">
          <button
            onClick={(event) =>
              this.SetTransferIvr(
                event,
                IvrCallTransfer,
                ContactId,
                InfoUsers,
                this.state.atdsimult,
                this.state.messages,
                ipcurrent,
              )
            }
            className="btn btn-primary"
          >
            Devolver
          </button>
          <button
            onClick={(event) => this.SetCancelIvr(event, IvrCallTransfer)}
            className="btn btn-secondary"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );

  handleValueUra(e) {
    this.setState({ searchUra: e.target.value });
  }

  renderPopover6 = () => (
    <div className="context-menu" id="modal-contato-ligar">
      <ul className="context-menu__list">
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path d="M0,0H20V20H0Z" fill="none" />
              <path
                className="grey-mode"
                d="M18.82,14.632A10.572,10.572,0,0,1,15.5,14.1a.95.95,0,0,0-.95.223L12.5,16.372a14,14,0,0,1-6.133-6.133L8.416,8.178a.893.893,0,0,0,.232-.931,10.572,10.572,0,0,1-.531-3.322A.933.933,0,0,0,7.188,3H3.924A.933.933,0,0,0,3,3.931a15.819,15.819,0,0,0,15.822,15.82.933.933,0,0,0,.929-.931V15.556A.933.933,0,0,0,18.82,14.632Zm-.931-3.264h1.86A8.376,8.376,0,0,0,11.375,3V4.86a6.509,6.509,0,0,1,6.514,6.514Zm-3.723,0h1.86a4.655,4.655,0,0,0-4.652-4.645v1.86a2.788,2.788,0,0,1,2.792,2.792Z"
                transform="translate(-1.375 -1.375)"
                fill="#005daa"
              />
            </svg>{" "}
            Ligação (Voz)
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                className="grey-mode"
                d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z"
                transform="translate(77.71 1227.71)"
                fill="#25d366"
              />
            </svg>{" "}
            Whatsapp
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20.009"
              viewBox="0 0 20 20.009"
            >
              <path
                d="M0,.961V19.047a.961.961,0,0,0,.961.961h9.693V12.283h-2.6V9.126h2.6V6.475a3.49,3.49,0,0,1,3.49-3.49h2.722V5.821H14.917a1.112,1.112,0,0,0-1.111,1.111V9.126h3.007L16.4,12.283H13.8v7.726h5.237A.961.961,0,0,0,20,19.047V.961A.961.961,0,0,0,19.039,0H.953A.959.959,0,0,0,0,.961Z"
                fill="#3b5998"
                className="grey-mode"
              />
            </svg>{" "}
            Facebook
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z"
                fill="#005daa"
                className="grey-mode"
              />
            </svg>{" "}
            E-mail
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.049"
              height="20.049"
              viewBox="0 0 20.049 20.049"
            >
              <circle
                className="grey-mode"
                cx="10.024"
                cy="10.024"
                r="10.024"
                fill="#08c"
              />
              <path
                d="M100.412,107.636a.334.334,0,0,0-.329-.027l-10.772,5.014a.527.527,0,0,0,.012.96l9.931,4.325a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,100.412,107.636Z"
                transform="translate(-85.522 -103.365)"
                fill="#e5e5e5"
              />
              <path
                d="M171.631,115.676l.671,4.487,7.455-11.73Z"
                transform="translate(-164.91 -104.186)"
                fill="#b7bec5"
              />
              <path
                d="M100.083,107.613l-10.772,5.014a.527.527,0,0,0,.012.96l2.919,1.271,8.127-7.244A.334.334,0,0,0,100.083,107.613Z"
                transform="translate(-85.522 -103.369)"
                fill="#fff"
              />
              <path
                d="M189.659,116.354l-.887,3.808,7.456-11.73Z"
                transform="translate(-181.38 -104.186)"
                fill="#fff"
              />
              <path
                d="M218.03,108.456a.328.328,0,0,0-.043-.024l-6.569,7.922,5.454,2.375a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,218.03,108.456Z"
                transform="translate(-203.139 -104.186)"
                fill="#fff"
              />
            </svg>{" "}
            Telegram
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.013"
              height="20.013"
              viewBox="0 0 20.013 20.013"
            >
              <path
                className="grey-mode"
                d="M14.051,0H5.962A5.969,5.969,0,0,0,0,5.962v8.089a5.969,5.969,0,0,0,5.962,5.962h8.089a5.969,5.969,0,0,0,5.962-5.962V5.962A5.969,5.969,0,0,0,14.051,0ZM18,14.051A3.949,3.949,0,0,1,14.051,18H5.962a3.949,3.949,0,0,1-3.949-3.949V5.962A3.949,3.949,0,0,1,5.962,2.013h8.089A3.949,3.949,0,0,1,18,5.962v8.089Z"
                fill="#e4405f"
              />
              <path
                className="grey-mode"
                d="M138.176,133a5.176,5.176,0,1,0,5.176,5.176A5.182,5.182,0,0,0,138.176,133Zm0,8.339a3.163,3.163,0,1,1,3.163-3.163A3.163,3.163,0,0,1,138.176,141.339Z"
                transform="translate(-128.17 -128.17)"
                fill="#e4405f"
              />
              <circle
                className="grey-mode"
                cx="1.24"
                cy="1.24"
                r="1.24"
                transform="translate(13.952 3.629)"
                fill="#e4405f"
              />
            </svg>{" "}
            Instagram
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.615"
              height="20"
              viewBox="0 0 24.615 20"
            >
              <path
                className="grey-mode"
                d="M24.615,50.368a10.521,10.521,0,0,1-2.908.8,5.018,5.018,0,0,0,2.22-2.789,10.085,10.085,0,0,1-3.2,1.222A5.046,5.046,0,0,0,12,53.048a5.2,5.2,0,0,0,.117,1.151,14.284,14.284,0,0,1-10.4-5.278,5.048,5.048,0,0,0,1.551,6.745,4.984,4.984,0,0,1-2.28-.622V55.1a5.07,5.07,0,0,0,4.043,4.958,5.037,5.037,0,0,1-1.323.166,4.462,4.462,0,0,1-.955-.086,5.094,5.094,0,0,0,4.715,3.515A10.14,10.14,0,0,1,1.208,65.8,9.453,9.453,0,0,1,0,65.735,14.207,14.207,0,0,0,7.742,68,14.264,14.264,0,0,0,22.1,53.64c0-.223-.008-.438-.018-.652A10.067,10.067,0,0,0,24.615,50.368Z"
                transform="translate(0 -48)"
                fill="#1da1f2"
              />
            </svg>{" "}
            Twitter
          </a>
        </li>
      </ul>
    </div>
  );

  renderPopover5 = (
    e,
    ContactId,
    AtdSimult,
    ExternConf,
    OutBandService,
    PermissionRouter,
    InfoUsers,
    StatusAgent,
    listCallQueue,
    IPCurrent,
  ) => (
    <div id="popover-check-conference">
      <div className="popover">
        <div className="popover__header">
          <span>Conferência</span>
        </div>

        <div className="popover__title">Telefone:</div>
        <div className="popover__body popover__body--full-width">
          <div className="popover-check-conference__inputs">
            <div className="modal__content__form__group modal__content__form__group--col-1">
              <a
                className="info tippy-popover"
                data-tippy-placement="right"
                data-tooltip="País"
                data-template="flags"
              >
                <div
                  className="new-select-with-icons new-select-with-icons--line"
                  tabIndex="1"
                >
                  <div className="new-select-with-icons__option new-select-with-icons__selected">
                    <div className="new-select-with-icons__option__icon">
                      <img src={FLAGBR} width="100%" alt="" />
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div className="modal__content__form__group modal__content__form__group--col-2">
              <div className="modal__content__form__group__input-line">
                <i className="material-icons">call</i>
                <input
                  type="text"
                  id="telefone_conf"
                  name="telefone_conf"
                  ref={(input) => (this.numberToActive = input)}
                  className="modal__content__form__group__input"
                />
              </div>
            </div>

            <TippyPopper2 trigger="click" content={this.renderPopover6(this)}>
              <button
                className="modal__content__form__group__button tippy-popover tippy-context-menu"
                data-tippy-placement="left"
                data-template="modal-contato-conferencia"
                onClick={
                  InfoUsers.enablecall
                    ? (event) =>
                        this.SolicitarConferenciaAtiva(
                          event,
                          PermissionRouter,
                          ContactId.idmidia,
                          OutBandService,
                          InfoUsers,
                          StatusAgent.status,
                          listCallQueue,
                          AtdSimult,
                          IPCurrent,
                          ContactId.idatendimento,
                        )
                    : () => {}
                }
              >
                {" "}
                Adicionar
              </button>
            </TippyPopper2>
          </div>

          {/* ALTERADO DIA 06/04/2023 PARA QDO FOR WEBRTC NÃO APRESENTAR A DIV ABAIXO */}
          {/* ///////AQUIIIII */}

          <div
            className="popover__clientes clts active"
            id="div_list_client_conference"
            style={{ display: connection_platform.client_webrtc ? "none" : "" }}
          >
            <form action="#" className="form-full">
              <div className="full-search">
                <input
                  type="text"
                  name="client-search"
                  id="client-search--popover"
                  placeholder="Pesquise um cliente..."
                />
                <button type="submit">
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </form>
            <div className="list">
              <ul>
                {AtdSimult.map((atend) =>
                  (() => {
                    if (
                      parseInt(atend.idmidia) === parseInt(ContactId.idmidia) &&
                      atend.idatendimento !== ContactId.idatendimento
                    ) {
                      let checkConf = null;

                      ExternConf.map((conf) =>
                        (() => {
                          if (conf.idconferencia === atend.idatendimento) {
                            checkConf = true;
                          }
                        })(),
                      );

                      checkConf === true
                        ? (checkConf = true)
                        : (checkConf = false);

                      return (
                        <li>
                          <div className="photo">
                            <img src={DEFAULT} />
                            <div className="photo__media">
                              <img src={PHONE} alt="" />
                            </div>
                          </div>
                          <div className="data">
                            <div className="name">{atend.cliente}</div>
                          </div>
                          <div className="action">
                            {(() => {
                              if (checkConf === false) {
                                return (
                                  <div className="action__item">
                                    <i
                                      className="material-icons"
                                      onClick={(event) =>
                                        this.AddExternalConference(
                                          ContactId.idatendimento,
                                          atend.idatendimento,
                                          atend.line,
                                          ContactId.serviceatd,
                                          atend.serviceatd,
                                        )
                                      }
                                    >
                                      person_add_alt_1
                                    </i>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="action__item remove">
                                    <i
                                      className="material-icons"
                                      onClick={(event) =>
                                        this.RemoveExternalConference(
                                          ContactId.idatendimento,
                                          atend.idatendimento,
                                          atend.line,
                                          ContactId.serviceatd,
                                          atend.serviceatd,
                                        )
                                      }
                                    >
                                      person_remove
                                    </i>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        </li>
                      );
                    }
                  })(),
                )}
              </ul>
            </div>
          </div>

          {/* ///////AQUIIIII */}

          <div className="popover__atendentes atd">
            <form action="#" className="form-full">
              <div className="full-search">
                <input
                  type="text"
                  name="client-search"
                  id="client-search--popover"
                  placeholder="Pesquise um atendente..."
                />
                <button type="submit">
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </form>
            <div className="list">
              <ul>
                {/* <!-- ITEM --> */}
                <li>
                  <div className="photo"></div>
                  <div className="data">
                    <div className="name">Roberto Assis Barbosa</div>
                    <div className="info">
                      <span>
                        <strong>Ramal:</strong> 5555
                      </span>
                      <span>
                        <strong>Grupo:</strong> Telemarketing
                      </span>
                      <span>
                        <strong>Atendendo:</strong> André Luiz Batista Santana
                        de Aureliano
                      </span>
                    </div>
                  </div>
                  <div className="action">
                    <div
                      className="action__item tippy-default"
                      alt="Consultar por voz"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      <i className="material-icons">phone</i>
                    </div>

                    <div
                      className="action__item tippy-default"
                      alt="Encaminhar"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    ></div>
                  </div>
                </li>
                {/* <!-- END ITEM -->
                      <!-- ITEM --> */}
                <li>
                  <div className="photo"></div>
                  <div className="data">
                    <div className="name">Roberto Assis Barbosa</div>
                    <div className="info">
                      <span>
                        <strong>Ramal:</strong> 5555
                      </span>
                      <span>
                        <strong>Grupo:</strong> Telemarketing
                      </span>
                      <span>
                        <strong>Atendendo:</strong> André Luiz Batista Santana
                        de Aureliano
                      </span>
                    </div>
                  </div>
                  <div className="action">
                    <div
                      className="action__item tippy-default"
                      alt="Consultar por voz"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      <i className="material-icons">phone</i>
                    </div>

                    <div
                      className="action__item tippy-default"
                      alt="Encaminhar"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      {/* <?php include 'build/images/account-arrow-right.svg'; ?> */}
                    </div>
                  </div>
                </li>
                {/* <!-- END ITEM -->

                      <!-- ITEM --> */}
                <li>
                  <div className="photo"></div>
                  <div className="data">
                    <div className="name">Roberto Assis Barbosa</div>
                    <div className="info">
                      <span>
                        <strong>Ramal:</strong> 5555
                      </span>
                      <span>
                        <strong>Grupo:</strong> Telemarketing
                      </span>
                      <span>
                        <strong>Atendendo:</strong> André Luiz Batista Santana
                        de Aureliano
                      </span>
                    </div>
                  </div>
                  <div className="action">
                    <div
                      className="action__item tippy-default"
                      alt="Consultar por voz"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      <i className="material-icons">phone</i>
                    </div>

                    <div
                      className="action__item tippy-default"
                      alt="Encaminhar"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      {/* <?php include 'build/images/account-arrow-right.svg'; ?> */}
                    </div>
                  </div>
                </li>
                {/* <!-- END ITEM -->
                      <!-- ITEM --> */}
                <li>
                  <div className="photo"></div>
                  <div className="data">
                    <div className="name">Roberto Assis Barbosa</div>
                    <div className="info">
                      <span>
                        <strong>Ramal:</strong> 5555
                      </span>
                      <span>
                        <strong>Grupo:</strong> Telemarketing
                      </span>
                      <span>
                        <strong>Atendendo:</strong> André Luiz Batista Santana
                        de Aureliano
                      </span>
                    </div>
                  </div>
                  <div className="action">
                    <div
                      className="action__item tippy-default"
                      alt="Consultar por voz"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      <i className="material-icons">phone</i>
                    </div>

                    <div
                      className="action__item tippy-default"
                      alt="Encaminhar"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      {/* <?php include 'build/images/account-arrow-right.svg'; ?> */}
                    </div>
                  </div>
                </li>
                {/* <!-- END ITEM -->
                      <!-- ITEM --> */}
                <li>
                  <div className="photo"></div>
                  <div className="data">
                    <div className="name">Roberto Assis Barbosa</div>
                    <div className="info">
                      <span>
                        <strong>Ramal:</strong> 5555
                      </span>
                      <span>
                        <strong>Grupo:</strong> Telemarketing
                      </span>
                      <span>
                        <strong>Atendendo:</strong> André Luiz Batista Santana
                        de Aureliano
                      </span>
                    </div>
                  </div>
                  <div className="action">
                    <div
                      className="action__item tippy-default"
                      alt="Consultar por voz"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      <i className="material-icons">phone</i>
                    </div>

                    <div
                      className="action__item tippy-default"
                      alt="Encaminhar"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      {/* <?php include 'build/images/account-arrow-right.svg'; ?> */}
                    </div>
                  </div>
                </li>
                {/* <!-- END ITEM -->
                      <!-- ITEM --> */}
                <li>
                  <div className="photo"></div>
                  <div className="data">
                    <div className="name">Roberto Assis Barbosa</div>
                    <div className="info">
                      <span>
                        <strong>Ramal:</strong> 5555
                      </span>
                      <span>
                        <strong>Grupo:</strong> Telemarketing
                      </span>
                      <span>
                        <strong>Atendendo:</strong> André Luiz Batista Santana
                        de Aureliano
                      </span>
                    </div>
                  </div>
                  <div className="action">
                    <div
                      className="action__item tippy-default"
                      alt="Consultar por voz"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      <i className="material-icons">phone</i>
                    </div>

                    <div
                      className="action__item tippy-default"
                      alt="Encaminhar"
                      data-tippy-placement="bottom"
                      data-tippy-content="Consultar por voz"
                    >
                      {/* <?php include 'build/images/account-arrow-right.svg'; ?> */}
                    </div>
                  </div>
                </li>
                {/* <!-- END ITEM --> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  renderPopover3 = (e, ContactId, InfoUsers) => (
    <div id="popover-add-note">
      {/* <span className="add-note__wrapper"> */}
      <div className="block-header__add-note-box add-note">
        <div className="block-header__add-note-content">
          <div className="add-note__header">Adicionar anotação</div>
          <div className="add-note__content">
            <div
              className={
                this.state.SaveSucess2
                  ? "add-note__content--secondary active"
                  : "add-note__content--secondary"
              }
            >
              <div className="add-note__block is-4">
                <img src={SUCESS} alt="" className="add-note__img" />
                <p className="add-note__text is-blue is-20 is-poppins mg-top-10">
                  Sua anotação foi salva
                  <em className="is-poppins is-poppins--bold"> com sucesso!</em>
                </p>
              </div>
              <div className="add-note__block is-1">
                <a
                  className="add-note__btn add-note__btn--back add-note__btn--blue pd-top-10"
                  onClick={this.ReturnSaveSucess2.bind(this)}
                >
                  Voltar para o chat
                </a>
              </div>
            </div>
            <div className="add-note__content--main">
              <div className="add-note__block is-4">
                <textarea
                  className="add-note__textarea"
                  name="add-note-text"
                  id="add-note-text"
                  ref={(input) => (this.comentarioAnotacoes = input)}
                ></textarea>
              </div>
              <div className="add-note__block is-1">
                {/* <div
                  onClick={this.DisplayAnotations.bind(this)}
                  className={
                    this.state.buttonAnotations
                      ? "select with-icons add-note__reset active"
                      : "select with-icons add-note__reset"
                  }
                > */}
                {/* <button
                    className={
                      this.state.buttonActive
                        ? "select-btn active"
                        : "select-btn"
                    }
                    className="select__btn"
                    type="button"
                    data-pausa="Criticidade da anotação"
                  >
                    <span
                      className={"add-note__dot " + this.state.iconeCriticidade}
                    >
                      •
                    </span>
                    {this.state.criticidadeSelec}
                    <i className="select__icon material-icons">
                      keyboard_arrow_left
                    </i>
                  </button> */}
                {/* <div className="options">
                    <ul className="add-note__list">
                      {this.state.DescAnotacoes.map(desc => (
                        <li
                          key={desc.id}
                          className="add-note__item"
                          onClick={this.DisplayCriticidade.bind(
                            this,
                            desc.description,
                            desc.id,
                            desc.class_criticality
                          )}
                        >
                          <a
                            className="add-note__link"
                            data-pausa="Criticidade"
                          >
                            <span
                              className={
                                "add-note__dot " + desc.class_criticality
                              }
                            >
                              •
                            </span>{" "}
                            {desc.description}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div> */}
                <Select
                  isLoading={false}
                  onChange={this.handleCriticality}
                  isClearable={true}
                  isRtl={false}
                  styles={colourStyles}
                  className="select with-icons add-note__reset"
                  id="options"
                  options={options}
                  classNamePrefix=""
                  defaultValue={""}
                />
                {/* </div> */}
              </div>
              <div className="add-note__block is-1">
                <div className="add-note__btn-box">
                  <button
                    className="add-note__btn add-note__btn--save add-note__btn--blue"
                    onClick={(event) =>
                      this.SaveAnotation2(event, ContactId, InfoUsers)
                    }
                  >
                    Salvar anotação
                  </button>
                  <button
                    className="add-note__btn add-note__btn--cancel"
                    onClick={(event) => this.ClosePopovers(event)}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </span> */}
    </div>
  );

  renderPopover4 = (e) => (
    <div className="context-menu emoji-container" id="emoji-container">
      <div className="context-menu__list">
        <Picker
          onSelect={this.addEmoji}
          set="google"
          showPreview={false}
          showSkinTones={false}
          skin="1"
          autoFocus={true}
          i18n={{
            search: "Buscar um emoji",
            clear: "Limpar", // Accessible label on "clear" button
            notfound: "Nenhum emoji encontrado",
            skintext: "Default Skin Tone",
            skintones: {
              1: "Light Skin Tone",
            },
            categories: {
              search: "Resultados da busca",
              recent: "Recentes",
              smileys: "Emojis e Pessoas",
              people: "Emojis e Pessoas",
              nature: "Animais e natureza",
              foods: "Comida e Bebida",
              activity: "Atividades",
              places: "Viagens & Locais",
              objects: "Objetos",
              symbols: "Símbolos",
              flags: "Bandeiras",
              custom: "Custom",
            },
          }}
        />
      </div>
    </div>
  );

  handleClick() {
    this.setState((state) => ({
      activeconsulta: !state.activeconsulta,
      searchText: "",
    }));
  }

  handleSearchReduce(withValue) {
    this.setState((state) => ({
      activeconsulta: true,
      searchText: withValue,
    }));
  }

  MoreChats(e) {
    e.preventDefault();
    this.setState({ buttonMore: !this.state.buttonMore });
  }

  DisplayQuickAnswer(e) {
    e.preventDefault();
    this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    // const { RespostasRapidas } = this.props;
    // this.state.respostasinicial = RespostasRapidas.respostas;
    // this.state.respostas = this.state.respostasinicial;
    // this.setState({ messageQuickAnswer: "", variableQuickAnwser: [] });
    // if (this.state.buttonQuickAnswer) {
    //   document.getElementById("input-msgs-rapidas").value = "";
    //   this.setState({ searchQuickMsg: "" });
    // }
  }

  InsertQuickAnswer(
    event,
    texto,
    editable,
    mimetypeid,
    filepath,
    InfoUsers,
    ContactId,
    resp,
  ) {
    event.preventDefault();

    let textReceived = texto;
    let checksocialname = texto.indexOf(`{SYS.SOCIALNAME}`);
    let checkNumProtocol = texto.indexOf(`{SYS.PROTOCOLO}`);
    let checkvalueSName = false;
    this.setState({ isHSM: false });
    this.setState({ editableQuickAnswer: false });

    const nomeCompleto = ContactId.cliente ? ContactId.cliente.trim() : "";
    const nomesArray = nomeCompleto.split(" ");
    const primeiroNome = nomesArray[0] || "";
    const ultimoNome =
      nomesArray.length > 1 ? nomesArray[nomesArray.length - 1] : "";

    let checkvalueSProtocol = false;
    console.log("INGENIUM_MSGTEXTO : ");
    if (checksocialname > 0) {
      checkvalueSName = true;
    } else {
      checkvalueSName = false;
    }

    if (checkNumProtocol > 0) {
      checkvalueSProtocol = true;
    } else {
      checkvalueSProtocol = false;
    }

    let checknomeagente = texto.indexOf(`{SYS.NOMEAGENTE}`);

    let checkvalueNAgent = false;
    if (checknomeagente > 0) {
      checkvalueNAgent = true;
    } else {
      checkvalueNAgent = false;
    }

    texto = texto.replace(
      /\${SYS\.SOCIALNAME}/g,
      createJSON(ContactId.cliente.trim()),
    );
    texto = texto.replace(
      /\${SYS\.PRIMEIRONOMECLIENTE}/g,
      createJSON(primeiroNome),
    );
    texto = texto.replace(
      /\${SYS\.CLIENTFIRSTNAME}/g,
      createJSON(primeiroNome),
    );
    texto = texto.replace(
      /\${SYS\.ULTIMONOMECLIENTE}/g,
      createJSON(ultimoNome),
    );
    texto = texto.replace(/\${SYS\.CLIENTLASTNAME}/g, createJSON(ultimoNome));
    texto = texto.replace(
      /\${SYS\.NOMEAGENTE}/g,
      createJSON(InfoUsers.displayname.trim()),
    );
    texto = texto.replace(
      /\${SYS\.LOGINAGENTE}/g,
      createJSON(InfoUsers.username.trim()),
    );
    const saudacao = saudacaoPorHorario();
    texto = texto.replace(/\${SYS\.GREETING}/g, createJSON(saudacao));
    texto = texto.replace(/\${SYS\.SAUDACAO}/g, createJSON(saudacao));

    if (this.props.NpsDetails.length !== 0) {
      const filterNpsClientDetails = this.props.NpsDetails.filter(
        (nps) => nps.numero_cliente === this.props.ContactId.telefone,
      );

      if (filterNpsClientDetails.length !== 0) {
        texto = texto.replace(
          /\${CAMP\.NOMECLIENTE}/g,
          createJSON(filterNpsClientDetails[0].nome_cliente),
        );
      }
    }

    if (checkvalueSProtocol && ContactId.protocolo) {
      texto = texto.replace(
        /\${SYS\.PROTOCOLO}/g,
        createJSON(ContactId.protocolo.trim()),
      );
    }

    try {
      let regex = new RegExp("{(.*?)}", "g");
      let result;
      let array = [];

      while ((result = regex.exec(textReceived))) {
        let value = result[1];

        value = value.replace(
          /SYS\.SOCIALNAME/g,
          createJSON(ContactId.cliente.trim()),
        );
        value = value.replace(
          /SYS\.PRIMEIRONOMECLIENTE/g,
          createJSON(primeiroNome),
        );
        value = value.replace(
          /SYS\.CLIENTFIRSTNAME/g,
          createJSON(primeiroNome),
        );
        value = value.replace(
          /SYS\.ULTIMONOMECLIENTE/g,
          createJSON(ultimoNome),
        );
        value = value.replace(/SYS\.CLIENTLASTNAME/g, createJSON(ultimoNome));
        value = value.replace(
          /SYS\.NOMEAGENTE/g,
          createJSON(InfoUsers.displayname.trim()),
        );
        value = value.replace(
          /SYS\.LOGINAGENTE/g,
          createJSON(InfoUsers.username.trim()),
        );

        value = value.replace(/SYS\.GREETING/g, createJSON(saudacao));
        value = value.replace(/SYS\.SAUDACAO/g, createJSON(saudacao));

        if (this.props.NpsDetails.length !== 0) {
          const filterNpsClientDetails = this.props.NpsDetails.filter(
            (nps) => nps.numero_cliente === this.props.ContactId.telefone,
          );
          if (filterNpsClientDetails.length !== 0) {
            value = value.replace(
              /CAMP\.NOMECLIENTE/g,
              createJSON(filterNpsClientDetails[0].nome_cliente),
            );
          }
        }

        if (ContactId.protocolo) {
          value = value.replace(
            /SYS\.PROTOCOLO/g,
            createJSON(ContactId.protocolo.trim()),
          );
        }
        array.push({
          id: result[1],
          name: result[1],
          value: value === result[1] ? "${" + value + "}" : value,
        }); // mostra o que está entre os :
      }

      if (
        array.length !== 0 &&
        (mimetypeid >= 30 || mimetypeid === 1) &&
        editable === true
      ) {
        MicroModal.show("modal__mensagens-predefinidas-attendance");
        this.setState({
          messageQuickAnswer: textReceived,
          variableQuickAnwser: array,
        });
      }
    } catch {
      console.log("ERROR");
    }

    document.getElementById("chat-message").innerText = texto;
    this.props.editMsg(texto, ContactId.idatendimento);

    if (mimetypeid != 1) {
      if (mimetypeid >= 30 && mimetypeid <= 38) {
        this.setState({
          isHSM: true,
          paramsHSM: resp,
          checkparam: checkvalueSName,
          checkparam2: checkvalueNAgent,
        });

        if (mimetypeid === 38 || mimetypeid === 31) {
          let arrayfile = [filepath, texto, mimetypeid];
          this.setState({ fileasw: [] });
          this.setState({ fileasw: arrayfile });
        }
      } else {
        let gerarnomearquivo = makeid(32);
        let photo = {
          uri: filepath,
          type: "application/pdf",
          name: gerarnomearquivo + ".pdf",
        };
        let fileencryp = new FormData();
        fileencryp.append("file", gerarnomearquivo + ".pdf");
        //fileencryp.append('file', photo, gerarnomearquivo+".pdf");
        let arrayfile = [filepath, texto, mimetypeid];
        this.setState({ fileasw: [] });
        this.setState({ fileasw: arrayfile });
      }
    } else {
      this.setState({ fileasw: [] });
    }
    if (editable == false) {
      document.getElementById("chat-message").disabled = true;
      document.getElementById("chat-message").contentEditable = false;
      this.setState({ editableQuickAnswer: true });
    } else {
      document.getElementById("chat-message").disabled = false;
      document.getElementById("chat-message").contentEditable = true;
      document.getElementById("chat-message").focus();
    }
    this.setState({
      buttonQuickAnswer: !this.state.buttonQuickAnswer,
      searchQuickMsg: "",
    });
    document.getElementById("input-msgs-rapidas").value = "";

    //this.setState({ fileasw: [] });
  }

  cancelQuickAnswer() {
    document.getElementById("chat-message").contentEditable = true;
    document.getElementById("chat-message").focus();
    document.getElementById("chat-message").innerHTML = "";
    this.setState({ editableQuickAnswer: false });
  }

  async ButtonSendMessage(event, author, InfoUsers, ContactId, typemsg) {
    event.preventDefault();
    document.getElementById("chat-message").disabled = false;
    document.getElementById("chat-message").contentEditable = true;

    let msgweb = document.getElementById("chat-message").innerText;
    let msgsocket = document.getElementById("chat-message").innerText;

    let infosendfile = this.state.fileasw;

    if (
      this.state.fileasw != null &&
      infosendfile[2] != 1 &&
      infosendfile.length > 0
    ) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgweb = msgweb.replace(/"/gm, '\\"');
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      msgsocket = msgsocket.replace(/"/gm, '\\"');

      //valorInput = "";
      let str = msgweb.replace(/\s/g, "");
      let callid = makeid(32);

      if (str != "") {
        if (this.state.headerMessage.length > 0 && !this.state.isHSM) {
          let findChecked = this.props.ActiveHeader.find(
            (header) => header.label === this.props.ContactId.telefone,
          );
          if (
            findChecked &&
            findChecked.active &&
            this.props.InfoUsers.variables_integration
          ) {
            let infos = this.state.headerMessage[0].header;
            const items = this.props.InfoUsers.variables_integration.split(",");
            let headerMsg = "";
            for (let index = 0; index < items.length; index++) {
              let label = "";
              if (items[index] === "codigo_ticket") {
                label = "Número do caso";
              } else {
                label =
                  items[index].substring(0, 1).toUpperCase() +
                  items[index].substring(1).toLowerCase();
              }

              if (index === items.length - 1) {
                headerMsg =
                  headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
              } else {
                headerMsg =
                  headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
              }
            }
            // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
            // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
            msgweb = headerMsg + msgweb;
            msgsocket = headerMsg + msgsocket;
          }
        }

        if (this.state.isHSM) {
          let opcoes = "";
          if (this.state.paramsHSM.buttons_or_list) {
            const options = `[${this.state.paramsHSM.buttons_or_list}]`;
            const parse = JSON.parse(options);
            const buttonsFormated = [];
            for (const btn of parse) {
              const objBtn = {
                payload: btn.payload.index,
                text: btn.payload.value,
              };

              buttonsFormated.push(objBtn);
            }
            opcoes = JSON.stringify(buttonsFormated).replace(/"/gi, "'");
          }
          // this.props.sendFileAswSocket(
          //   InfoUsers,
          //   ContactId,
          //   infosendfile[0],
          //   msgweb,
          //   callid
          // );

          this.props.sendImageAsw(
            callid,
            msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            2,
            "hsm" + "§" + opcoes,
          );

          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgweb = msgweb.replace(/"/gm, '\\"');

          msgsocket = msgsocket.trim();
          // msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          msgsocket = msgsocket.replace(/"/gm, '\\"');

          if (InfoUsers.attach_sender_name && !this.state.isHSM) {
            msgweb = `*` + InfoUsers.displayname + `:*¿` + msgweb;
            msgsocket = `*` + InfoUsers.displayname + `:*¿` + msgsocket;
            console.log("INGENIUM_MSGTEXTO : ", msgweb);
            console.log("INGENIUM_MSGTEXTO : ", msgsocket);
          }

          this.props.InviteMessagesNew(
            callid,
            msgweb,
            "Me",
            InfoUsers,
            ContactId,
            typemsg,
            msgsocket,
            "url",
            this.state.isHSM,
            this.state.paramsHSM,
            this.state.showreplyopNew[this.props.ContactId.idatendimento]
              ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
              : 0,
            // this.state.idreplyop,
            this.state.checkparam,
            this.state.checkparam2,
            this.state.variableQuickAnwser,
          );
        } else {
          this.props.sendFileAswSocket(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            callid,
          );

          this.props.sendImageAsw(
            callid,
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            1,
          );
        }

        this.setState({ isHSM: false });
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      var img = document.getElementById("contein");
      let callid = makeid(32);
      if (
        img.currentSrc !== "" &&
        img.currentSrc !== null &&
        img.currentSrc !== "null"
      ) {
        var blobImage = await createFile(img.currentSrc);
        this.handleCreateFileSplit(blobImage, InfoUsers, ContactId);
        var parentElement = img.parentNode;
        parentElement.removeChild(img);
        var newElement = document.createElement("img");
        newElement.id = "contein";
        newElement.width = "150";
        newElement.style.display = "none";
        parentElement.appendChild(newElement);
        blobImage = [];
      } else {
        if (str != "") {
          //valorInput = "";
          let opcoes = "";

          if (this.state.isHSM) {
            if (this.state.paramsHSM.buttons_or_list) {
              const options = `[${this.state.paramsHSM.buttons_or_list}]`;
              const parse = JSON.parse(options);
              const buttonsFormated = [];
              for (const btn of parse) {
                const objBtn = {
                  payload: btn.payload.index,
                  text: btn.payload.value,
                };

                buttonsFormated.push(objBtn);
              }
              opcoes = JSON.stringify(buttonsFormated).replace(/"/gi, "'");
            }
          }

          if (this.state.headerMessage.length > 0 && !this.state.isHSM) {
            let findChecked = this.props.ActiveHeader.find(
              (header) => header.label === this.props.ContactId.telefone,
            );

            if (
              findChecked &&
              findChecked.active &&
              this.props.InfoUsers.variables_integration
            ) {
              let infos = this.state.headerMessage[0].header;
              const items =
                this.props.InfoUsers.variables_integration.split(",");
              let headerMsg = "";
              for (let index = 0; index < items.length; index++) {
                let label = "";
                if (items[index] === "codigo_ticket") {
                  label = "Número do caso";
                } else {
                  label =
                    items[index].substring(0, 1).toUpperCase() +
                    items[index].substring(1).toLowerCase();
                }

                if (index === items.length - 1) {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
                } else {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
                }
              }
              // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
              // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
              msgweb = headerMsg + msgweb;
              msgsocket = headerMsg + msgsocket;
            }
          }

          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgweb = msgweb.replace(/"/gm, '\\"');

          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          msgsocket = msgsocket.replace(/"/gm, '\\"');
          console.log("INGENIUM_MSGTEXTO_SEND_8 : ");

          if (InfoUsers.attach_sender_name && !this.state.isHSM) {
            msgweb = `*` + InfoUsers.displayname + `:*¿` + msgweb;
            msgsocket = `*` + InfoUsers.displayname + `:*¿` + msgsocket;
            console.log("INGENIUM_MSGTEXTO : ", msgweb);
            console.log("INGENIUM_MSGTEXTO : ", msgsocket);
          }

          this.props.InviteMessage(
            callid,
            msgweb,
            "Me",
            InfoUsers,
            ContactId,
            this.state.isHSM ? "2" : typemsg,
            msgsocket,
            "url",
            this.state.isHSM,
            this.state.paramsHSM,
            this.state.showreplyopNew[this.props.ContactId.idatendimento]
              ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
              : 0,
            // this.state.idreplyop,
            this.state.checkparam,
            this.state.checkparam2,
            this.state.variableQuickAnwser,
            "hsm" + "§" + opcoes,
          );

          this.setState({ isHSM: false });
        }

        if (mensagemretorno[ContactId.idatendimento] != true) {
          this.props.refreshReturnAtd(1, ContactId.telefone);
          mensagemretorno[ContactId.idatendimento] = true;
        }
        if (mensagemenviada[ContactId.idatendimento] != true) {
          this.props.editAtendimentoAgent(ContactId.idatendimento);
          mensagemenviada[ContactId.idatendimento] = true;
        }
      }
    }
    this.scrollDown();

    document.getElementById("chat-message").innerHTML = "";
    const hasTextInTextMessage = !!textMessage[ContactId.idatendimento];
    if (hasTextInTextMessage) {
      textMessage[ContactId.idatendimento] = "";
    } else if (!!textMessage[parseInt(ContactId.idatendimento)]) {
      textMessage[parseInt(ContactId.idatendimento)] = "";
    }
    this.setState({ fileasw: [] });
    // this.setState({ idreplyop: 0, showreplyop: false });
    this.clearReplyToThisCdr();
    this.setState({ editableQuickAnswer: false });
  }

  DisplayAnotations(e) {
    e.preventDefault();
    this.setState({ buttonAnotations: !this.state.buttonAnotations });
  }

  DisplayCriticidade(desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      criticidadeSelec: desccriticidade,
      iconeCriticidade: tipocriticidade,
      idCriticidadeSelec: idcriticidade,
    });
  }

  handleKeyPress = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  handleKeyDown = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  removeFilesFromStageAreaOfThisAtt(ContactId) {
    const filesOfThissAtt = this.state.filesInStage.filter((filterFile) => {
      return (
        filterFile.idAtendimento === ContactId.idatendimento ||
        parseInt(filterFile.idAtendimento) === parseInt(ContactId.idatendimento)
      );
    });

    const filesWithoutFilesSended = [...this.state.filesInStage].filter(
      (fileData) => {
        return !filesOfThissAtt.some((fileOfThisAtt) => {
          return (
            fileOfThisAtt.idAtendimento === fileData.idAtendimento ||
            parseInt(fileOfThisAtt.idAtendimento) ===
              parseInt(fileData.idAtendimento)
          );
        });
      },
    );
    this.setState({
      filesInStage: filesWithoutFilesSended,
    });
  }

  sendFileFromStageArea(ContactId, InfoUsers) {
    const filesOfThissAtt = this.state.filesInStage.filter((filterFile) => {
      return (
        filterFile.idAtendimento === ContactId.idatendimento ||
        parseInt(filterFile.idAtendimento) === parseInt(ContactId.idatendimento)
      );
    });
    const files = filesOfThissAtt.map((fileData) => {
      return fileData.file;
    });
    this.handleselectedFileOnDrop(files, InfoUsers, ContactId);
    const filesWithoutFilesSended = [...this.state.filesInStage].filter(
      (fileData) => {
        return !filesOfThissAtt.some((fileOfThisAtt) => {
          return (
            fileOfThisAtt.idAtendimento === fileData.idAtendimento ||
            parseInt(fileOfThisAtt.idAtendimento) ===
              parseInt(fileData.idAtendimento)
          );
        });
      },
    );
    this.setState({
      filesInStage: filesWithoutFilesSended,
    });
  }

  async handleOnChange(
    event,
    InfoUsers,
    ContactId,
    hasFilesInStageArea = false,
  ) {
    let msgsave = document.getElementById("chat-message").innerText;
    let blob = [];
    this.setState({ editableQuickAnswer: false });
    event.preventDefault();

    if (event.key === "Enter" && event.shiftKey === false) {
      if (hasFilesInStageArea) {
        this.sendFileFromStageArea(ContactId, InfoUsers);
        return;
      }
      let teste = document.getElementsByClassName("chat-message");
      let msgweb = document.getElementById("chat-message").innerText;

      let msgsocket = document.getElementById("chat-message").innerText;
      document.getElementById("chat-message").contentEditable = true;
      let infosendfile = this.state.fileasw;

      if (
        this.state.fileasw != null &&
        infosendfile[2] != 1 &&
        infosendfile.length > 0
      ) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgweb = msgweb.replace(/"/gm, '\\"');
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        msgsocket = msgsocket.replace(/"/gm, '\\"');
        let str = msgweb.replace(/\s/g, "");
        //valorInput = "";
        if (str != "") {
          if (this.state.headerMessage.length > 0) {
            let findChecked = this.props.ActiveHeader.find(
              (header) => header.label === this.props.ContactId.telefone,
            );

            if (
              findChecked &&
              findChecked.active &&
              this.props.InfoUsers.variables_integration
            ) {
              let infos = this.state.headerMessage[0].header;
              const items =
                this.props.InfoUsers.variables_integration.split(",");
              let headerMsg = "";
              for (let index = 0; index < items.length; index++) {
                let label = "";
                if (items[index] === "codigo_ticket") {
                  label = "Número do caso";
                } else {
                  label =
                    items[index].substring(0, 1).toUpperCase() +
                    items[index].substring(1).toLowerCase();
                }

                if (index === items.length - 1) {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
                } else {
                  headerMsg =
                    headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
                }
              }
              // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
              // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
              msgweb = headerMsg + msgweb;
              msgsocket = headerMsg + msgsocket;
            }
          }

          this.props.sendFileAswSocket(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            makeid(32),
          );
          this.props.sendImageAsw(
            makeid(32),
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            1,
          );
        }
        document.getElementById("chat-message").innerHTML = "";
        const hasTextInTextMessage = !!textMessage[ContactId.idatendimento];
        if (hasTextInTextMessage) {
          textMessage[ContactId.idatendimento] = "";
        } else if (!!textMessage[parseInt(ContactId.idatendimento)]) {
          textMessage[parseInt(ContactId.idatendimento)] = "";
        }
        this.scrollDown();
        this.props.sendtyping(0, InfoUsers, ContactId);
        this.setState({ fileasw: [] });
      } else {
        console.log("INGENIUM_MSGTEXTO_CHAT : ", msgweb);
        let str = msgweb.replace(/\s/g, "");
        var img = document.getElementById("contein");
        if (
          img.currentSrc !== "" &&
          img.currentSrc !== null &&
          img.currentSrc !== "null"
        ) {
          var blobImage = await createFile(img.currentSrc);
          this.handleCreateFileSplit(blobImage, InfoUsers, ContactId);
          var parentElement = img.parentNode;
          parentElement.removeChild(img);
          var newElement = document.createElement("img");
          newElement.id = "contein";
          newElement.width = "150";
          newElement.style.display = "none";
          parentElement.appendChild(newElement);
          blobImage = [];
        } else {
          if (str != "") {
            if (this.state.headerMessage.length > 0) {
              let findChecked = this.props.ActiveHeader.find(
                (header) => header.label === this.props.ContactId.telefone,
              );

              if (
                findChecked &&
                findChecked.active &&
                this.props.InfoUsers.variables_integration
              ) {
                let infos = this.state.headerMessage[0].header;
                const items =
                  this.props.InfoUsers.variables_integration.split(",");
                let headerMsg = "";
                for (let index = 0; index < items.length; index++) {
                  let label = "";
                  if (items[index] === "codigo_ticket") {
                    label = "Número do caso";
                  } else {
                    label =
                      items[index].substring(0, 1).toUpperCase() +
                      items[index].substring(1).toLowerCase();
                  }

                  if (index === items.length - 1) {
                    headerMsg =
                      headerMsg +
                      `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
                  } else {
                    headerMsg =
                      headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
                  }
                }
                // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
                // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
                msgweb = headerMsg + msgweb;
                msgsocket = headerMsg + msgsocket;
              }
            }

            this.setState({ fileasw: [] });
            msgweb = msgweb.trim();
            msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
            msgweb = msgweb.replace(/"/gm, '\\"');
            msgsocket = msgsocket.trim();
            msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
            msgsocket = msgsocket.replace(/"/gm, '\\"');

            console.log("INGENIUM_MSGTEXTO : ", InfoUsers);
            console.log("INGENIUM_MSGTEXTO : ", msgweb);
            console.log("INGENIUM_MSGTEXTO : ", msgsocket);

            if (InfoUsers.attach_sender_name) {
              msgweb = `*` + InfoUsers.displayname + `:*¿` + msgweb;
              msgsocket = `*` + InfoUsers.displayname + `:*¿` + msgsocket;
              console.log("INGENIUM_MSGTEXTO : ", msgweb);
              console.log("INGENIUM_MSGTEXTO : ", msgsocket);
            }
            //valorInput = "";

            this.props.InviteMessage(
              makeid(32),
              msgweb,
              "Me",
              InfoUsers,
              ContactId,
              "0",
              msgsocket,
              "url",
              this.state.isHSM,
              this.state.paramsHSM,
              this.state.showreplyopNew[this.props.ContactId.idatendimento]
                ? this.state.showreplyopNew[this.props.ContactId.idatendimento]
                : 0,
              // this.state.idreplyop,
              this.state.checkparam,
              this.state.checkparam2,
              this.state.variableQuickAnwser,
            );
            if (this.state.isHSM === true) this.setState({ isHSM: false });
          }
        }
        document.getElementById("chat-message").innerHTML = "";
        const hasTextInTextMessage = !!textMessage[ContactId.idatendimento];
        if (hasTextInTextMessage) {
          textMessage[ContactId.idatendimento] = "";
        } else if (!!textMessage[parseInt(ContactId.idatendimento)]) {
          textMessage[parseInt(ContactId.idatendimento)] = "";
        }
        this.scrollDown();
        this.props.sendtyping(0, InfoUsers, ContactId);
        if (mensagemretorno[ContactId.idatendimento] != true) {
          this.props.refreshReturnAtd(1, ContactId.telefone);
          mensagemretorno[ContactId.idatendimento] = true;
        }
        if (mensagemenviada[ContactId.idatendimento] != true) {
          this.props.editAtendimentoAgent(ContactId.idatendimento);
          mensagemenviada[ContactId.idatendimento] = true;
        }
      }
      // this.setState({ idreplyop: 0, showreplyop: false });
      this.clearReplyToThisCdr();
    } else {
      //COMENTADO PARA CHECAGEM DE USO DE LENTIDAO NA DIGITAÇÃO 2023-11-10
      //this.props.sendtyping(1, InfoUsers, ContactId);

      textMessage[ContactId.idatendimento] = msgsave;
      if (this.state.isHSM === true) this.setState({ isHSM: false });
    }
  }

  //##### ANTIGA FUNÇÃO PARA ENVIAR MENSAGEM AO APERTAR ENTER ##############
  // async handleOnChange(event, InfoUsers, ContactId) {
  //   let msgsave = document.getElementById("chat-message").innerText;
  //   let blob = [];
  //   this.setState({ editableQuickAnswer: false });
  //   event.preventDefault();

  //   if (event.key === "Enter" && event.shiftKey === false) {
  //     console.log("raimundo_neto 4346");
  //     let teste = document.getElementsByClassName("chat-message");
  //     let msgweb = document.getElementById("chat-message").innerText;

  //     let msgsocket = document.getElementById("chat-message").innerText;
  //     document.getElementById("chat-message").contentEditable = true;
  //     let infosendfile = this.state.fileasw;

  //     if (
  //       this.state.fileasw != null &&
  //       infosendfile[2] != 1 &&
  //       infosendfile.length > 0
  //     ) {
  //       msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
  //       msgweb = msgweb.replace(/"/gm, '\\"');
  //       msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
  //       msgsocket = msgsocket.replace(/"/gm, '\\"');
  //       let str = msgweb.replace(/\s/g, "");
  //       //valorInput = "";
  //       if (str != "") {
  //         if (this.state.headerMessage.length > 0) {
  //           let findChecked = this.props.ActiveHeader.find(
  //             (header) => header.label === this.props.ContactId.telefone
  //           );

  //           if (
  //             findChecked &&
  //             findChecked.active &&
  //             this.props.InfoUsers.variables_integration
  //           ) {
  //             let infos = this.state.headerMessage[0].header;
  //             const items =
  //               this.props.InfoUsers.variables_integration.split(",");
  //             let headerMsg = "";
  //             for (let index = 0; index < items.length; index++) {
  //               let label = "";
  //               if (items[index] === "codigo_ticket") {
  //                 label = "Número do caso";
  //               } else {
  //                 label =
  //                   items[index].substring(0, 1).toUpperCase() +
  //                   items[index].substring(1).toLowerCase();
  //               }

  //               if (index === items.length - 1) {
  //                 headerMsg =
  //                   headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
  //               } else {
  //                 headerMsg =
  //                   headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
  //               }
  //             }
  //             // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
  //             // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
  //             msgweb = headerMsg + msgweb;
  //             msgsocket = headerMsg + msgsocket;
  //           }
  //         }

  //         this.props.sendFileAswSocket(
  //           InfoUsers,
  //           ContactId,
  //           infosendfile[0],
  //           msgweb,
  //           makeid(32)
  //         );
  //         this.props.sendImageAsw(
  //           makeid(32),
  //           " ~¿" + msgweb + "~¿" + infosendfile[0],
  //           "Me",
  //           InfoUsers,
  //           ContactId,
  //           1
  //         );
  //       }
  //       document.getElementById("chat-message").innerHTML = "";
  //       this.scrollDown();
  //       this.props.sendtyping(0, InfoUsers, ContactId);
  //       this.setState({ fileasw: [] });
  //     } else {
  //       let str = msgweb.replace(/\s/g, "");
  //       var img = document.getElementById("contein");
  //       if (
  //         img.currentSrc !== "" &&
  //         img.currentSrc !== null &&
  //         img.currentSrc !== "null"
  //       ) {
  //         var blobImage = await createFile(img.currentSrc);
  //         this.handleCreateFileSplit(blobImage, InfoUsers, ContactId);
  //         var parentElement = img.parentNode;
  //         parentElement.removeChild(img);
  //         var newElement = document.createElement("img");
  //         newElement.id = "contein";
  //         newElement.width = "150";
  //         newElement.style.display = "none";
  //         parentElement.appendChild(newElement);
  //         blobImage = [];
  //       } else {
  //         if (str != "") {
  //           if (this.state.headerMessage.length > 0) {
  //             let findChecked = this.props.ActiveHeader.find(
  //               (header) => header.label === this.props.ContactId.telefone
  //             );

  //             if (
  //               findChecked &&
  //               findChecked.active &&
  //               this.props.InfoUsers.variables_integration
  //             ) {
  //               let infos = this.state.headerMessage[0].header;
  //               const items =
  //                 this.props.InfoUsers.variables_integration.split(",");
  //               let headerMsg = "";
  //               for (let index = 0; index < items.length; index++) {
  //                 let label = "";
  //                 if (items[index] === "codigo_ticket") {
  //                   label = "Número do caso";
  //                 } else {
  //                   label =
  //                     items[index].substring(0, 1).toUpperCase() +
  //                     items[index].substring(1).toLowerCase();
  //                 }

  //                 if (index === items.length - 1) {
  //                   headerMsg =
  //                     headerMsg +
  //                     `ℹ️ *${label}:* ${infos[items[index]]}\r\n\r\n`;
  //                 } else {
  //                   headerMsg =
  //                     headerMsg + `ℹ️ *${label}:* ${infos[items[index]]}\r\n`;
  //                 }
  //               }
  //               // let header = JSON.parse(infos.replace(/(?<!\w)'|'(?!\w)/g, '"'));
  //               // let headerMsg = `ℹ️ *Tag:* ${header.tag}\nℹ️ *Protocolo:* ${header.protocolo}\r\n\r\n`;
  //               msgweb = headerMsg + msgweb;
  //               msgsocket = headerMsg + msgsocket;
  //             }
  //           }

  //           this.setState({ fileasw: [] });
  //           msgweb = msgweb.trim();
  //           msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
  //           msgweb = msgweb.replace(/"/gm, '\\"');
  //           msgsocket = msgsocket.trim();
  //           msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
  //           msgsocket = msgsocket.replace(/"/gm, '\\"');

  //           console.log("INGENIUM_MSGTEXTO : ", InfoUsers);
  //           console.log("INGENIUM_MSGTEXTO : ", msgweb);
  //           console.log("INGENIUM_MSGTEXTO : ", msgsocket);

  //           if (InfoUsers.attach_sender_name) {
  //             msgweb = `*` + InfoUsers.displayname + `:*¿` + msgweb;
  //             msgsocket = `*` + InfoUsers.displayname + `:*¿` + msgsocket;
  //             console.log("INGENIUM_MSGTEXTO : ", msgweb);
  //             console.log("INGENIUM_MSGTEXTO : ", msgsocket);
  //           }
  //           //valorInput = "";

  //           this.props.InviteMessage(
  //             makeid(32),
  //             msgweb,
  //             "Me",
  //             InfoUsers,
  //             ContactId,
  //             "0",
  //             msgsocket,
  //             "url",
  //             this.state.isHSM,
  //             this.state.paramsHSM,
  //             this.state.idreplyop,
  //             this.state.checkparam,
  //             this.state.checkparam2,
  //             this.state.variableQuickAnwser
  //           );
  //           if (this.state.isHSM === true) this.setState({ isHSM: false });
  //         }
  //       }
  //       document.getElementById("chat-message").innerHTML = "";
  //       this.scrollDown();
  //       this.props.sendtyping(0, InfoUsers, ContactId);
  //       if (mensagemretorno[ContactId.idatendimento] != true) {
  //         this.props.refreshReturnAtd(1, ContactId.telefone);
  //         mensagemretorno[ContactId.idatendimento] = true;
  //       }
  //       if (mensagemenviada[ContactId.idatendimento] != true) {
  //         this.props.editAtendimentoAgent(ContactId.idatendimento);
  //         mensagemenviada[ContactId.idatendimento] = true;
  //       }
  //     }
  //     this.setState({ idreplyop: 0, showreplyop: false });
  //   } else {
  //     //COMENTADO PARA CHECAGEM DE USO DE LENTIDAO NA DIGITAÇÃO 2023-11-10
  //     //this.props.sendtyping(1, InfoUsers, ContactId);

  //     textMessage[ContactId.idatendimento] = msgsave;
  //     if (this.state.isHSM === true) this.setState({ isHSM: false });
  //   }
  // }

  // async handleOnChange2(event, InfoUsers, ContactId) {
  //   let blob = [];
  //   var item = event.clipboardData.items[0];
  //   if (item !== undefined) {
  //     if (item.type.indexOf("image") === 0) {
  //       blob = item.getAsFile();

  //       var reader = new FileReader();
  //       reader.onload = function (event) {
  //         document.getElementById("contein").src = event.target.result;
  //         document.getElementById("contein").style.display = "block";
  //         document.getElementById("chat-message").innerText = "";
  //       };

  //       reader.readAsDataURL(blob);
  //     }
  //   }

  //   var tag = document
  //     .getElementById("chat-message")
  //     .querySelectorAll("img").length;
  //   if (tag > 0) {
  //     document.getElementById("chat-message").innerText = "";
  //   }
  // }
  async handleOnChange2(event, InfoUsers, ContactId) {
    var item = event.clipboardData.items[0];
    if (item !== undefined) {
      if (item.type.indexOf("image") === 0) {
        event.preventDefault();
        const file = item.getAsFile();
        const updatedFilesInStage = [...this.state.filesInStage];
        const indexOfOlderFileOfThisAtt = this.state.filesInStage.findIndex(
          (fileData) => {
            return (
              fileData.idAtendimento === ContactId.idatendimento ||
              parseInt(fileData.idAtendimento) ===
                parseInt(ContactId.idatendimento)
            );
          },
        );
        const hasAFileToReplace = indexOfOlderFileOfThisAtt !== -1;
        if (hasAFileToReplace) {
          updatedFilesInStage.splice(indexOfOlderFileOfThisAtt, 1, {
            name: file.name,
            file: file,
            isImage: file.type.startsWith("image/"),
            type: file.type,
            idAtendimento: ContactId.idatendimento,
            id: `${file.name}-${ContactId.idatendimento}-${
              item.lastModified
            }--${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
            isVideo: file.type.startsWith("video/"),
          });
        } else {
          updatedFilesInStage.push({
            name: file.name,
            file: file,
            isImage: file.type.startsWith("image/"),
            type: file.type,
            idAtendimento: ContactId.idatendimento,
            id: `${file.name}-${ContactId.idatendimento}-${
              file.lastModified
            }--${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
            isVideo: file.type.startsWith("video/"),
          });
        }
        this.setState({
          filesInStage: updatedFilesInStage,
        });
      }
    }

    var tag = document
      .getElementById("chat-message")
      .querySelectorAll("img").length;
    if (tag > 0) {
      document.getElementById("chat-message").innerText = "";
    }
  }

  ButtonSendMessageChat(event, author, InfoUsers, Chat, typemsg, id) {
    console.log("ISTO eeeee", InfoUsers);
    event.preventDefault();
    document.getElementById("chat-message-mini-chat" + id).disabled = false;
    let msgweb = document.getElementById(
      "chat-message-mini-chat" + id,
    ).innerText;
    let msgsocket = document.getElementById(
      "chat-message-mini-chat" + id,
    ).innerText;

    let infosendfile = this.state.fileasw;

    if (
      this.state.fileasw != null &&
      infosendfile[2] != 1 &&
      infosendfile.length > 0
    ) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgweb = msgweb.replace(/"/gm, '\\"');
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      msgsocket = msgsocket.replace(/"/gm, '\\"');

      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        this.props.sendFileAswSocket(
          InfoUsers,
          Chat,
          infosendfile[0],
          msgweb,
          makeid(32),
        );
        this.props.sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          InfoUsers.id,
          InfoUsers,
          Chat,
          1,
        );
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgweb = msgweb.replace(/"/gm, '\\"');
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        msgsocket = msgsocket.replace(/"/gm, '\\"');

        this.props.InviteChat(
          makeid(32),
          msgweb,
          InfoUsers.id,
          InfoUsers,
          Chat,
          typemsg,
          msgsocket,
        );
      }
    }
    this.scrollDownChat(Chat.iduserout);
    document.getElementById("chat-message-mini-chat" + id).innerHTML = "";
    this.textInputChat.focus();
  }

  handleOnChangeChat(event, InfoUsers, Chat, id) {
    if (event.key === "Enter" && event.shiftKey === false) {
      //let teste = document.getElementsByClassName('chat-message-mini-chat'+id);
      let msgweb = document.getElementById(
        "chat-message-mini-chat" + id,
      ).innerText;
      let msgsocket = document.getElementById(
        "chat-message-mini-chat" + id,
      ).innerText;
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgweb = msgweb.replace(/"/gm, '\\"');
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        msgsocket = msgsocket.replace(/"/gm, '\\"');
        this.props.InviteChat(
          makeid(32),
          msgweb,
          InfoUsers.id,
          InfoUsers,
          Chat,
          "0",
          msgsocket,
        );
        document.getElementById("chat-message-mini-chat" + id).innerHTML = "";
        this.scrollDownChat(id);
        this.props.sendtyping(0, InfoUsers, Chat);
      }
    } else {
      this.props.sendtyping(1, InfoUsers, Chat);
    }
    this.textInputChat.focus();
  }

  digitnumberdtmf(e) {
    let numberslast = e.target.value;
    let retorno = numberslast.substring(0, numberslast.length - 1);
    dtmf(retorno);
  }

  numberdtmf(number, event) {
    dtmf(number);
    document.getElementById("phone-dtmf__input__item").value =
      document.getElementById("phone-dtmf__input__item").value + number;
  }

  removedtmf() {
    let numberslast = document.getElementById("phone-dtmf__input__item").value;
    let retorno = numberslast.substring(0, numberslast.length - 1);
    document.getElementById("phone-dtmf__input__item").value = retorno;
  }

  handleKeyPressChat = (event, id) => {
    var el = document.getElementById("chat-message-mini-chat" + id);
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  handleKeyDownChat = (event, id) => {
    var el = document.getElementById("chat-message-mini-chat" + id);
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  start = () => {
    this.setState({
      record: true,
      timerecording: 0,
      isStartingRecord: false,
    });
    if (this.state.isBlocked) {
    } else {
      Mp3Recorder.start()
        .then(() => {
          this.setState({ isRecording: true, isStartingRecord: true });
        })
        .catch((e) => console.error(e));
    }
  };

  stopIn = () => {
    this.setState({
      record: false,
    });

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        // const blobURL = URL.createObjectURL(blob)
        const blobURL = blob;
        this.setState({ blobURL, isRecording: true, isStartingRecord: false });
      })
      .catch((e) => console.log(e));
  };

  stop = () => {
    this.setState({
      record: false,
      blobURL: "",
    });

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        this.setState({ isRecording: false, isStartingRecord: false });
      })
      .catch((e) => console.log(e));
  };

  getMymeType(message) {
    let separador = message.substr(message.indexOf(".") + 1, 4);
    separador = separador.replace("~", "");
    let mymetype = "";
    switch (separador) {
      case "jpeg":
      case "png":
      case "jpg":
        mymetype = "image/jpeg";
        break;
      case "pdf":
        mymetype = "application/pdf";
        break;
      case "xls":
        mymetype = "application/vnd.ms-excel";
        break;
      case "xlsx":
        mymetype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "doc":
        mymetype = "application/msword";
        break;
      case "docx":
        mymetype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        break;
      case "ppt":
        mymetype = "application/vnd.ms-powerpoint";
        break;
      case "pptx":
        mymetype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        break;
      case "wav":
        mymetype = "audio/wav";
        break;
      case "mp3":
        mymetype = "audio/mp3";
        break;
      case "ogg":
        mymetype = "audio/ogg";
        break;
      case "mpeg":
        mymetype = "audio/mpeg";
        break;
      case "mp4":
        mymetype = "video/mp4";
        break;
      case "xlsm":
        mymetype = "application/vnd.ms-excel.sheet.macroEnabled.12";
        break;
      case "zip":
        mymetype = "application/x-zip-compressed";
        break;
      default:
        mymetype = "...";
    }
    return mymetype;
  }

  handleDirectForward = (message, contactid, infousers, author, typemsg) => {
    document.getElementById("chat-wrapper").classList.add("active");
    let url = message.message.split("~¿");
    let msgsocket = "";
    const mymeType = this.getMymeType(message.message);

    // const pattern = /\/\d{6}_/g;

    if (typemsg === "1") {
      // let caption = url[2].substr(url[2].indexOf(url[2].match(pattern))+1);
      let caption = url[2].split(".")[0].split("/")[6];
      msgsocket = `{"CDR":"${contactid.idatendimento}","URL":"${url[2]}","THUMBNAIL":"","CAPTION":"${caption}","MIMETYPE":"${mymeType}"}`;
    }

    const forwardMsgList = [];
    forwardMsgList.push({
      makeid: makeid(32),
      message,
      contactid,
      infousers,
      author,
      typemsg,
      msgsocket,
      url,
    });

    this.setState({ forwardMsgList }, () => {
      MicroModal.show("modal__encaminhar");
    });
  };

  handleSelectForward = async (infousers, contactid, url, IPCurrent) => {
    let data = new FormData();
    const fileExt = url.substring(url.length - 3);
    const hora = url.substring(
      url.indexOf("_") + 1,
      url.indexOf("." + fileExt),
    );
    const random = url.substring(url.indexOf("_") - 6, url.indexOf("_"));
    const nameFile = random + "_" + hora + "." + fileExt;
    const filesend = {
      lastModified: hora,
      lastModifiedDate: "",
      name: random + "_" + hora,
      size: 1000,
      type: fileExt,
    };
    // data.append("file", filesend, nameFile);
  };

  handleForwardClick = () => {
    MicroModal.show("modal__encaminhar");
  };

  handleCloseEncaminhar = () => {
    this.setState({ forwardMsgList: [] }, () => {
      document.getElementById("chat-wrapper").classList.remove("active");
      // MicroModal.close("modal__encaminhar");
    });
  };

  handleCheck = (
    isChecked,
    message,
    contactid,
    infousers,
    author,
    typemsg,
    msgsocket,
  ) => {
    const { forwardMsgList } = this.state;
    // const msgType = message.message.match(/\.(pdf|doc)$/);
    // if(!msgType){
    //   msgsocket = msgsocket!=""? "ENC: "+msgsocket:"";
    //   // message.message ="ENC: "+ message.message;
    // }
    let url = message.message.split("~¿");
    const mymeType = this.getMymeType(message.message);

    // const pattern = /\/\d{6}_/g;
    if (typemsg === "1") {
      // let caption = url[2].substr(url[2].indexOf(url[2].match(pattern))+1);
      let caption = url[2].split(".")[0].split("/")[6];
      msgsocket = `{"CDR":"${contactid.idatendimento}","URL":"${url[2]}","THUMBNAIL":"","CAPTION":"${caption}","MIMETYPE":"${mymeType}"}`;
    }

    if (!isChecked) {
      forwardMsgList.push({
        makeid: makeid(32),
        message,
        contactid,
        infousers,
        author,
        typemsg,
        msgsocket,
      });
      this.setState({ forwardMsgList });
    } else {
      //remove logic here
      const newForwardMsgList = forwardMsgList.filter(
        (msg) => msg.message.messageid != message.messageid,
      );
      this.setState({ forwardMsgList: newForwardMsgList });
    }
  };

  handleForwardConfirm = (contactList) => {
    const { forwardMsgList } = this.state;
    if (contactList.length === "0") return;
    contactList.forEach((contact) => {
      forwardMsgList.forEach((msg) => {
        msg.contactid = contact;
        msg.url = msg.url ? msg.url[2] : "";
        this.props.InviteMessage(
          msg.makeid,
          msg.message,
          msg.author,
          msg.infousers,
          msg.contactid,
          msg.typemsg,
          msg.msgsocket,
          msg.url,
        );
      });
    });
    this.handleCloseEncaminhar();
    MicroModal.close("modal__encaminhar");
  };

  renderPopoverInfo = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file
                ? connection_platform.type_connect + "://" + ipcurrent + file
                : null
            }
            width="140"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  renderAvaliation = (atd) => {
    switch (atd.score_class) {
      case "otimo":
        return (
          <Tooltippy content={atd.score_value} placement="top">
            <div className="username-rating__tag happy">
              <HappyRating />
              Cliente satisfeito
            </div>
          </Tooltippy>
        );

      case "promotor":
        return (
          <Tooltippy content={atd.score_value} placement="top">
            <div className="username-rating__tag happy">
              <HappyRating />
              Cliente satisfeito
            </div>
          </Tooltippy>
        );

      case "razoavel":
        return (
          <Tooltippy content={atd.score_value} placement="top">
            <div className="username-rating__tag indifferent">
              <IndifRating />
              Cliente indiferente
            </div>
          </Tooltippy>
        );

      case "neutro":
        return (
          <Tooltippy content={atd.score_value} placement="top">
            <div className="username-rating__tag indifferent">
              <IndifRating />
              Cliente indiferente
            </div>
          </Tooltippy>
        );

      case "ruim":
        return (
          <Tooltippy content={atd.score_value} placement="top">
            <div className="username-rating__tag sad">
              <SadRating />
              Cliente insatisfeito
            </div>
          </Tooltippy>
        );

      case "detrator":
        return (
          <Tooltippy content={atd.score_value} placement="top">
            <div className="username-rating__tag sad">
              <SadRating />
              Cliente insatisfeito
            </div>
          </Tooltippy>
        );

      default:
        return (
          <div className="username-rating__tag">
            <NullRating />
            Nenhuma avaliação
          </div>
        );
    }
  };

  handleCriticality = (criticidade) => {
    this.setState({ idCriticidadeSelec: criticidade ? criticidade.value : "" });
  };

  addEmoji(emoji) {
    let string = document.getElementById("chat-message").innerText;
    document.getElementById("chat-message").innerText = string + emoji.native;
  }

  removeImageSplit() {
    // document.getElementById("contein").style.display = "none";
    // document.getElementById("contein").src = null;
    var img = document.getElementById("contein");

    var parentElement = img.parentNode;
    parentElement.removeChild(img);
    var newElement = document.createElement("img");
    newElement.id = "contein";
    newElement.width = "150";
    newElement.style.display = "none";
    parentElement.appendChild(newElement);
  }

  handleReply = ({ messageid }) => {
    // this.setState({ showreplyop: true, idreplyop: messageid });
    this.addReplyToThisCdr(messageid);
    document.getElementById("simulation_click").click();
  };

  SolicitarConferenciaAtiva(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    status,
    queue,
    AtdSimult,
    ipcurrent,
    ContactId,
  ) {
    if (document.getElementById("chat-message"))
      document.getElementById("chat-message").innerText = "";
    document.getElementById("simulation_click").click();
    if (permrouter != "undefined" && permrouter != "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      var rotaDefault = false;
      var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      var trunkDef = "";
      var addtechDef = "";
      var scriptrunkDef = "";
      var operatorDef = "";
      var tech = "";
      var techDef = "";
      var idgrupo_rota = "";
      var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      var idgrupo_transbDef = "";
      var chamado = document.getElementById("telefone_conf").value;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;

      if (mediaid === 5 || mediaid === 1 || mediaid === 8 || mediaid === 16) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid != "undefined" &&
        permrouter[0].areacodeid != ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "";
        var DDDPadrao = "";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (
        connection_platform.remove_digits ||
        (parseInt(mediaid) !== 1 && parseInt(mediaid) !== 16)
      ) {
        if (chamado[0] === "0" && chamado.substr(0, 2) != "00") {
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) != "00"
      ) {
        if (
          chamado.substr(0, 2) === "55" &&
          (mediaid === 5 ||
            mediaid === "5" ||
            mediaid === "16" ||
            mediaid === 16) &&
          chamado.length > 11
        ) {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }
        if (parseInt(chamado.substr(2, 2)) != parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          }
        } else if (parseInt(chamado.substr(2, 2)) == parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          }
        }
      }
      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) != "0800" &&
        chamado.substr(0, 2) != "00"
      ) {
        DDD = chamado.substr(0, 2);
        chamado = chamado.substr(2, chamado.length - 1);
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) != parseInt(DDDPadrao) &&
          chamado.substr(0, 2) != "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          }
        } else if (parseInt(DDD) == parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 16) tipochamada = 27;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 1;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 16) tipochamada = 27;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 2;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 16) tipochamada = 27;
        }
        if (mediaid !== 1 && mediaid !== 8 && mediaid !== 16) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) === "0800" && chamado.length > 9) {
        //chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) === "00") {
        if (mediaid === 1) tipochamada = 5;
        else if (mediaid === 5) tipochamada = 17;
        else if (mediaid === 8) tipochamada = 19;
        else if (mediaid === 16) tipochamada = 27;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid === 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid === 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            this.setState({ senhaincorreta: "none" });

            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) === result.calltypeid) {
                  if (parseInt(tipochamada) == 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator != "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator != "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 5) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 8) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) != 5 &&
                    chamado.substr(0, 2) == "00" &&
                    parseInt(result.operator) == parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) == 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid == 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) == 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid == 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota == true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;
                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  var status = queue[i].status;
                }
              }

              if (parseInt(mediaid) === 5 || parseInt(mediaid) === 16) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (parseInt(mediaid) === 1 || parseInt(mediaid) === 16) {
                if (retorno === 1) {
                  this.props.RequestActiveConfSocketVoz(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    chamado,
                    addtech,
                    scriptrunk,
                    operator,
                    true,
                    queueid,
                    recvcount,
                    null,
                    tech,
                    idgrupo_rota,
                    idgrupo_transb,
                    ipcurrent,
                    cdrid,
                    checkRota,
                    ContactId,
                  );
                  this.props.ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status,
                  );
                } else {
                  this.props.RequestActiveConfSocketVoz(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    chamado,
                    addtech,
                    scriptrunk,
                    operator,
                    false,
                    queueid,
                    recvcount,
                    null,
                    tech,
                    idgrupo_rota,
                    idgrupo_transb,
                    ipcurrent,
                    cdrid,
                    checkRota,
                    ContactId,
                  );
                  this.props.ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status,
                  );
                }
              }

              // else{
              //     if(retorno === 1){
              //         this.props.RequestActiveCall(outband,infouser,trunk,mediaid,calledDigitado,addtech,scriptrunk,operator,true,queueid,recvcount,cbackcount,idgrupo_transb,cdrid)
              //         this.props.ReturningCallbackIn(queueid,true,recvcount,cdrid,mediaid,srvin,caller,called,cbackcount,status)
              //     }else{
              //         this.props.RequestActiveCall(outband,infouser,trunk,mediaid,calledDigitado,addtech,scriptrunk,operator,false,queueid,recvcount,cbackcount,idgrupo_transb)
              //     }
              // }
              //this.props.ShowActiveCallIn('')
              // MicroModal.close('modal__falar-com-cliente');
              this.numberToActive.value = "";
            } else {
              // this.setState({senhaincorreta: 'block'}) ;
              // document.getElementById('div_alert').innerHTML='Sem rota de sa&iacute;da!';
            }
          } else {
            // this.setState({senhaincorreta: 'block'}) ;
            // document.getElementById('div_alert').innerHTML='Apenas n&uacute;meros!';
          }
        } else {
          // this.setState({senhaincorreta: 'block'});
          // document.getElementById('div_alert').innerHTML='Informe o n&uacute;mero!';
        }
      } else {
        this.props.InterationNotifier(
          "Este cliente já está sendo atendido por você",
          "call",
        );
      }
    }
  }

  getScheduleConfirm(e) {
    this.props.actionScheduleNc2();
  }

  handleModalQuickAnswer() {
    MicroModal.show("modal__agenda-pj-empresa-detalhes-editar-respostas");
  }

  sendTextInputChat(textReceived) {
    document.getElementById("chat-message").innerText = textReceived;
  }

  actionSendMessageClient(bind) {
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-respostas");
    document.getElementById("button-send-message").click();
    document.getElementById("input-msgs-rapidas").value = "";
    bind.setState({ searchQuickMsg: "" });
  }

  actionCancelMessageClient() {
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-respostas");
    document.getElementById("chat-message").innerText = "";
  }

  saveVariablesQuick() {
    this.setState({ variableQuickAnwser: arrayVariables });
  }

  changeVisibleBoxMail(bind) {
    bind.setState({ isVisibleBox: !bind.state.isVisibleBox });
  }

  changeVariablesSending(array) {
    arrayVariables = array;
    document.getElementById("button-save-variables").click();
  }

  async fileHandle(mensagens) {
    const { Mimetypes } = this.props;
    for (const item of mensagens) {
      //Busca as informações do arquivo com base no link
      if (
        mimetypesPrincipal.includes(item.typename) &&
        !item.messagem.includes("https")
      ) {
        const response = await handleFiles(item.messagem);
        const fileObject = {
          name: response.name,
          size: response.size,
          type: response.typeMime,
          path_arquivos: item.messagem,
          extension: response.type,
          id: item.id,
        };
        item.file = fileObject;
        //Busca as informações do mimetype caso venha o link completo do arquivo
      } else if (
        mimetypesPrincipal.includes(item.typename) &&
        item.messagem.includes("https")
      ) {
        const response = Mimetypes;
        const mimetype = response.find(
          (element) => item.mimetypeid === element.id_mimetype,
        );
        item.mimetype = mimetype;
        //Caso a mensagem seja um json, ele faz o parse para ler o json
      } else if (item.typename === "application") {
        // item.messagem = JSON.parse(item.messagem).msg || JSON.parse(item.messagem).MSG;
        try {
          if (JSON.parse(item.messagem).msg || JSON.parse(item.messagem).MSG) {
            item.messagem =
              JSON.parse(item.messagem).msg || JSON.parse(item.messagem).MSG;
          }

          item.messagem = createJSON(item.messagem);
        } catch (err) {
          console.log("Error: ", err.message);
        }

        //Caso seja auditória de voz, formata o link que vem do back (vem sem formatação) para poder chamar a função que busca as informações do arquivo.
      } else if (item.typename === "Interactive") {
        if (item.mimetypeid >= 33 && item.mimetypeid <= 36) {
          let json = JSON.parse(item.messagem);
          item.buttons = json.buttons;
          item.botid = json.botid;

          if (json.link) {
            const response = await handleFiles(json.link);
            const fileObject = {
              name: response.name,
              size: response.size,
              type: response.typeMime,
              path_arquivos: json.link,
              extension: response.type,
              id: item.id,
            };
            item.file = fileObject;
          }
        } else if (item.mimetypeid === 37) {
          let json = JSON.parse(item.messagem);
          item.buttons = json.items;
          item.botid = json.botid;
        }
      } else if (item.typename === "location") {
        let json = JSON.parse(item.messagem);
        item.location = {
          latitude: json.latitude,
          longitude: json.longitude,
          nomeEndereco: json.name,
          endereco: json.address,
        };
      } else if (item.typename === "hsm") {
        let json = JSON.parse(item.messagem);

        if (json.FILEPATH) {
          const response = await handleFiles(json.FILEPATH);
          const fileObject = {
            name: response.name,
            size: response.size,
            type: response.typeMime,
            path_arquivos: json.FILEPATH,
            extension: response.type,
            id: item.id,
          };
          item.file = fileObject;

          item.messagem = json.URL;
        }

        if (json.HSM_BUTTONS) {
          item.messagem = json.URL;
          const buttons = json.HSM_BUTTONS.buttons;
          const buttonsFormated = [];
          for (const btn of buttons) {
            const objBtn = {
              payload: btn.index,
              text: btn.parameters[0].text,
            };

            buttonsFormated.push(objBtn);
          }

          item.buttons = buttonsFormated;
        }
      }
    }
  }

  handleClickOnMoreOptionsItem(idOfItem) {
    const isDetalhes = idOfItem === "detalhes";
    if (isDetalhes) {
      this.props.SideContentAttendanceSelectedAction("detalhes");
      this.props.OpenSideContent();
      return;
    }
    const isPesquisa = idOfItem === "pesquisa";
    if (isPesquisa) {
      this.props.SideContentAttendanceSelectedAction("pesquisa");
      this.props.OpenSideContent();
      return;
    }
    const isCampanhas = idOfItem === "campanhas";
    if (isCampanhas) {
      this.props.SideContentAttendanceSelectedAction("campanhas");
      this.props.OpenSideContent();
      return;
    }
    const isAjuda = idOfItem === "ajuda";
    if (isAjuda) {
      this.props.SideContentAttendanceSelectedAction("ajuda");
      this.props.OpenSideContent();
      return;
    }
  }

  renderMoreOptions(contact) {
    return (
      <ul className="more-options">
        {/* <li className="more-options__item">
          <div className="more-options__item-icon">
            <IconMoreHeader />
          </div>
          <div
            className="more-options__item-label"
            onClick={() => this.handleHeaderMessage()}
          >
            <Typography.H5 color={"gray-180"}>
              {this.state.headerMessage.length > 0 ? "Desativar" : "Ativar"}{" "}
              Cabeçalho
            </Typography.H5>
          </div>
        </li> */}
        <li
          className={`more-options__item ${
            this.props.SideContentAttendanceSelected === "detalhes" &&
            this.props.IsSideContentOpen
              ? "active"
              : ""
          }`}
          style={{
            backgroundColor:
              this.props.SideContentAttendanceSelected === "detalhes" &&
              this.props.IsSideContentOpen
                ? "#455cc7"
                : "#ffffff",
          }}
          onClick={() => {
            this.props.SideContentAttendanceSelectedAction("detalhes");
            this.props.OpenSideContent();
          }}
        >
          <div className="more-options__item-icon">
            <IconDetalhes />
          </div>
          <div className="more-options__item-label">
            <Typography.H5 color={"gray-180"}>Ver detalhes</Typography.H5>
          </div>
        </li>

        <li
          className={`more-options__item ${
            this.props.SideContentAttendanceSelected === "pesquisa" &&
            this.props.IsSideContentOpen
              ? "active"
              : ""
          }`}
          style={{
            backgroundColor:
              this.props.SideContentAttendanceSelected === "pesquisa" &&
              this.props.IsSideContentOpen
                ? "#455cc7"
                : "#ffffff",
          }}
          onClick={() => {
            this.props.SideContentAttendanceSelectedAction("pesquisa");
            this.props.OpenSideContent();
          }}
        >
          <div className="more-options__item-icon">
            <IconPesquisa />
          </div>
          <div className="more-options__item-label">
            <Typography.H5 color={"gray-180"}>Pesquisa</Typography.H5>
          </div>
        </li>

        <li
          className={`more-options__item ${
            this.props.SideContentAttendanceSelected === "campanhas" &&
            this.props.IsSideContentOpen
              ? "active"
              : ""
          }`}
          style={{
            backgroundColor:
              this.props.SideContentAttendanceSelected === "campanhas" &&
              this.props.IsSideContentOpen
                ? "#455cc7"
                : "#ffffff",
          }}
          onClick={() => {
            this.props.SideContentAttendanceSelectedAction("campanhas");
            this.props.OpenSideContent();
          }}
        >
          <div className="more-options__item-icon">
            <IconCampanha />
          </div>
          <div className="more-options__item-label">
            <Typography.H5 color={"gray-180"}>Campanhas</Typography.H5>
          </div>
        </li>

        <li
          className={`more-options__item`}
          style={{
            backgroundColor:
              this.props.SideContentAttendanceSelected === "ajuda" &&
              this.props.IsSideContentOpen
                ? "#455cc7"
                : "#ffffff",
          }}
          onClick={() => {
            this.props.SideContentAttendanceSelectedAction("ajuda");
            this.props.OpenSideContent();
          }}
        >
          <div className="more-options__item-icon">
            <IconAjuda />
          </div>
          <div className="more-options__item-label">
            <Typography.H5 color={"gray-180"}>Ajuda</Typography.H5>
          </div>
        </li>
      </ul>
    );
  }

  handleHeaderMessage() {
    let { ContactId } = this.props;
    let protocolo = ContactId.protocolo;
    if (this.state.headerMessage.length === 0) {
      if (ContactId.menubot) {
        let menubot = ContactId.menubot.split("~¿");

        for (const item of menubot) {
          if (item.includes("Protocolo")) {
            let separator = item.split(": ");
            protocolo = separator[1];
          }
        }
      }

      let objeto = {
        tag: ContactId.idatendimento,
        protocolo: protocolo,
      };
      let stringObj = JSON.stringify(objeto).replace(/"/gi, "'");
      this.props.addMessageHeader(ContactId, stringObj);
    }

    if (this.state.headerMessage.length > 0) {
      this.props.deleteMessageHeader(ContactId);
      this.setState({ headerMessage: [] });
    }
  }

  handleAddContact(contact, typeModal, bind) {
    port = localStorage.getItem("port");
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${contact.telefone}&nome=&empresa=&contato=&codext=&email=`,
      )
      .then((response) => {
        if (response.data.length > 0) {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            bind.props.GetDetailsContacts(false, response.data[0]);
          } else {
            bind.props.GetDetailsContacts(true, response.data[0], "");
          }
        } else {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            bind.props.GetDetailsContacts(false, contact);
          } else {
            bind.props.GetDetailsContacts(true, "", contact);
            bind.props.AddNumberContact("", contact.telefone);
          }
        }
        // this.setState({ cursorState: false });
      });
  }

  SolicitarChamadaAtiva(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    status,
    queue,
    number,
    AtdSimult,
    ipcurrent,
    statusAgent,
  ) {
    if (statusAgent.allowCall === false) {
      this.props.InterationNotifier("Pausa não permite ativo", "permission");
      return true;
    }

    if (document.getElementById("chat-message"))
      document.getElementById("chat-message").innerText = "";
    if (permrouter != "undefined" && permrouter != "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      var rotaDefault = false;
      var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      var trunkDef = "";
      var addtechDef = "";
      var scriptrunkDef = "";
      var operatorDef = "";
      var tech = "";
      var techDef = "";
      var idgrupo_rota = "";
      var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      var idgrupo_transbDef = "";
      var chamado = number;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var dddValidado = "";

      if (
        parseInt(mediaid) === 5 ||
        parseInt(mediaid) === 1 ||
        parseInt(mediaid) === 8 ||
        parseInt(mediaid) === 16
      ) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid != "undefined" &&
        permrouter[0].areacodeid != ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "";
        var DDDPadrao = "";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (
        connection_platform.remove_digits ||
        (parseInt(mediaid) !== 1 && parseInt(mediaid) !== 16)
      ) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) != "00" &&
          chamado.substr(0, 4) != "0800"
        ) {
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) != "00"
      ) {
        if (
          chamado.substr(0, 2) === "55" &&
          (mediaid === 5 || mediaid === "5" || parseInt(mediaid) === 16) &&
          chamado.length > 11
        ) {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }

        dddValidado = chamado.substr(2, 2);

        if (
          !connection_platform.remove_digits &&
          (parseInt(mediaid) === 1 || parseInt(mediaid) === 16) &&
          chamado.startsWith("0")
        ) {
          dddValidado = chamado.substr(1, 2);
        }

        if (parseInt(dddValidado) != parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          }
        } else if (parseInt(dddValidado) == parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          }
        }
      }
      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) !== "0800" &&
        chamado.substr(0, 2) !== "00"
      ) {
        // DDD = chamado.substr(0, 2);
        // chamado = chamado.substr(2, chamado.length - 1);

        if (!connection_platform.remove_digits && chamado[0] === "0") {
          DDD = chamado.substr(1, 2);
          chamado = chamado.substr(3, chamado.length - 1);
        } else {
          DDD = chamado.substr(0, 2);
          chamado = chamado.substr(2, chamado.length - 1);
        }

        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) !== parseInt(DDDPadrao) &&
          chamado.substr(0, 2) !== "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          }
        } else if (parseInt(DDD) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
            else if (mediaid === 16) tipochamada = 27;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 1;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
          else if (mediaid === 11) tipochamada = 25;
          else if (mediaid === 16) tipochamada = 27;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 2;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
          else if (mediaid === 11) tipochamada = 25;
          else if (mediaid === 16) tipochamada = 27;
        }
        if (mediaid !== 1 && mediaid !== 8 && mediaid !== 16) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) === "0800" && chamado.length > 9) {
        //chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) === "00") {
        if (mediaid === 1) tipochamada = 5;
        else if (mediaid === 5) tipochamada = 17;
        else if (mediaid === 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
        else if (mediaid === 11) tipochamada = 25;
        else if (mediaid === 16) tipochamada = 27;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid === 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid === 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;
      else if (mediaid === 11) tipochamada = 25;
      else if (mediaid === 16) tipochamada = 27;

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            this.setState({ senhaincorreta: "none" });

            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) === result.calltypeid) {
                  if (parseInt(tipochamada) === 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 10, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 11, 2),
                      ) == parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 5) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 8) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) !== 5 &&
                    chamado.substr(0, 2) === "00" &&
                    parseInt(result.operator) === parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) === 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) === 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota == true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;
                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  var status = queue[i].status;
                }
              }

              if (parseInt(mediaid) === 5 || parseInt(mediaid) === 16) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (parseInt(mediaid) === 1 || parseInt(mediaid) === 16) {
                if (retorno === 1) {
                  this.props.RequestActiveCallSocketVoz(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    chamado,
                    addtech,
                    scriptrunk,
                    operator,
                    true,
                    queueid,
                    recvcount,
                    null,
                    tech,
                    idgrupo_rota,
                    idgrupo_transb,
                    ipcurrent,
                    cdrid,
                    checkRota,
                  );
                  this.props.ReturningCallbackIn2(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status,
                  );
                  this.props.ShowInfoDisplay("Clientes");
                } else {
                  this.props.RequestActiveCallSocketVoz(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    chamado,
                    addtech,
                    scriptrunk,
                    operator,
                    false,
                    queueid,
                    recvcount,
                    null,
                    tech,
                    idgrupo_rota,
                    idgrupo_transb,
                    ipcurrent,
                    cdrid,
                    checkRota,
                  );
                  this.props.ReturningCallbackIn2(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status,
                  );
                  this.props.ShowInfoDisplay("Clientes");
                }
              } else {
                if (retorno === 1) {
                  this.props.RequestActiveCall(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    calledDigitado,
                    addtech,
                    scriptrunk,
                    operator,
                    true,
                    queueid,
                    recvcount,
                    cbackcount,
                    idgrupo_transb,
                    cdrid,
                  );
                  this.props.ReturningCallbackIn2(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status,
                  );
                  this.props.ShowInfoDisplay("Clientes");
                } else {
                  this.props.RequestActiveCall(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    calledDigitado,
                    addtech,
                    scriptrunk,
                    operator,
                    false,
                    queueid,
                    recvcount,
                    cbackcount,
                    idgrupo_transb,
                  );
                  this.props.ShowInfoDisplay("Clientes");
                }
              }
              //this.props.ShowActiveCallIn('')
              //MicroModal.close('modal__falar-com-cliente');
              //this.numberToActive.value = '';
            } else {
              this.setState({ senhaincorreta: "block" });
              document.getElementById("div_alert").innerHTML =
                "Sem rota de sa&iacute;da!";
            }
          } else {
            this.setState({ senhaincorreta: "block" });
            document.getElementById("div_alert").innerHTML =
              "Apenas n&uacute;meros!";
          }
        } else {
          this.setState({ senhaincorreta: "block" });
          document.getElementById("div_alert").innerHTML =
            "Informe o n&uacute;mero!";
        }
      } else {
        this.props.InterationNotifier(
          "Este cliente já está sendo atendido por você",
          "call",
        );
      }
    }
  }

  RemoveNotifierMail(e, idnotifier, notifiers) {
    for (let i = 0; i < notifiers.length; i++) {
      this.props.RemoveNotifier(notifiers[i].remote);
    }
  }

  showMessageMail(e, idnotifier, notifiers) {
    for (let i = 0; i < notifiers.length; i++) {
      this.props.RemoveNotifier(notifiers[i].remote);
    }
    var emailDiv = document.getElementById(
      `email-to-${notifiers[notifiers.length - 1].idnotifier}`,
    );
    emailDiv.scrollIntoView({ behavior: "smooth" });
  }

  printDivEmail() {
    // let conteudo = document.getElementById('attendance__mail-container').innerHTML;
    const element = document.querySelector("#containers");
    const sectionTable = document.querySelector(".attendance__mail");
    const sectionTable2 = document.querySelector("#containers");

    sectionTable.classList.replace(
      "attendance__mail",
      "attendance__mail_before",
    );

    sectionTable2.classList.remove("chat-canvas");

    htmlToImage
      .toPng(element, {
        height: sectionTable2.clientHeight,
      })
      .then(function (dataUrl) {
        const a = document.createElement("a");
        a.download = "file.png";
        a.href = dataUrl;
        a.click();
        sectionTable.classList.replace(
          "attendance__mail_before",
          "attendance__mail",
        );
        sectionTable2.classList.add("chat-canvas");
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
        sectionTable.classList.replace(
          "attendance__mail_before",
          "attendance__mail",
        );
        sectionTable2.classList.add("chat-canvas");
      });
  }

  render() {
    const {
      Typing,
      IvrCallTransfer,
      Messages,
      ContactId,
      InfoUsers,
      IPCurrent,
      Chat,
      ChatSimult,
      DisplayDetails,
      RespostasRapidas,
      UserGroups,
      CriticidadesAnotacoes,
      StatusAgent,
      DisplayNextAtd,
      AtdSimult,
      outservices,
      servicegroup,
      ExternConf,
      PermissionRouter,
      listCallQueue,
      MailMessage,
      MessagesHeader,
      RegisterNotifier,
      ingFaqConditions,
    } = this.props;

    if(RespostasRapidas.length !== 0){
      this.state.respostas = RespostasRapidas.respostas;
      this.state.respostasinicial = RespostasRapidas.respostas;

      if (RespostasRapidas.length !== 0) {
        let respostas = RespostasRapidas.respostas;

        if(localStorage.getItem("hsm__send-call")){
          if(ContactId && ContactId.telefone === localStorage.getItem("hsm__send-call")){
            localStorage.removeItem("hsm__send-call");
            this.state.buttonQuickAnswer = true;
            this.state.searchQuickMsg = "ligar"
          }
        }
      
        if (this.state.searchQuickMsg !== "") {
          respostas = respostas.filter(item => {
            const asw = item.qck_asw_keyword;
            const filtro = this.state.searchQuickMsg;
      
            return asw
              .toLowerCase()
              .includes(filtro.toLowerCase());
          });
        }
      
        this.state.respostas = respostas;
      }
    }

    const hasFilesInStageArea =
      !!this.state.filesInStage &&
      this.state.filesInStage.length > 0 &&
      this.state.filesInStage.filter((fileToFilter) => {
        return (
          fileToFilter.idAtendimento === ContactId.idatendimento ||
          parseInt(fileToFilter.idAtendimento) ===
            parseInt(ContactId.idatendimento)
        );
      }).length > 0;

    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    let input;
    var typing_w = "";
    var dia = "";
    var auxdia = "";

    const hasPesquisaButton = ContactId.nps_call;

    if (ChatSimult.length != 0) {
      this.state.chatsimult = ChatSimult;
    }

    if (outservices) {
      this.state.outservices = outservices;
    }

    if (servicegroup) {
      this.state.servicegroup = servicegroup;
    }

    if (Typing.length != 0) {
      this.state.typing = Typing;
    }

    if (DisplayNextAtd.displaynextatd === "ocultar") {
      this.state.activeCrm = true;
    }

    this.state.typing.map((typingtodo) => {
      if (
        parseInt(typingtodo.typing) == 1 &&
        typingtodo.idatendimento == ContactId.idatendimento
      ) {
        typing_w = (
          <div className="message left" style={{ marginTop: "20px" }}>
            <div className="bubble">
              <img src={LOADING} alt="" className="bubble__typing" width="48" />
            </div>
          </div>
        );
      }
    });

    if (!InfoUsers.sending_audio) {
      disabledAudio = true;
    }

    const { props, onScroll } = this;
    const mimetypesPrincipal = [
      "image",
      "voice",
      "document",
      "audio",
      "txt",
      "video",
    ];

    // Alterado dia 09/09/2020
    // if (Messages.length != 0 && StatusAgent.status === "Atendimento") {
    if (Messages.length != 0 && StatusAgent.status !== "Livre") {
      var NovaMensagem = Messages[ContactId.idatendimento];
      // var NovaMensagemC = MessagesNew;
      var Contador = [];

      if (NovaMensagem === undefined) {
        var NovaMensagem = [];
      }
      // if (NovaMensagemC === undefined) {
      //   var NovaMensagemC = [];
      // }
    } else {
      var NovaMensagem = [];
      // var NovaMensagemC = [];
    }

    if (MessagesHeader.length != 0) {
      var HeaderMessage = MessagesHeader[ContactId.telefone];
      // this.setState({ headerMessage: MessagesHeader[ContactId.idatendimento] });
      this.state.headerMessage = MessagesHeader[ContactId.telefone];

      if (HeaderMessage === undefined) {
        HeaderMessage = [];
        // this.setState({ headerMessage: [] });
        this.state.headerMessage = [];
      }
    } else {
      HeaderMessage = [];
      // this.setState({ headerMessage: [] });
      this.state.headerMessage = [];
    }

    if (DisplayDetails.displaydetailsatd === true)
      this.state.showbuttondetails = "";
    if (DisplayDetails.displaydetailsatd === false)
      this.state.showbuttondetails = " active";
    if (DisplayDetails.displaydetailsatd === undefined)
      this.state.showbuttondetails = "";
    if (DisplayNextAtd.displaynextatd === "ocultar") {
      this.state.visible = " w-40";
    } else {
      this.state.visible = " w-50";
      this.state.activeCrm = false;
    }

    if (IvrCallTransfer.length != 0)
      this.state.transfers = IvrCallTransfer.transfers;

    if (Messages.length != 0) this.state.messages = Messages;

    if (CriticidadesAnotacoes.length != 0) {
      this.state.DescAnotacoes = CriticidadesAnotacoes.criticalitys;
      options = CriticidadesAnotacoes.criticalitys;
      if (this.state.idCriticidadeSelec === 0) {
        this.state.iconeCriticidade =
          this.state.DescAnotacoes[0].class_criticality;
        this.state.criticidadeSelec = this.state.DescAnotacoes[0].description;
        //this.state.idCriticidadeSelec = this.state.DescAnotacoes[0].id;
      }
    }

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    }

    if (AtdSimult.length != 0) {
      this.state.atdsimult = AtdSimult;
    } else {
      this.state.atdsimult = [];
    }

    if (ContactId.length != 0) {
      this.state.contactid = ContactId;
      if (mensagensnaolidas[ContactId.idatendimento] === undefined) {
        mensagensnaolidas[ContactId.idatendimento] = 0;
        outroatendimento[ContactId.idatendimento] = 0;
      }
    }

    let chatwrapper = document.getElementById("chat-wrapper");
    if (chatwrapper && chatwrapper.offsetWidth !== this.state.lengthLast) {
      let lengthDiv = document.getElementById("chat-wrapper").offsetWidth;
      theaterStart = Math.trunc(lengthDiv / 160);
    }

    this.state.atdsimult = this.state.atdsimult.slice(0, theaterStart);
    //this.state.atdsimult = this.state.atdsimult.filter(simult => simult.idatendimento != ContactId.idatendimento)
    this.state.atdsimultsec = AtdSimult.slice(theaterStart, AtdSimult.length);
    this.state.atdsimultsec = this.state.atdsimultsec.filter(
      (simult) => simult.idatendimento != ContactId.idatendimento,
    );

    let index = this.state.atdsimult.findIndex(
      (simult, index, array) =>
        simult.idatendimento === ContactId.idatendimento,
    );

    if (index != -1) {
      this.state.atdsimult = AtdSimult.slice(0, theaterStart + 1);
      this.state.atdsimultsec = AtdSimult.slice(
        theaterStart + 1,
        AtdSimult.length,
      );
      this.state.atdsimultsec = this.state.atdsimultsec.filter(
        (simult) => simult.idatendimento != ContactId.idatendimento,
      );
    }

    if (ContactId.searchText) {
      this.handleSearchReduce(ContactId.searchText);
      this.props.ChangeSearchText("");
    }

    const commentFilters = (comment) => {
      if (searchText) {
        let textSearch = "";
        if (comment.typemsg === "0") {
          textSearch = comment.message.replace(/¿/gi, "\n");
        } else if (comment.typemsg === "1") {
          const get_json = comment.message;
          let separadorurlcaption = get_json.split("~¿");
          textSearch = separadorurlcaption[1].replace(/¿/gi, "\n");
        } else if (comment.typemsg === "2") {
          const get_json = comment.message.replace(/§/gi, "\r\n");
          let separadorurlcaption = get_json.split("~¿");
          textSearch = separadorurlcaption[0].replace(/¿¿/gi, "\\n\\n");
        } else {
          let infosLocation = comment.message.split("~¿");
          textSearch = `${infosLocation[1]}\n${infosLocation[0]}`;
        }

        const commentFilter = textSearch
          ? textSearch.toLowerCase().includes(searchText.toLowerCase())
          : "";

        if (commentFilter) {
          return comment;
        } else {
          return;
        }
      } else {
        return comment;
      }
    };

    return (
      <div
        id="column2"
        // className={"chat-page column split column-chat" + this.state.visible}
        className={"chat-page column column-chat" + this.state.visible}
      >
        <ForwardModal
          // updateForwardContactList={this.updateForwardContactList}
          handleCloseEncaminhar={this.handleCloseEncaminhar}
          handleForwardConfirm={this.handleForwardConfirm}
        />
        <div
          className="popover-box block no-margin-bottom"
          id="popover-all-notes"
        >
          <div className="block-header">
            <h1>
              Anotações <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
            </h1>
            <div className="close">
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </div>
          </div>
          <div className="block-content">
            <div className="column-user-details">
              <div className="user-name">André Luiz Batista Aureliano</div>
              <div className="user-time">
                <FontAwesomeIcon icon={["far", "clock"]} />
                <span className="time">00:00:00</span> na fila
              </div>
            </div>
          </div>
        </div>
        <div className="chat-wrapper is-visible" id="chat-wrapper">
          <div
            className="block full-height no-margin-bottom"
            id="chat"
            style={{ height: "100%" }}
          >
            <div
              className="block-header"
              style={{
                flexWrap: "wrap",
                //  minHeight: "66px"
              }}
            >
              <div className="column-user-details column-user-details--confer">
                <div className="user-confer">
                  <div className="user-photo">
                    {(() => {
                      if (typeof ContactId.pathfile != "undefined")
                        return (
                          <Topover
                            interactive={true}
                            content={this.renderPopoverInfo(
                              this,
                              IPCurrent.ip,
                              ContactId.pathfile,
                            )}
                          >
                            <img
                              src={
                                ContactId.pathfile.length > 2
                                  ? connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    ContactId.pathfile
                                  : DEFAULT
                              }
                              alt=""
                            />
                          </Topover>
                        );
                    })()}
                  </div>
                  <div className="user-name is-poppins">
                    <img
                      src="build/images/whatsapp_new.svg"
                      alt=""
                      className="user-name__channel-img"
                    />
                    Conferência iniciada por <strong>André</strong> <br /> (4
                    Participantes)
                  </div>
                </div>
              </div>
              <div
                className="column-user-details column-user-details active"
                style={{
                  minWidth: ContactId.idmidia === "3" ? "350px" : "200px",
                }}
              >
                <div className="user-photo">
                  {(() => {
                    if (ContactId) {
                      if (ContactId.idmidia === "5") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={WHATSAPPICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "4") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={FACEBOOKICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "12") {
                        return (
                          <span className="user-photo__channel">
                            <SMSICON />
                          </span>
                        );
                      } else if (ContactId.idmidia === "2") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={WEBCHATICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "3") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={EMAILICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "8") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={TELEGRANICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "1") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={VOZICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "6") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={INSTAGRAMICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "11") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={GOOGLEGBMICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "15") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={TEAMSICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      } else if (ContactId.idmidia === "16") {
                        return (
                          <span className="user-photo__channel">
                            <img
                              src={WHATSAPPVOZICON}
                              alt=""
                              className="user-name__channel-img"
                            />
                          </span>
                        );
                      }
                    }
                  })()}
                  {(() => {
                    if (typeof ContactId.pathfile != "undefined")
                      return (
                        <Topover
                          interactive={true}
                          content={this.renderPopoverInfo(
                            this,
                            IPCurrent.ip,
                            ContactId.pathfile,
                          )}
                        >
                          <UserPhoto
                            size="large"
                            link={
                              ContactId.pathfile.length > 2
                                ? connection_platform.type_connect +
                                  "://" +
                                  ipcurrent +
                                  ContactId.pathfile
                                : ""
                            }
                            letterIcon={createJSON(ContactId.cliente)}
                          />
                          {/* <img
                            src={
                              ContactId.pathfile.length > 2
                                ? connection_platform.type_connect +
                                  "://" +
                                  ipcurrent +
                                  ContactId.pathfile
                                : DEFAULT
                            }
                            alt=""
                          /> */}
                        </Topover>
                      );
                  })()}
                </div>
                <div className="username-rating">
                  <div className="user-name">
                    {createJSON(formatarNomeDoContato(ContactId.cliente))}
                    {/* {ContactId.idmidia === "3" &&
                      ContactId.telefone !== ContactId.cliente &&
                      ` <${ContactId.telefone}>`} */}
                  </div>

                  <div className="user-rating">
                    {this.renderAvaliation(ContactId)}
                  </div>
                </div>
                {this.state.atdsimult.map((simult, index) => {
                  var datatimeatd = Moment(
                    simult.recuperationtime,
                    "DD/MM/YYYY HH:mm:ss",
                  ).format("YYYY/MM/DD HH:mm:ss");
                  var valorDiferenca = parseInt(
                    Math.abs(Math.round(IPCurrent.difftime)),
                  );
                  var datacorreta = "";

                  if (parseInt(IPCurrent.difftime) < 0) {
                    datacorreta = Moment()
                      .subtract(valorDiferenca, "seconds")
                      .format("YYYY/MM/DD HH:mm:ss");
                  } else {
                    datacorreta = Moment()
                      .add(valorDiferenca, "seconds")
                      .format("YYYY/MM/DD HH:mm:ss");
                  }

                  var time = Moment(datacorreta).diff(datatimeatd, "seconds");

                  if (time < 0) {
                    time = 0;
                  }
                  return "";
                })}
              </div>
              {(() => {
                if (
                  //StatusAgent.status != "Chamando" ||
                  StatusAgent.status !== "" ||
                  ContactId.direction === 1
                ) {
                  return (
                    <div className="column-actions">
                      <button
                        onClick={(event) => {
                          try {
                            const contactIdString = JSON.stringify(ContactId);
                            console.log(
                              "INGENIUM_VOICE_ENCERRAMENTO ",
                              contactIdString,
                            );
                          } catch (error) {
                            console.log(
                              "INGENIUM_VOICE_ENCERRAMENTO_ERROR ",
                              error,
                            );

                            console.log(
                              "INGENIUM_VOICE_ENCERRAMENTO_ERROR_1 ",
                              ContactId,
                            );
                          }
                          if (
                            !!StatusAgent &&
                            StatusAgent.status === "Aftercallwork"
                          ) {
                            console.log(
                              "INGENIUM_VOICE_ENCERRAMENTO_AFTERCALLWORK",
                            );
                            this.ByeCall(
                              event,
                              ContactId,
                              InfoUsers,
                              AtdSimult,
                              Messages,
                              "encerramento",
                              IPCurrent,
                              StatusAgent,
                            );
                          } else if (!InfoUsers.confirm_before_close) {
                            console.log("INGENIUM_VOICE_ENCERRAMENTO_AQUI");
                            this.ByeCall(
                              event,
                              ContactId,
                              InfoUsers,
                              AtdSimult,
                              Messages,
                              "encerramento",
                              IPCurrent,
                              StatusAgent,
                            );
                          } else {
                            console.log("INGENIUM_VOICE_ENCERRAMENTO_AQUI2");
                            event.preventDefault();
                            MicroModal.show("modal__end-call");
                          }
                        }}
                        className="btn action with-icon not-clicable-tooltip"
                        id="chat-action-shutdown"
                        data-tooltip="Encerrar atendimento"
                      >
                        {/* <i className="material-icons">call_end</i> */}
                        <IconCallEnd />
                      </button>
                      {ContactId.idmidia === "3" && (
                        <>
                          {/* <ReactToPrint
                            trigger={() => ( */}
                          {/* <button
                            type="button"
                            className="btn action with-icon with-dropdown fix-center tippy-popover"
                            id="chat-action-transfer"
                            data-tooltip="Baixar"
                            onClick={() => this.printDivEmail()}
                            // data-template="popover-return-ura"
                            // style={{
                            //   display: StatusAgent.status == "Ligação" || StatusAgent.status == "Atendimento" ? "" : "none"
                            // }}
                          >
                            <i className="material-icons">download</i>
                          </button> */}
                          {/* )}
                            content={() => this.componentRef}
                          /> */}
                          {/* <button
                            type="button"
                            className="btn action with-icon with-dropdown fix-center tippy-popover"
                            id="chat-action-transfer"
                            data-tooltip="Mensagem"
                          >
                            <RepeatIcon />
                          </button> */}
                        </>
                      )}
                      {/* {ContactId.idmidia !== "3" && ( */}
                      <>
                        <button
                          onClick={(event) =>
                            this.mute(event, ContactId.statusatd)
                          }
                          style={{
                            display:
                              (StatusAgent.status === "Ligação" ||
                                StatusAgent.status === "Atendimento") &&
                              (parseInt(ContactId.idmidia) === 1 ||
                                parseInt(ContactId.idmidia) === 16)
                                ? ""
                                : "none",
                          }}
                          className={
                            ContactId.statusatd === 3
                              ? "btn action with-icon active not-clicable-tooltip"
                              : "btn action with-icon not-clicable-tooltip"
                          }
                          data-tooltip="Silenciar atendimento"
                        >
                          <i className="material-icons">mic_off</i>
                        </button>
                        <button
                          onClick={(event) =>
                            this.pause(event, ContactId.statusatd)
                          }
                          style={{
                            display:
                              (StatusAgent.status === "Ligação" ||
                                StatusAgent.status === "Atendimento") &&
                              (parseInt(ContactId.idmidia) === 1 ||
                                parseInt(ContactId.idmidia) === 16)
                                ? ""
                                : "none",
                          }}
                          className={
                            ContactId.statusatd === 2
                              ? "btn action with-icon active"
                              : "btn action with-icon"
                          }
                          data-tooltip="Colocar em espera"
                        >
                          <i className="material-icons">access_time</i>
                        </button>
                        <Popover
                          trigger="click"
                          interactive={true}
                          content={this.renderPopover2(
                            this,
                            IvrCallTransfer,
                            ContactId,
                            InfoUsers,
                            IPCurrent,
                          )}
                          onCreate={({ reference }) => {
                            reference = this.meuElemento;
                          }}
                        >
                          <button
                            ref={(elemento) => {
                              this.meuElemento = elemento;
                            }}
                            type="button"
                            className={`btn action with-icon with-dropdown fix-center tippy-popover not-clicable-tooltip ${
                              StatusAgent.status == "Ligação" ||
                              StatusAgent.status == "Atendimento" ||
                              StatusAgent.status == "Discando" ||
                              StatusAgent.status == "Chamando"
                                ? ""
                                : "disabled"
                            }`}
                            id="chat-action-transfer"
                            data-tooltip="Devolver para o BOT"
                            data-template="popover-return-ura"
                          >
                            {/* <i className="material-icons">phone_forwarded</i> */}
                            <IconTransferBot />
                          </button>
                        </Popover>
                        <Popover
                          trigger="click"
                          interactive={true}
                          content={this.renderPopover5(
                            this,
                            ContactId,
                            AtdSimult,
                            ExternConf,
                            outservices,
                            PermissionRouter,
                            InfoUsers,
                            StatusAgent,
                            listCallQueue,
                            IPCurrent,
                          )}
                        >
                          <button
                            type="button"
                            style={{
                              display:
                                StatusAgent.status == "Ligação" &&
                                (parseInt(ContactId.idmidia) === 1 ||
                                  parseInt(ContactId.idmidia) === 16)
                                  ? ""
                                  : "none",
                            }}
                            className="btn action with-icon with-dropdown tippy-popover"
                            id="chat-action-check-conference"
                            data-template="popover-check-conference"
                            data-tooltip="Conferência"
                          >
                            <i className="material-icons">groups</i>
                          </button>
                        </Popover>
                        <AgentButton />
                        <AddChannelCall />
                        {(() => {
                          if (
                            connection_platform.nc2_integration === true &&
                            ContactId.isDialNc2 === true &&
                            connection_platform.nc2_users.indexOf(
                              InfoUsers.ramal,
                            ) !== -1
                          ) {
                            return (
                              <button
                                type="button"
                                className="btn action with-icon with-dropdown fix-center tippy-popover"
                                id="chat-action-transfer"
                                data-tooltip="Resultado da ligação"
                                data-template="popover-return-agendamento"
                                onClick={(e) => this.getScheduleConfirm(e)}
                              >
                                {/* <i className="material-icons">local_offer</i> */}
                                {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.01 10.02">
                                          <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                              <path id="Path_5592" data-name="Path 5592" className="cls-1" d="M8.31,9.28V2.89H.72V9.28ZM8,1A1,1,0,0,1,9,2V9a1,1,0,0,1-1,1H1A1,1,0,0,1,0,9V2a1,1,0,0,1,.3-.71A.94.94,0,0,1,1,1h.49V0h1V1h4V0h1V1ZM6.29,8.23A3.94,3.94,0,0,1,2.36,4.3a.37.37,0,0,1,.35-.36h.8a.36.36,0,0,1,.25.11.31.31,0,0,1,.1.25h0A2.24,2.24,0,0,0,4,5a.28.28,0,0,1,0,.13.3.3,0,0,1-.12.26l-.41.41A4.16,4.16,0,0,0,4.75,7.11l.42-.41a.35.35,0,0,1,.25-.12.28.28,0,0,1,.13,0,2.34,2.34,0,0,0,.74.12.34.34,0,0,1,.36.35h0v.78a.35.35,0,0,1-.35.36Z" />
                                            </g>
                                          </g>
                                          </svg> */}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 9.01 10.02"
                                >
                                  <g id="Layer_2" data-name="Layer 2">
                                    <g id="Layer_1-2" data-name="Layer 1">
                                      <path
                                        id="Path_5592"
                                        data-name="Path 5592"
                                        className="cls-1"
                                        d="M8.31,9.28V2.89H.72V9.28ZM8,1A1,1,0,0,1,9,2V9a1,1,0,0,1-1,1H1A1,1,0,0,1,0,9V2a1,1,0,0,1,.3-.71A.94.94,0,0,1,1,1h.49V0h1V1h4V0h1V1ZM6.29,8.23A3.94,3.94,0,0,1,2.36,4.3a.37.37,0,0,1,.35-.36h.8a.36.36,0,0,1,.25.11.31.31,0,0,1,.1.25h0A2.24,2.24,0,0,0,4,5a.28.28,0,0,1,0,.13.3.3,0,0,1-.12.26l-.41.41A4.16,4.16,0,0,0,4.75,7.11l.42-.41a.35.35,0,0,1,.25-.12.28.28,0,0,1,.13,0,2.34,2.34,0,0,0,.74.12.34.34,0,0,1,.36.35h0v.78a.35.35,0,0,1-.35.36Z"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </button>
                            );
                          }
                        })()}
                      </>

                      {/* } */}
                      {connection_platform.isLinkDinamyc &&
                        ContactId.linkCopied !== true &&
                        parseInt(ContactId.idmidia) === 2 && (
                          <button
                            className="btn action with-icon"
                            id="chat-action-add-note"
                            data-tooltip="Copiar link dinâmico"
                            onClick={(event) =>
                              this.changeCopiedLinkDinamicy(
                                event,
                                ContactId,
                                InfoUsers,
                              )
                            }
                          >
                            <i className="material-icons">link</i>
                          </button>
                        )}
                      {connection_platform.isLinkDinamyc &&
                        ContactId.linkCopied && (
                          <button
                            className="btn action with-icon active"
                            id="chat-action-link-copied"
                            data-tooltip="Link dinâmico copiado!"
                            style={{
                              backgroundColor: "#43A047",
                              borderColor: "#43A047",
                              zIndex: "99999",
                            }}
                            onClick={(event) =>
                              this.changeCopiedLinkDinamicy(
                                event,
                                ContactId,
                                InfoUsers,
                              )
                            }
                          >
                            <i className="material-icons">check_circle</i>
                          </button>
                        )}
                      {/* <Tabulator
                        isDisabled={tabulationHandler.isExcededNumberOfClassifications(
                          this.props.tabulatedInfos,
                          this.props.ContactId,
                          this.props.InfoUsers,
                        )}
                      /> */}
                      <button
                        disabled={
                          tabulationHandler.isExcededNumberOfClassifications(
                            this.props.tabulatedInfos,
                            this.props.ContactId,
                            this.props.InfoUsers,
                          ) ||
                          !Boolean(
                            this.props.Tabulator &&
                            Array.isArray(this.props.Tabulator.three) &&
                            this.props.Tabulator.three.length > 0,
                          )
                        }
                        data-tooltip="Tabulador de Atendimento"
                        className={`button-to-open-new-tabulator not-clicable-tooltip ${
                          this.props.InfoUsers.classificationcount > 0 &&
                          !tabulationHandler.hasAnyTabulatedInfo(
                            this.props.tabulatedInfos,
                            this.props.ContactId,
                          )
                            ? "required"
                            : ""
                        }`}
                        onClick={() => {
                          this.openTabulationModal(
                            this.props.tabulatedInfos,
                            this.props.ContactId,
                            this.props.InfoUsers,
                          );
                        }}
                      >
                        <IconTabulator />
                      </button>
                      <button
                        style={{
                          display:
                            parseInt(ContactId.idmidia) !== 1 &&
                            parseInt(ContactId.idmidia) !== 16
                              ? ""
                              : "none",
                        }}
                        onClick={this.handleClick}
                        className="btn action with-icon not-clicable-tooltip"
                        id="chat-action-search"
                        data-tooltip="Pesquisar na conversa"
                      >
                        {/* <i className="material-icons">search</i> */}
                        <IconSearchChat />
                      </button>
                      <button
                        className={
                          this.state.activeCrm === true
                            ? "btn action with-icon active not-clicable-tooltip"
                            : "btn action with-icon not-clicable-tooltip"
                        }
                        id="chat-action-crm"
                        onClick={(event) =>
                          this.HandleNextAtd(
                            event,
                            "ocultar",
                            DisplayNextAtd.displaynextatd,
                          )
                        }
                        style={{
                          display:
                            InfoUsers.nameauth === "IngDesk" ||
                            InfoUsers.nameauth === "URLExt" ||
                            InfoUsers.nameauth === "IngCeub"
                              ? "flex"
                              : "none",
                        }}
                        data-tooltip="Abrir CRM"
                      >
                        {/* <svg
                          width="24"
                          height="24"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clip-rule="evenodd"
                            d="M7.22656 18.1245C7.22656 17.7794 7.50638 17.4995 7.85156 17.4995H13.9845C14.3296 17.4995 14.6095 17.7794 14.6095 18.1245V18.1245C14.6095 18.4697 14.3296 18.7495 13.9845 18.7495H7.85156C7.50638 18.7495 7.22656 18.4697 7.22656 18.1245V18.1245ZM7.22656 13.1247C7.22656 12.7796 7.50638 12.4997 7.85156 12.4997H17.1486C17.4937 12.4997 17.7736 12.7796 17.7736 13.1247V13.1247C17.7736 13.4699 17.4937 13.7497 17.1486 13.7497H7.85156C7.50639 13.7497 7.22656 13.4699 7.22656 13.1247V13.1247ZM7.22656 8.12495C7.22656 7.77977 7.50638 7.49995 7.85156 7.49995H17.1486C17.4937 7.49995 17.7736 7.77977 17.7736 8.12495V8.12495C17.7736 8.47013 17.4937 8.74995 17.1486 8.74995H7.85156C7.50638 8.74995 7.22656 8.47013 7.22656 8.12495V8.12495ZM19.7917 2.5H15.4375C15 1.05 13.8542 0 12.5 0C11.1458 0 10 1.05 9.5625 2.5H5.20833C5.0625 2.5 4.92708 2.5125 4.79167 2.55C4.38542 2.65 4.02083 2.9 3.73958 3.2375C3.55208 3.4625 3.39583 3.7375 3.29167 4.0375C3.1875 4.325 3.125 4.65 3.125 5V22.5C3.125 22.8375 3.1875 23.175 3.29167 23.475C3.39583 23.775 3.55208 24.0375 3.73958 24.275C4.02083 24.6125 4.38542 24.8625 4.79167 24.9625C4.92708 24.9875 5.0625 25 5.20833 25H19.7917C20.9375 25 21.875 23.875 21.875 22.5V5C21.875 3.625 20.9375 2.5 19.7917 2.5ZM19.7917 21.9258C19.7917 22.473 19.348 22.9167 18.8008 22.9167H6.19924C5.65198 22.9167 5.20833 22.473 5.20833 21.9258V5.15757C5.20833 4.61031 5.65198 4.16667 6.19924 4.16667H18.8008C19.348 4.16667 19.7917 4.61031 19.7917 5.15757V21.9258Z"
                            fill="#788693"
                          />
                        </svg> */}
                        <IconCRMOpen />
                      </button>
                      {/* <button
                        className="btn action with-icon active"
                        id="chat-action-pesq-sat"
                        data-tooltip="Pesquisa de satisfação"
                      >
                        <i className="material-icons">assignment_turned_in</i>
                      </button> */}
                      <a
                        onClick={(event) => this.HandleDetails(event, true)}
                        className={"btn inline" + this.state.showbuttondetails}
                        id="user-more-details"
                      >
                        Ver detalhes
                      </a>
                      {/*
                        <Popover
                          trigger="click"
                          interactive={true}
                          content={this.renderMoreOptions(ContactId)}
                        >
                          <button
                            className="btn action with-icon"
                            id="chat-action-more"
                            data-tooltip="Mais itens"
                          >
                            <IconMore />
                          </button>
                        </Popover>
                        */}
                      {hasPesquisaButton ? (
                        <MoreOptionsPopover
                          handleClick={this.handleClickOnMoreOptionsItem}
                          itemsOfMenu={[
                            {
                              id: "detalhes",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "detalhes" && this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "detalhes" &&
                                      this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill-stroke">
                                    <IconDetalhes />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Ver detalhes
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            {
                              id: "pesquisa",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "pesquisa" && this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "pesquisa" &&
                                      this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill-stroke">
                                    <IconPesquisa />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Pesquisa
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            ingFaqConditions.isCampaignActive && {
                              id: "campanhas",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "campanhas" &&
                                    this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "campanhas" &&
                                      this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill">
                                    <IconCampanha />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Campanhas
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            ingFaqConditions.isHelpActive && {
                              id: "ajuda",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "ajuda" && this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "ajuda" && this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                  onClick={() => {
                                    this.props.SideContentAttendanceSelectedAction(
                                      "ajuda",
                                    );
                                    this.props.OpenSideContent();
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill">
                                    <IconAjuda />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Ajuda
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            this.props.InfoUsers.standby_permission &&
                              !(
                                ContactId.idmidia === 1 ||
                                ContactId.idmidia === "1" ||
                                ContactId.idmidia === 16 ||
                                ContactId.idmidia === "16"
                              ) && {
                                id: "quarantineZone",
                                label: (
                                  <button
                                    className={`more-options-popover-on-quarantine-zone ${
                                      ContactId.idmidia === 1 ||
                                      ContactId.idmidia === "1" ||
                                      ContactId.idmidia === 16 ||
                                      ContactId.idmidia === "16" ||
                                      ContactId.idmidia === 3 ||
                                      ContactId.idmidia === "3"
                                        ? "disable"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      MicroModal.show("modal__quarantine-zone");
                                    }}
                                  >
                                    <div className="more-options-popover-on-quarantine-zone__icon">
                                      <IconQuarantine />
                                    </div>
                                    <span>Mover para Standby</span>
                                  </button>
                                ),
                              },
                          ]}
                        >
                          <IconMore />
                        </MoreOptionsPopover>
                      ) : (
                        <MoreOptionsPopover
                          handleClick={this.handleClickOnMoreOptionsItem}
                          itemsOfMenu={[
                            {
                              id: "detalhes",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "detalhes" && this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "detalhes" &&
                                      this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill-stroke">
                                    <IconDetalhes />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Ver detalhes
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            ingFaqConditions.isCampaignActive && {
                              id: "campanhas",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "campanhas" &&
                                    this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "campanhas" &&
                                      this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill">
                                    <IconCampanha />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Campanhas
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            ingFaqConditions.isHelpActive && {
                              id: "ajuda",
                              label: (
                                <div
                                  className={`more-options-popover-on-attendance__item ${
                                    this.props.SideContentAttendanceSelected ===
                                      "ajuda" && this.props.IsSideContentOpen
                                      ? "active"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      this.props
                                        .SideContentAttendanceSelected ===
                                        "ajuda" && this.props.IsSideContentOpen
                                        ? "#455cc7"
                                        : "#ffffff",
                                  }}
                                  onClick={() => {
                                    this.props.SideContentAttendanceSelectedAction(
                                      "ajuda",
                                    );
                                    this.props.OpenSideContent();
                                  }}
                                >
                                  <div className="more-options-popover-on-attendance__item-icon fill">
                                    <IconAjuda />
                                  </div>
                                  <div className="more-options-popover-on-attendance__item-label">
                                    <Typography.H5 color={"gray-180"}>
                                      Ajuda
                                    </Typography.H5>
                                  </div>
                                </div>
                              ),
                            },
                            this.props.InfoUsers.standby_permission &&
                              !(
                                ContactId.idmidia === 1 ||
                                ContactId.idmidia === "1" ||
                                ContactId.idmidia === 16 ||
                                ContactId.idmidia === "16"
                              ) && {
                                id: "quarantineZone",
                                label: (
                                  <button
                                    className={`more-options-popover-on-quarantine-zone ${
                                      ContactId.idmidia === 1 ||
                                      ContactId.idmidia === "1" ||
                                      ContactId.idmidia === 3 ||
                                      ContactId.idmidia === "3" ||
                                      ContactId.idmidia === 16 ||
                                      ContactId.idmidia === "16"
                                        ? "disable"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      MicroModal.show("modal__quarantine-zone");
                                    }}
                                  >
                                    <div className="more-options-popover-on-quarantine-zone__icon">
                                      <IconQuarantine />
                                    </div>
                                    <span>Mover para Standby</span>
                                  </button>
                                ),
                              },
                          ]}
                        >
                          <IconMore />
                        </MoreOptionsPopover>
                      )}
                    </div>
                  );
                }
              })()}
              <SearchBox
                value={this.state.searchText}
                activeconsulta={this.state.activeconsulta}
                handleSearchClick={this.handleClick}
                handleSearchChange={this.handleSearchChange}
                handleSearchKeyUp={this.handleKeyUp}
                lessAndMore={false}
              />
            </div>
            <div
              className="block-content chat-canvas"
              id="containers"
              ref="containers"
            >
              {ContactId.idmidia === "3" && (
                <div
                  id="attendance__mail"
                  className="attendance__mail"
                  ref="containers_mails"
                  // ref={(el) => (this.componentRef = el)}
                >
                  {MailMessage.sort((a, b) => {
                    try {
                      const dataA = parse(
                        a.date_sending,
                        "dd/MM/yyyy HH:mm",
                        new Date(),
                      );
                      const dataB = parse(
                        b.date_sending,
                        "dd/MM/yyyy HH:mm",
                        new Date(),
                      );

                      const order = compareAsc(dataA, dataB);
                      if (order === 0 && Boolean(a.id) && Boolean(b.id)) {
                        return parseInt(a.id) - parseInt(b.id);
                      }
                      return order;
                    } catch {
                      return 0;
                    }
                  })
                    .filter(
                      (message) => message.cdr === ContactId.idatendimento,
                    )
                    .map((mail) => (
                      <MailContainer
                        mail={mail}
                        inputSearch={this.state.searchText}
                      />
                    ))}
                </div>
              )}
              <StatusAgentStatus
                status={StatusAgent.status}
                idmidia={ContactId.idmidia}
              />
              {StatusAgent.status !== "ChamandoChat" &&
                ContactId.idmidia !== 3 &&
                ContactId.idmidia !== "3" &&
                ContactId.idmidia !== 1 &&
                ContactId.idmidia !== "1" &&
                ContactId.idmidia !== 16 &&
                ContactId.idmidia !== "16" && (
                  <div>
                    <PreviousMessages
                      cdr={this.props.ContactId.idatendimento}
                      number={this.props.ContactId.telefone}
                      mediaId={parseInt(this.props.ContactId.idmidia)}
                    />
                  </div>
                )}
              {!connection_platform.attendance_screen_new &&
                NovaMensagem.map((message, i) => {
                  if (message.dia != auxdia) {
                    dia = message.dia;
                    auxdia = message.dia;
                  } else {
                    auxdia = message.dia;
                    dia = "";
                  }
                  var positmessage1 = "message left";
                  var positmessage2 = "fav fav--left";
                  if (message.author === "Me") {
                    positmessage1 = "message right";
                    positmessage2 = "fav fav--right";
                  }

                  if (message.destiny === "Gestor") {
                    positmessage1 = "message gestor";
                    positmessage2 = "fav fav--left";
                  }

                  // var verifystar = this.state.active;
                  var mensagem_tratada = message.message.replace(/¿/gi, "\n");
                  if (message.typemsg === "2") {
                    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
                  }
                  if (
                    parseInt(ContactId.idatendimento) ===
                    parseInt(message.contactid)
                  ) {
                    if (message.author === "Me" && message.typemsg === "0") {
                      const msgProps = {
                        positmessage1,
                        message,
                        mensagem_tratada,
                        latinize,
                        searchWords,
                        dia,
                        InfoUsers,
                        ContactId,
                        NovaMensagem,
                        isChecked:
                          this.state.forwardMsgList.filter(
                            (msg) =>
                              msg.message.messageid === message.messageid,
                          ).length > 0
                            ? true
                            : false,
                      };
                      return (
                        <MessageContainer
                          key={i}
                          msgIndex={i}
                          markstar2={this.markstar2}
                          {...msgProps}
                          handleCheck={this.handleCheck}
                          handleReply={this.handleReply}
                        />
                      );
                    } else if (
                      message.typemsg === "0" ||
                      message.typemsg === "2"
                    ) {
                      const msgProps = {
                        positmessage1,
                        message,
                        mensagem_tratada,
                        latinize,
                        searchWords,
                        dia,
                        InfoUsers,
                        ContactId,
                        NovaMensagem,
                        isChecked:
                          this.state.forwardMsgList.filter(
                            (msg) =>
                              msg.message.messageid === message.messageid,
                          ).length > 0
                            ? true
                            : false,
                      };
                      return (
                        <MessageContainer
                          key={i}
                          markstar2={this.markstar2}
                          {...msgProps}
                          msgIndex={i}
                          handleCheck={this.handleCheck}
                          handleReply={this.handleReply}
                        />
                      );
                    } else if (message.typemsg === "1") {
                      var get_json = message.message;
                      let separadorurlcaption = get_json.split("~¿");
                      let thumbnail = separadorurlcaption[0];
                      let caption = separadorurlcaption[1];
                      let size = separadorurlcaption[3];
                      if (caption) caption = caption.replace(/¿/gi, "\r\n");
                      if (caption == "null") caption = "";
                      let url = separadorurlcaption[2];
                      if (url) {
                        let separador = url.split(".");
                        let get_name = separador[0].split("/");
                        let verificarexistencia = "";

                        // eslint-disable-next-line default-case
                        if (
                          separador[1] !== undefined &&
                          separador[1] !== "undefined"
                        ) {
                          switch (separador[1].toLowerCase()) {
                            case "jpeg":
                            case "png":
                            case "jpg": {
                              const msgProps = {
                                positmessage1,
                                dia,
                                IPCurrent,
                                size,
                                caption,
                                url,
                                InfoUsers,
                                ContactId,
                                message,
                                JPG,
                                isChecked:
                                  this.state.forwardMsgList.filter(
                                    (msg) =>
                                      msg.message.messageid ===
                                      message.messageid,
                                  ).length > 0
                                    ? true
                                    : false,
                              };
                              return (
                                <MessageContainerMedia
                                  mediaType="image"
                                  key={i}
                                  markstar2={this.markstar2}
                                  handleCheck={this.handleCheck}
                                  {...msgProps}
                                  handleDirectForward={this.handleDirectForward}
                                  handleReply={this.handleReply}
                                />
                              );
                            }
                            case "pdf":
                              if (
                                thumbnail === " " ||
                                thumbnail === null ||
                                thumbnail === "null"
                              ) {
                                verificarexistencia = "";
                              } else {
                                verificarexistencia = "";
                              }
                              {
                                const msgProps = {
                                  verificarexistencia,
                                  positmessage1,
                                  dia,
                                  IPCurrent,
                                  PDF,
                                  InfoUsers,
                                  ContactId,
                                  message,
                                  size,
                                  caption,
                                  url,
                                  isChecked:
                                    this.state.forwardMsgList.filter(
                                      (msg) =>
                                        msg.message.messageid ===
                                        message.messageid,
                                    ).length > 0
                                      ? true
                                      : false,
                                };
                                return (
                                  <MessageContainerPDF
                                    key={i}
                                    handleDirectForward={
                                      this.handleDirectForward
                                    }
                                    handleCheck={this.handleCheck}
                                    markstar2={this.markstar2}
                                    handleReply={this.handleReply}
                                    {...msgProps}
                                  />
                                );
                              }
                            case "xls":
                            case "xlsx":
                            case "xlsm":
                            case "txt":
                            case "doc":
                            case "docx":
                            case "ppt":
                            case "pptx": {
                              const msgProps = {
                                positmessage1,
                                dia,
                                IPCurrent,
                                InfoUsers,
                                ContactId,
                                message,
                                size,
                                caption,
                                url,
                                isChecked:
                                  this.state.forwardMsgList.filter(
                                    (msg) =>
                                      msg.message.messageid ===
                                      message.messageid,
                                  ).length > 0
                                    ? true
                                    : false,
                              };
                              return (
                                <MessageContainerDocs
                                  key={i}
                                  markstar2={this.markstar2}
                                  handleCheck={this.handleCheck}
                                  {...msgProps}
                                  handleReply={this.handleReply}
                                  handleDirectForward={this.handleDirectForward}
                                />
                              );
                            }
                            case "wav":
                            case "mp3":
                            case "ogg":
                            case "mpeg": {
                              const msgProps = {
                                positmessage1,
                                dia,
                                IPCurrent,
                                url,
                                MP3,
                                ContactId,
                                message,
                                size,
                                InfoUsers,
                                isChecked:
                                  this.state.forwardMsgList.filter(
                                    (msg) =>
                                      msg.message.messageid ===
                                      message.messageid,
                                  ).length > 0
                                    ? true
                                    : false,
                              };
                              return (
                                // <MessageContainerAudio
                                //   {...msgProps}
                                //   key={message.id}
                                //   markstar2={this.markstar2}
                                // />
                                <MessageContainerMedia
                                  mediaType="audio"
                                  {...msgProps}
                                  key={i}
                                  markstar2={this.markstar2}
                                  handleCheck={this.handleCheck}
                                  handleDirectForward={this.handleDirectForward}
                                  handleReply={this.handleReply}
                                />
                              );
                            }
                            case "mp4": {
                              const msgProps = {
                                AVI,
                                size,
                                url,
                                IPCurrent,
                                positmessage1,
                                message,
                                dia,
                                caption,
                                InfoUsers,
                                ContactId,
                                isChecked:
                                  this.state.forwardMsgList.filter(
                                    (msg) =>
                                      msg.message.messageid ===
                                      message.messageid,
                                  ).length > 0
                                    ? true
                                    : false,
                              };
                              return (
                                // <MessageContainerVideo
                                //   {...msgProps}
                                //   key={message.id}
                                //   markstar2={this.markstar2}

                                // />
                                <MessageContainerMedia
                                  mediaType="video"
                                  {...msgProps}
                                  key={i}
                                  markstar2={this.markstar2}
                                  handleCheck={this.handleCheck}
                                  handleDirectForward={this.handleDirectForward}
                                  handleReply={this.handleReply}
                                />
                              );
                            }
                            default:
                              if (
                                thumbnail === " " ||
                                thumbnail === null ||
                                thumbnail === "null"
                              ) {
                                verificarexistencia = "";
                              } else {
                                verificarexistencia = "";
                              }

                              {
                                const msgProps = {
                                  verificarexistencia,
                                  positmessage1,
                                  dia,
                                  IPCurrent,
                                  PDF,
                                  InfoUsers,
                                  ContactId,
                                  message,
                                  size,
                                  caption,
                                  url,
                                  isChecked:
                                    this.state.forwardMsgList.filter(
                                      (msg) =>
                                        msg.message.messageid ===
                                        message.messageid,
                                    ).length > 0
                                      ? true
                                      : false,
                                };
                                return (
                                  <MessageContainerDefault
                                    key={i}
                                    handleDirectForward={
                                      this.handleDirectForward
                                    }
                                    handleCheck={this.handleCheck}
                                    markstar2={this.markstar2}
                                    handleReply={this.handleReply}
                                    {...msgProps}
                                  />
                                );
                              }
                            //if(history.messagem.indexOf("https")> -1 && history.messagem!==""){
                          }
                        }
                      }
                    } else if (message.typemsg === "4") {
                      const msgProps = {
                        positmessage1,
                        message,
                        mensagem_tratada,
                        latinize,
                        searchWords,
                        dia,
                        InfoUsers,
                        ContactId,
                        isChecked:
                          this.state.forwardMsgList.filter(
                            (msg) =>
                              msg.message.messageid === message.messageid,
                          ).length > 0
                            ? true
                            : false,
                      };
                      return (
                        <MessageContainerLocation
                          key={i}
                          markstar2={this.markstar2}
                          {...msgProps}
                          msgIndex={i}
                          handleCheck={this.handleCheck}
                          handleReply={this.handleReply}
                        />
                      );
                    }
                  }
                })}

              {connection_platform.attendance_screen_new &&
                NovaMensagem.filter(commentFilters).map((message, i) => {
                  if (message.dia != auxdia) {
                    dia = message.dia;
                    auxdia = message.dia;
                  } else {
                    auxdia = message.dia;
                    dia = "";
                  }
                  var positmessage1 = "message left";
                  var positmessage2 = "fav fav--left";
                  if (message.author === "Me") {
                    positmessage1 = "message right";
                    positmessage2 = "fav fav--right";
                  }

                  if (message.destiny === "Gestor") {
                    positmessage1 = "message gestor";
                    positmessage2 = "fav fav--left";
                  }

                  // var verifystar = this.state.active;
                  var mensagem_tratada = message.message.replace(/¿/gi, "\n");

                  let nameUser = ContactId.cliente;

                  if (message.author === "Me" || message.typemon !== "0") {
                    if (message.username) {
                      nameUser =
                        InfoUsers.username === message.username
                          ? "Você"
                          : message.username;
                    } else {
                      nameUser = "Você";
                    }
                  }

                  let replyProps = "";
                  let replyInOtherCdr = "";
                  const haveReply =
                    message.replyid !== "null" &&
                    message.replyid !== "undefined" &&
                    message.replyid !== "0" &&
                    message.replyid !== "";

                  if (haveReply) {
                    const array = NovaMensagem.filter(
                      (msg) => msg.messageid === message.replyid,
                    );

                    if (array && array.length > 0) {
                      let typenameMsg = "mensagem";

                      try {
                        if (array[0].typemsg === "1") {
                          const get_json = array[0].message;
                          let separadorurlcaption = get_json.split("~¿");
                          let url = separadorurlcaption[2];
                          let separador = url.split(".");

                          switch (separador[1].toLowerCase()) {
                            case "jpeg":
                            case "png":
                            case "webp":
                            case "jpe":
                            case "gif":
                            case "bmp":
                            case "jpg":
                              typenameMsg = "image";
                              break;
                            case "pdf":
                            case "zip":
                            case "xls":
                            case "xml":
                            case "xlsx":
                            case "xlsm":
                            case "txt":
                            case "doc":
                            case "docx":
                            case "ppt":
                            case "pptx":
                            case "ppsx":
                              typenameMsg = "document";
                              break;
                            case "wav":
                            case "mp3":
                            case "ogg":
                            case "aac":
                            case "m4a":
                            case "amr":
                            case "opus":
                            case "mpeg":
                              typenameMsg = "audio";
                              break;
                            case "m4v":
                            case "mp4":
                              typenameMsg = "video";
                              break;
                            default:
                              break;
                          }
                        }
                      } catch (error) {
                        console.log("INGENIUM_ERROR_TYPE 9074", error);
                      }

                      let textSeparator = array[0].message.split("~¿");
                      let text = textSeparator[0];
                      text = text.replace(/¿/gi, "\n");
                      text = text.replace(/§/gi, "\r\n");

                      let nameReply = ContactId.cliente;
                      if (
                        array[0].author === "Me" ||
                        array[0].typemon !== "0"
                      ) {
                        if (array[0].username) {
                          nameReply =
                            InfoUsers.username === array[0].username
                              ? "Você"
                              : array[0].username;
                        } else {
                          nameReply = "Você";
                        }
                      }

                      replyProps = {
                        id: message.replyid,
                        username: nameReply,
                        typename: typenameMsg,
                        mimetype: array[0].typemsg,
                        mensagem:
                          array[0].typemsg === "4"
                            ? "Localização"
                            : array[0].typemsg === "11"
                              ? "Contato"
                              : text,
                      };
                    } else {
                      replyInOtherCdr = { id: message.replyid };
                    }
                  }
                  //commentFilters
                  if (
                    parseInt(ContactId.idatendimento) ===
                    parseInt(message.contactid)
                  ) {
                    if (message.typemsg === "0") {
                      return (
                        <InteractionChat
                          key={i}
                          index={i}
                          id={message.messageid}
                          inputSearch={searchText}
                          text={mensagem_tratada}
                          type={""}
                          date={{
                            dia: dia,
                            horaEnvio: message.datatime,
                            statusmsg: message.statusmsg,
                          }}
                          titlemsg={message.titlemsg}
                          attachment={message.file}
                          size={message.size}
                          mimetypeId={message.mimetypeid}
                          mimetype={message.mimetype}
                          typeName={message.typename}
                          name={nameUser}
                          direction={
                            message.author === "Me" && message.typemon === "0"
                              ? "right"
                              : "left"
                          }
                          buttons={message.buttons}
                          botId={message.botid}
                          reply={haveReply ? replyProps : false}
                          buttonResponse={message.buttonResponse}
                          location={message.location}
                          allInfo={message}
                          handleReply={this.handleReply}
                          handleFavorite={this.markstar2}
                          InfoUsers={InfoUsers}
                          ContactId={ContactId}
                          replyInOtherCdr={replyInOtherCdr}
                        />
                        // <MessageContainer
                        //   key={i}
                        //   msgIndex={i}
                        //   markstar2={this.markstar2}
                        //   {...msgProps}
                        //   handleCheck={this.handleCheck}
                        //   handleReply={this.handleReply}
                        // />
                      );
                    } else if (message.typemsg === "2") {
                      var get_json = message.message.replace(/§/gi, "\r\n");
                      let separadorurlcaption = get_json.split("~¿");
                      let messageSeparada = separadorurlcaption[0]
                        .replace(/¿¿/gi, "\r\n\r\n")
                        .replace(/¿/gi, "\r\n");
                      let url = separadorurlcaption[1];
                      let infos = message.options.split("§");
                      let separador = infos[1].split("¿");
                      let buttons = "";
                      if (infos[1]) {
                        buttons = JSON.parse(
                          infos[1].replace(/(?<!\w)'|'(?!\w)/g, '"'),
                        );
                      }

                      let responseButton = "";
                      const arrayFind = NovaMensagem.find(
                        (msg) => msg.replyid === message.messageid,
                      );

                      if (arrayFind) {
                        responseButton = arrayFind.message;
                      }

                      let typeFile = "";
                      let fileObject = "";
                      if (url && url !== "null" && url !== "undefined") {
                        let separadorUrl = url.split(".");
                        let get_name = separadorUrl[0].split("/");
                        let verificarexistencia = "";
                        if (separadorUrl[1]) {
                          switch (separadorUrl[1].toLowerCase()) {
                            case "jpeg":
                            case "png":
                            case "jpg":
                              typeFile = "image";
                              break;
                            case "pdf":
                            case "xls":
                            case "xlsx":
                            case "xlsm":
                            case "txt":
                            case "doc":
                            case "docx":
                            case "ppt":
                            case "pptx":
                              typeFile = "document";
                              break;
                            case "wav":
                            case "mp3":
                            case "ogg":
                            case "mpeg":
                              typeFile = "audio";
                              break;
                            case "mp4":
                              typeFile = "video";
                              break;
                            default:
                              break;
                          }
                        }

                        fileObject = {
                          name: get_name[get_name.length - 1],
                          size: "",
                          type: typeFile,
                          path_arquivos: url,
                          extension: separadorUrl[1]
                            ? separadorUrl[1].toLowerCase()
                            : "",
                          id: message.messageid,
                        };
                      }

                      return (
                        <InteractionChat
                          key={i}
                          index={i}
                          id={message.messageid}
                          inputSearch={searchText}
                          text={messageSeparada}
                          type={""}
                          date={{
                            dia: dia,
                            horaEnvio: message.datatime,
                            statusmsg: message.statusmsg,
                          }}
                          titlemsg={message.titlemsg}
                          attachment={fileObject}
                          size={message.size}
                          mimetypeId={infos[0]}
                          mimetype={message.mimetype}
                          typeName={message.typename}
                          name={nameUser}
                          direction={
                            message.author === "Me" && message.typemon === "0"
                              ? "right"
                              : "left"
                          }
                          buttons={buttons}
                          botId={infos[2]}
                          reply={haveReply ? replyProps : false}
                          buttonResponse={responseButton}
                          location={message.location}
                          allInfo={message}
                          handleReply={this.handleReply}
                          handleFavorite={this.markstar2}
                          InfoUsers={InfoUsers}
                          ContactId={ContactId}
                          replyInOtherCdr={replyInOtherCdr}
                        />
                        // <MessageContainer
                        //   key={i}
                        //   markstar2={this.markstar2}
                        //   {...msgProps}
                        //   msgIndex={i}
                        //   handleCheck={this.handleCheck}
                        //   handleReply={this.handleReply}
                        // />
                      );
                    } else if (message.typemsg === "1") {
                      var get_json = message.message;
                      let separadorurlcaption = get_json.split("~¿");
                      let thumbnail = separadorurlcaption[0];
                      let caption = separadorurlcaption[1];
                      let size = separadorurlcaption[3];
                      if (caption) caption = caption.replace(/¿/gi, "\r\n");
                      if (caption == "null") caption = "";
                      let url = separadorurlcaption[2];
                      if (url) {
                        let separador = url.split(".");
                        let get_name = separador[0].split("/");
                        let verificarexistencia = "";

                        // eslint-disable-next-line default-case

                        if (
                          separador[1] !== undefined &&
                          separador[1] !== "undefined"
                        ) {
                          let typenameMsg = "txt";
                          switch (separador[1].toLowerCase()) {
                            case "jpeg":
                            case "png":
                            case "webp":
                            case "jpe":
                            case "gif":
                            case "bmp":
                            case "jpg": {
                              typenameMsg = "image";
                              break;
                            }
                            case "pdf":
                            case "zip":
                            case "xls":
                            case "xml":
                            case "xlsx":
                            case "xlsm":
                            case "txt":
                            case "doc":
                            case "docx":
                            case "ppt":
                            case "pptx":
                            case "ppsx": {
                              typenameMsg = "document";
                              break;
                            }
                            case "wav":
                            case "mp3":
                            case "ogg":
                            case "aac":
                            case "m4a":
                            case "amr":
                            case "opus":
                            case "mpeg": {
                              typenameMsg = "audio";
                              break;
                            }
                            case "m4v":
                            case "mp4": {
                              typenameMsg = "video";
                              break;
                            }
                            default:
                              typenameMsg = "document";
                              break;
                          }

                          let fileObject = {
                            name: get_name[get_name.length - 1],
                            size: size,
                            type: typenameMsg,
                            path_arquivos: url,
                            extension: separador[1].toLowerCase(),
                            id: message.messageid,
                          };

                          return (
                            <InteractionChat
                              key={i}
                              index={i}
                              id={message.messageid}
                              inputSearch={searchText}
                              text={caption}
                              type={"attachment"}
                              date={{
                                dia: dia,
                                horaEnvio: message.datatime,
                                statusmsg: message.statusmsg,
                              }}
                              titlemsg={message.titlemsg}
                              attachment={fileObject}
                              size={size}
                              mimetypeId={message.mimetypeid}
                              mimetype={message.mimetype}
                              typeName={typenameMsg}
                              name={nameUser}
                              direction={
                                message.author === "Me" &&
                                message.typemon === "0"
                                  ? "right"
                                  : "left"
                              }
                              buttons={message.buttons}
                              botId={message.botid}
                              reply={haveReply ? replyProps : false}
                              buttonResponse={message.buttonResponse}
                              location={message.location}
                              allInfo={message}
                              handleReply={this.handleReply}
                              handleFavorite={this.markstar2}
                              InfoUsers={InfoUsers}
                              ContactId={ContactId}
                              replyInOtherCdr={replyInOtherCdr}
                            />
                          );
                        }
                      }
                    } else if (message.typemsg === "4") {
                      let infosLocation = message.message.split("~¿");
                      let location = {
                        latitude: infosLocation[3],
                        longitude: infosLocation[2],
                        nomeEndereco: infosLocation[1],
                        endereco: infosLocation[0],
                      };

                      return (
                        <InteractionChat
                          key={i}
                          index={i}
                          id={message.messageid}
                          inputSearch={searchText}
                          text={`${infosLocation[1]}\n${infosLocation[0]}`}
                          type={""}
                          date={{
                            dia: dia,
                            horaEnvio: message.datatime,
                            statusmsg: message.statusmsg,
                          }}
                          titlemsg={message.titlemsg}
                          attachment={message.file}
                          size={message.size}
                          mimetypeId={message.mimetypeid}
                          mimetype={message.mimetype}
                          typeName={message.typename}
                          name={nameUser}
                          direction={
                            message.author === "Me" && message.typemon === "0"
                              ? "right"
                              : "left"
                          }
                          buttons={message.buttons}
                          botId={message.botid}
                          reply={haveReply ? replyProps : false}
                          buttonResponse={message.buttonResponse}
                          location={location}
                          allInfo={message}
                          handleReply={this.handleReply}
                          handleFavorite={this.markstar2}
                          InfoUsers={InfoUsers}
                          ContactId={ContactId}
                          replyInOtherCdr={replyInOtherCdr}
                        />
                        // <MessageContainerLocation
                        //   key={i}
                        //   markstar2={this.markstar2}
                        //   {...msgProps}
                        //   msgIndex={i}
                        //   handleCheck={this.handleCheck}
                        //   handleReply={this.handleReply}
                        // />
                      );
                    } else if (message.typemsg === "11") {
                      const cleanedJsonString = message.message.replace(
                        /\\(?!["\\/bfnrtu])/g,
                        "",
                      );
                      const contactInfo = JSON.parse(
                        cleanedJsonString.replace(/(?<!\w)'|'(?!\w)/g, '"'),
                      );
                      return (
                        <InteractionChat
                          bind={this}
                          key={i}
                          index={i}
                          id={message.messageid}
                          inputSearch={searchText}
                          text={""}
                          type={""}
                          date={{
                            dia: dia,
                            horaEnvio: message.datatime,
                            statusmsg: message.statusmsg,
                          }}
                          attachment={message.file}
                          size={message.size}
                          mimetypeId={message.mimetypeid}
                          mimetype={message.mimetype}
                          typeName={message.typename}
                          name={nameUser}
                          direction={
                            message.author === "Me" && message.typemon === "0"
                              ? "right"
                              : "left"
                          }
                          buttons={message.buttons}
                          botId={message.botid}
                          reply={haveReply ? replyProps : false}
                          buttonResponse={message.buttonResponse}
                          location={message.location}
                          allInfo={message}
                          handleReply={this.handleReply}
                          handleFavorite={this.markstar2}
                          InfoUsers={InfoUsers}
                          ContactId={ContactId}
                          contactInfo={contactInfo}
                          contactLinkAdd={this.handleAddContact}
                          replyInOtherCdr={replyInOtherCdr}
                        />
                      );
                    }
                  }
                })}

              {typing_w}
              <div
                style={{ display: ContactId.line != "0" ? "block" : "none" }}
                className={
                  this.state.activedtmf ? "phone-dtmf active" : "phone-dtmf"
                }
              >
                <div className="phone-dtmf__content">
                  <div
                    className="phone-dtmf__minimize"
                    onClick={() =>
                      this.setState({ activedtmf: !this.state.activedtmf })
                    }
                  >
                    <div className="phone-dtmf__minimize__icon">
                      <i className="material-icons">remove</i>
                    </div>
                  </div>

                  <div className="phone-dtmf__input">
                    <input
                      type="number"
                      onChange={(e) => this.digitnumberdtmf(e)}
                      id="phone-dtmf__input__item"
                      className="phone-dtmf__input__item"
                      placeholder="123..."
                    />

                    <button
                      onClick={this.removedtmf}
                      className="phone-dtmf__input__backspace"
                    >
                      <i className="material-icons">backspace</i>
                    </button>
                  </div>
                  <div className="phone-dtmf__numeric">
                    <div className="phone-dtmf__numeric__row">
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(1, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          1
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text"></div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(2, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          2
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          abc
                        </div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(3, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          3
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          def
                        </div>
                      </button>
                    </div>
                    <div className="phone-dtmf__numeric__row">
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(4, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          4
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          ghi
                        </div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(5, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          5
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          jkl
                        </div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(6, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          6
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          mno
                        </div>
                      </button>
                    </div>
                    <div className="phone-dtmf__numeric__row">
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(7, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          7
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          pqrs
                        </div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(8, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          8
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          tuv
                        </div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(9, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          9
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          wxyz
                        </div>
                      </button>
                    </div>
                    <div className="phone-dtmf__numeric__row">
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf("*", e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          *
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text"></div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf(0, e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          0
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text">
                          +
                        </div>
                      </button>
                      <button
                        className="phone-dtmf__numeric__row__item"
                        onClick={(e) => this.numberdtmf("#", e)}
                      >
                        <div className="phone-dtmf__numeric__row__item__number">
                          #
                        </div>
                        <div className="phone-dtmf__numeric__row__item__text"></div>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="phone-dtmf--closed"
                  onClick={() =>
                    this.setState({ activedtmf: !this.state.activedtmf })
                  }
                >
                  <div className="phone-dtmf--closed__title">
                    Teclado numérico
                  </div>
                  <div className="phone-dtmf--closed__dialpad">
                    <i className="material-icons">dialpad</i>
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={(event) => this.removeImageSplit(event)}
              style={{
                width: "150px",
                left: "20px",
                marginLeft: "5px",
                position: "relative",
              }}
              className="phone-dtmf active"
            >
              <img width="150" src={null} id="contein" />
            </div>
            {hasFilesInStageArea && (
              <StageAreaOfFiles
                filesInStage={this.state.filesInStage}
                ContactId={ContactId}
                setFilesInStage={(updatedFilesInStage) => {
                  this.setState({
                    filesInStage: updatedFilesInStage,
                  });
                }}
              />
            )}
            <div
              style={{
                alignItems: "center",
                marginBottom: "10px",
                marginLeft: "16px",
                display:
                  this.state.editableQuickAnswer === true ? "flex" : "none",
              }}
            >
              <DangerIconSVG />
              <span style={{ marginLeft: "8px" }}>
                Esta mensagem não pode ser editada.
              </span>
            </div>
            <div
              className="block-footer"
              // style={{
              //   maxHeight: this.state.isVisibleBox ? "350px" : "64px",
              //   paddingBottom: this.state.isVisibleBox ? "4px" : "18px",
              // }}
            >
              {/* style={{display: (simult.idatendimento != ContactId.idatendimento) ? 'block' : 'none' }} */}
              <div
                className={
                  this.state.showreplyopNew[this.props.ContactId.idatendimento]
                    ? "reply-message active"
                    : "reply-message"
                }
              >
                {(() => {
                  if (
                    this.state.showreplyopNew[
                      this.props.ContactId.idatendimento
                    ]
                  ) {
                    var text = "";
                    var array = [];
                    var posit = "";
                    array = NovaMensagem.filter(
                      (msg) =>
                        msg.messageid ===
                        (this.state.showreplyopNew[
                          this.props.ContactId.idatendimento
                        ]
                          ? this.state.showreplyopNew[
                              this.props.ContactId.idatendimento
                            ]
                          : 0),
                    );
                    if (array.length !== 0 && array) {
                      posit = array[0].author;
                      let nameUser = createJSON(ContactId.cliente);

                      if (
                        array[0].author === "Me" ||
                        array[0].typemon !== "0"
                      ) {
                        if (array[0].username) {
                          nameUser =
                            InfoUsers.username === array[0].username
                              ? "Você"
                              : array[0].username;
                        } else {
                          nameUser = "Você";
                        }
                      }
                      if (array[0].typemsg === "11") {
                        return (
                          <div className="reply-message__container">
                            <div className="reply-message__name">
                              {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                              {nameUser}
                            </div>
                            <div className="reply-message__text">Contato</div>
                          </div>
                        );
                      } else if (
                        array[0].typemsg !== "0" &&
                        array[0].typemsg !== "2" &&
                        array[0].typemsg !== "4"
                      ) {
                        var url = array[0].message;
                        url = url.split("~¿");
                        url = url[2];
                        url = url.substring(url.lastIndexOf(".") + 1);
                        switch (url.toLowerCase()) {
                          case "jpeg":
                          case "png":
                          case "jpg": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={FOTO} alt="" width="15" /> Imagem
                                </div>
                              </div>
                            );
                          }
                          case "pdf":
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={DOC} alt="" width="15" /> PDF
                                </div>
                              </div>
                            );
                          case "xls":
                          case "xlsx":
                          case "doc":
                          case "docx":
                          case "ppt":
                          case "pptx": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={DOC} alt="" width="15" /> DOC
                                </div>
                              </div>
                            );
                          }
                          case "wav":
                          case "mp3":
                          case "ogg":
                          case "mpeg": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={AUDIO} alt="" width="12" /> Áudio
                                </div>
                              </div>
                            );
                          }
                          case "mp4": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={VIDEO} alt="" width="15" /> Vídeo
                                </div>
                              </div>
                            );
                          }
                        }
                      } else if (array[0].typemsg === "4") {
                        // text = array[0].message;
                        // if (text.length > 200)
                        //   text = text.substr(0, 200) + "...";
                        // text = text.replace(/¿/gi, "\n");
                        // text = text.replace(/§/gi, "\r\n");
                        return (
                          <div className="reply-message__container">
                            <div className="reply-message__name">
                              {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                              {nameUser}
                            </div>
                            <div className="reply-message__text">
                              Localização
                            </div>
                          </div>
                        );
                      } else {
                        text = array[0].message;
                        text = text.replace(/§/gi, "\r\n");

                        if (array[0].typemsg === "2") {
                          let msgSeparator = text.split("~¿");
                          text = msgSeparator[0];
                        }

                        text = text
                          .replace(/¿/gi, "\n")
                          .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1");

                        if (text.length > 200)
                          text = text.substr(0, 200) + "...";

                        return (
                          <div className="reply-message__container">
                            <div className="reply-message__name">
                              {/* {posit === "Me"
                                    ? "Você"
                                    : createJSON(ContactId.cliente)} */}
                              {nameUser}
                            </div>
                            <div className="reply-message__text">{text}</div>
                          </div>
                        );
                      }
                    }
                  }
                })()}
                <div
                  className="reply-message__close"
                  onClick={
                    (event) => this.clearReplyToThisCdr()
                    // this.setState({
                    //   showreplyop: !this.state.showreplyop,
                    //   idreplyop: 0,
                    // })
                  }
                >
                  <i className="material-icons">close</i>
                </div>
              </div>
              {StatusAgent.status !== "Aftercallwork" && (
                <div
                  className="message-box-mail"
                  style={{ display: ContactId.idmidia === "3" ? "" : "none" }}
                >
                  <MailBox
                    isVisibleBox={this.state.isVisibleBox}
                    changeVisibleBoxMail={this.changeVisibleBoxMail}
                    bindAttendance={this}
                  />
                </div>
              )}
              <div
                className="message-box new-chat"
                style={{
                  display:
                    ContactId.idmidia === "1" ||
                    ContactId.idmidia === "3" ||
                    ContactId.idmidia === "16" ||
                    StatusAgent.status === "Aftercallwork"
                      ? "none"
                      : "",
                  position: "relative",
                }}
                onDragEnter={(e) => {
                  e.preventDefault();
                  this.dragCounter++;
                  if (this.state.isDragging === false) {
                    this.setState({
                      isDragging: true,
                    });
                  }
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  this.dragCounter--;
                  if (this.dragCounter === 0) {
                    this.setState({
                      isDragging: false,
                    });
                  }
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  this.removeImageSplit();
                  this.dragCounter = 0;
                  if (this.state.isDragging) {
                    this.setState({
                      isDragging: false,
                    });
                  }

                  const updatedFilesInStage = [...this.state.filesInStage];
                  const indexOfOlderFileOfThisAtt =
                    this.state.filesInStage.findIndex((fileData) => {
                      return (
                        fileData.idAtendimento === ContactId.idatendimento ||
                        parseInt(fileData.idAtendimento) ===
                          parseInt(ContactId.idatendimento)
                      );
                    });
                  const hasAFileToReplace = indexOfOlderFileOfThisAtt !== -1;
                  if (hasAFileToReplace) {
                    updatedFilesInStage.splice(indexOfOlderFileOfThisAtt, 1, {
                      name: e.dataTransfer.files[0].name,
                      file: e.dataTransfer.files[0],
                      isImage:
                        e.dataTransfer.files[0].type.startsWith("image/"),
                      type: e.dataTransfer.files[0].type,
                      idAtendimento: ContactId.idatendimento,
                      id: `${e.dataTransfer.files[0].name}-${
                        ContactId.idatendimento
                      }-${
                        e.dataTransfer.files[0].lastModified
                      }--${Date.now()}-${Math.random()
                        .toString(36)
                        .substring(2, 9)}`,
                      isVideo:
                        e.dataTransfer.files[0].type.startsWith("video/"),
                    });
                  } else {
                    updatedFilesInStage.push({
                      name: e.dataTransfer.files[0].name,
                      file: e.dataTransfer.files[0],
                      isImage:
                        e.dataTransfer.files[0].type.startsWith("image/"),
                      type: e.dataTransfer.files[0].type,
                      idAtendimento: ContactId.idatendimento,
                      id: `${e.dataTransfer.files[0].name}-${
                        ContactId.idatendimento
                      }-${
                        e.dataTransfer.files[0].lastModified
                      }--${Date.now()}-${Math.random()
                        .toString(36)
                        .substring(2, 9)}`,
                      isVideo:
                        e.dataTransfer.files[0].type.startsWith("video/"),
                    });
                  }
                  this.setState({
                    filesInStage: updatedFilesInStage,
                  });

                  // this.handleselectedFileOnDrop(
                  //   e.dataTransfer.files,
                  //   InfoUsers,
                  //   ContactId
                  // );
                }}
              >
                {this.state.mensagensNaoLidasDocliente.length !== 0 && (
                  <div
                    style={{
                      width: "100%",
                      position: "absolute",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      top: "-32px",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: "#455cc7",
                        color: "#ffffff",
                        fontFamily: "'Inter', sans-serif",
                        padding: "5px 10px",
                        borderRadius: "80px",
                        cursor: "pointer",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "113%",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        border: "none",
                      }}
                      onClick={() => {
                        this.scrollDown(false);
                      }}
                    >
                      <MESSAGEICON />
                      <span>{`Você tem mensagens não lidas`}</span>
                    </button>
                  </div>
                )}
                {this.state.isDragging && (
                  <div className="message-box__drop-zone">
                    <div>
                      <IconDropFile />
                    </div>
                    <p>Solte o arquivo para enviar</p>
                  </div>
                )}
                <div className="input-message">
                  <div
                    onKeyPress={this.handleKeyPress}
                    autoComplete="off"
                    type="text"
                    ref={(node) => (this.node = node)}
                    // onInput={e => (valorInput = e.target.innerText)}
                    className="chat-message"
                    id="chat-message"
                    onKeyDown={this.handleKeyDown}
                    spellCheck="true"
                    onKeyUp={(event) =>
                      this.handleOnChange(
                        event,
                        InfoUsers,
                        ContactId,
                        hasFilesInStageArea,
                      )
                    }
                    onPaste={(event) => {
                      const isImage =
                        event.clipboardData.items.length > 0 &&
                        !!event.clipboardData.items[0] &&
                        !!event.clipboardData.items[0].type &&
                        event.clipboardData.items[0].type.indexOf("image") ===
                          0;
                      if (hasFilesInStageArea && isImage) {
                        this.removeFilesFromStageAreaOfThisAtt(ContactId);
                      }
                      this.handleOnChange2(event, InfoUsers, ContactId);
                    }}
                    // onFocus={event =>
                    //   this.handleOnFocus(event)
                    // }
                    contentEditable="true"
                    suppressContentEditableWarning={true}
                  />
                  <a
                    type="submit"
                    className="close-quick close-quick-new"
                    id="button-close-quick"
                    onClick={() => this.cancelQuickAnswer()}
                    style={{
                      marginRight: "22px",
                      display: this.state.editableQuickAnswer
                        ? "block"
                        : "none",
                    }}
                  >
                    <i className="material-icons">close</i>
                  </a>

                  <div
                    className={
                      this.state.record ? "actions-chat" : "actions-chat active"
                    }
                  >
                    <div
                      className="content-emoji-popover"
                      contentEditable="true"
                      suppressContentEditableWarning={true}
                    >
                      {(() => {
                        if (emoji === true) {
                          return (
                            <Popover
                              trigger="click"
                              interactive={true}
                              content={this.renderPopover4(this)}
                            >
                              <div
                                className="emoji-container tippy-context-menu tippy-default"
                                data-template="emoji-container"
                              >
                                <ICONEMOJI />
                              </div>
                            </Popover>
                          );
                        }
                      })()}
                    </div>
                    <Tooltippy content={"Mensagens Predefinidas"}>
                      <button
                        onClick={this.DisplayQuickAnswer.bind(this)}
                        className="btn action"
                        id="action-premade-messages"
                        data-tippy="Mensagens predefinidas"
                      >
                        <IconMessagePreset />
                      </button>
                    </Tooltippy>
                    <div
                      className={
                        this.state.buttonQuickAnswer
                          ? "premade-msg active"
                          : "premade-msg"
                      }
                    >
                      <p className="premade-msg__title">
                        Mensagens Predefinidas
                      </p>
                      <div className="premade-msg__content">
                        <ul className="premade-msg__list">
                          {this.state.respostas.map((resp) => (
                            <li
                              key={resp.qck_asw_id}
                              className="premade-msg__item"
                              onClick={(event) =>
                                this.InsertQuickAnswer(
                                  event,
                                  convertUnicodeEmoji(resp.qck_asw_answer),
                                  resp.editable,
                                  resp.mimetypeid,
                                  resp.filepath,
                                  InfoUsers,
                                  ContactId,
                                  resp,
                                )
                              }
                            >
                              {resp.qck_asw_keyword}
                            </li>
                          ))}
                        </ul>
                        <div className="premade-msg__input-wrapper">
                          <input
                            type="text"
                            className="premade-msg__search-input"
                            id="input-msgs-rapidas"
                            value={this.state.searchQuickMsg}
                            onChange={(event) =>
                              this.filterList(
                                event,
                                this.state.respostasinicial,
                              )
                            }
                            placeholder="Pesquise uma resposta..."
                          />
                          <span className="premade-msg__input-icon">
                            <i className="material-icons">search</i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <Tooltippy content={"Adicionar Anexo"}>
                      <button
                        className="btn action"
                        id="action-attachment"
                        data-tippy="Adicionar Anexo"
                      >
                        <label className="upload-input" htmlFor="file-input">
                          <IconUploadFile />
                        </label>
                        <input
                          style={{ display: "none" }}
                          type="file"
                          name="upload"
                          multiple
                          id="file-input"
                          onChange={(event) =>
                            this.handleselectedFile(event, InfoUsers, ContactId)
                          }
                        />
                      </button>
                    </Tooltippy>
                    <Tooltippy content={"Enviar Áudio"}>
                      <button
                        onClick={this.start}
                        disabled={disabledAudio}
                        className="btn action"
                        id="action-voice"
                        data-tippy="Atender em voz"
                      >
                        <IconAudio />
                      </button>
                    </Tooltippy>
                  </div>
                  <div
                    className={
                      this.state.record ? "active-voice active" : "active-voice"
                    }
                  >
                    {this.state.record === true &&
                    !this.state.isStartingRecord ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          minWidth: "max-content",
                        }}
                      >
                        <span>Iniciando gravação, aguarde...</span>
                        <Box sx={{ display: "flex" }}>
                          <CircularProgress />
                        </Box>
                      </div>
                    ) : (
                      <div className="active-voice active">
                        <a onClick={this.stop} className="cancel">
                          <i className="material-icons">close</i>
                        </a>

                        <div className="active-chats__timer active-chats__timer--active-voice">
                          {this.state.record === true &&
                            this.state.isStartingRecord && (
                              <>
                                <span className="active-chats__timer-icon active-chats__timer--active-voice-icon alta">
                                  •
                                </span>
                                <TimeCounterAudio
                                  horario={this.state.timerecording}
                                />
                              </>
                            )}
                        </div>

                        <a onClick={this.stopIn} className="done">
                          <i className="material-icons">done</i>
                        </a>
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    onClick={(event) => {
                      if (hasFilesInStageArea) {
                        this.sendFileFromStageArea(ContactId, InfoUsers);
                      } else {
                        this.ButtonSendMessage(
                          event,
                          "Me",
                          InfoUsers,
                          ContactId,
                          "0",
                        );
                      }
                    }}
                    className="send-message"
                    id="button-send-message"
                  >
                    {/* <i className="material-icons">send</i> */}
                    <IconSend />
                  </button>
                </div>
              </div>
            </div>
            <div className="block-forward">
              <div className="block-forward__text">
                {this.state.forwardMsgList.length} Mensagem
                selecionada&#x28;s&#x29;{" "}
                <i
                  onClick={this.handleCloseEncaminhar}
                  className="material-icons close-encaminhar"
                >
                  close
                </i>
              </div>
              <div className="block-forward__link">
                {this.state.forwardMsgList.length > 0 && (
                  <a onClick={this.handleForwardClick}>
                    <ForwardIconSVG />
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="block transparent active-chats" id="active-chats">
            <div className="active-chats__tabs">
              <ul className="active-chats__list">
                <ChatSimultComponent
                  chatemcurso={this.state.chat}
                  remotescreen={"attendance"}
                />
              </ul>
            </div>
          </div>
          <QuickAnswer
            message={this.state.messageQuickAnswer}
            variables={this.state.variableQuickAnwser}
            sendTextInputChat={this.sendTextInputChat}
            actionSendMessageClient={this.actionSendMessageClient}
            actionCancelMessageClient={this.actionCancelMessageClient}
            changeVariablesSending={this.changeVariablesSending}
            screen="attendance"
            bind={this}
          />
          <input type="hidden" id="simulation_click" name="simulation_click" />
          <input
            type="hidden"
            onClick={(event) => this.saveVariablesQuick()}
            id="button-save-variables"
            name="button-save-variables"
          />
        </div>
        {RegisterNotifier.filter(
          (register) =>
            register.task !== "2" &&
            register.remote === ContactId.idatendimento,
        ).map((notifier) => (
          <div className="container__new-mail">
            <div className="container__new-mail__icon">
              <IconMail />
            </div>
            <div className="container__new-mail__separator">
              <div className="container__pause-automatic__box">
                {RegisterNotifier.filter(
                  (register) =>
                    register.task !== "2" &&
                    register.remote === ContactId.idatendimento,
                ).length > 1 ? (
                  <strong>
                    {
                      RegisterNotifier.filter(
                        (register) =>
                          register.task !== "2" &&
                          register.remote === ContactId.idatendimento,
                      ).length
                    }{" "}
                    novas mensagens
                  </strong>
                ) : (
                  <strong>Nova mensagem de {ContactId.cliente}</strong>
                )}
                <div className="container__pause-automatic__box-icon"></div>
              </div>
              <div className="container__new-mail__box">
                <span
                  onClick={(event) =>
                    this.showMessageMail(
                      event,
                      notifier.idnotifier,
                      RegisterNotifier.filter(
                        (register) =>
                          register.task !== "2" &&
                          register.remote === ContactId.idatendimento,
                      ),
                    )
                  }
                >
                  Mostrar mensagem
                </span>
                <span
                  onClick={(event) =>
                    this.RemoveNotifierMail(
                      event,
                      notifier.idnotifier,
                      RegisterNotifier.filter(
                        (register) =>
                          register.task !== "2" &&
                          register.remote === ContactId.idatendimento,
                      ),
                    )
                  }
                >
                  Ignorar
                </span>
              </div>
            </div>
          </div>
        ))}
        <QuarantineModal
          onConfirm={() => {
            try {
              this.props.AddCcontactIdsToQuarentine(ContactId);
              sendToQuarentineZone(ContactId, InfoUsers);
            } catch (error) {
              console.log("attendance 10556 error: ", error);
              const hasErrorMessage =
                !!error && !!error.message && typeof error.message === "string";
              if (hasErrorMessage) {
                toast.error(error.message);
              }
            }
          }}
        />
        {this.state.tabulationModalInfos.isOpen && (
          <TabulationModal
            atdInfo={this.state.tabulationModalInfos.data}
            onClose={() => {
              this.setState({
                tabulationModalInfos: { isOpen: false, data: null },
              });
            }}
          />
        )}
        <EndCallModal
          onConfirm={(e) => {
            e.preventDefault();
            this.ByeCall(
              e,
              ContactId,
              InfoUsers,
              AtdSimult,
              Messages,
              "encerramento",
              IPCurrent,
              StatusAgent,
            );
          }}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Attendance);
